const geoJson = {
  type: 'FeatureCollection',
  features: [
    {
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [35.279026031494084, 36.64069366455101],
              [35.28180694580078, 36.6390266418457],
              [35.282917022705135, 36.636806488037166],
              [35.27819442749029, 36.640140533447266],
              [35.279026031494084, 36.64069366455101],
            ],
          ],
          [
            [
              [35.27152633666998, 36.64485931396507],
              [35.274028778076456, 36.64319610595709],
              [35.274028778076456, 36.64208221435558],
              [35.27125167846697, 36.64319610595709],
              [35.27152633666998, 36.64485931396507],
            ],
          ],
          [
            [
              [35.20735931396513, 36.65069580078119],
              [35.2093048095706, 36.64986038208025],
              [35.20958328247099, 36.64930725097685],
              [35.206249237060604, 36.649028778076456],
              [35.20735931396513, 36.65069580078119],
            ],
          ],
          [
            [
              [35.21180725097656, 36.65541839599638],
              [35.212081909179744, 36.65319442749046],
              [35.21152877807634, 36.6529159545899],
              [35.20958328247099, 36.65513992309582],
              [35.21180725097656, 36.65541839599638],
            ],
          ],
          [
            [
              [35.21347045898466, 36.659862518310774],
              [35.21402740478527, 36.65874862670927],
              [35.21069335937517, 36.65902709960943],
              [35.21097183227556, 36.659862518310774],
              [35.21347045898466, 36.659862518310774],
            ],
          ],
          [
            [
              [35.20958328247099, 36.67874908447283],
              [35.212360382080135, 36.677639007568644],
              [35.212360382080135, 36.67680740356468],
              [35.20847320556646, 36.6781959533692],
              [35.20958328247099, 36.67874908447283],
            ],
          ],
          [
            [
              [35.5912513732913, 36.704029083252124],
              [35.5915260314942, 36.6995849609375],
              [35.59069442749018, 36.6995849609375],
              [35.589862823486385, 36.70319366455078],
              [35.5912513732913, 36.704029083252124],
            ],
          ],
          [
            [
              [35.60680389404291, 36.70541763305687],
              [35.60625076293951, 36.700973510742415],
              [35.6012496948245, 36.70019912719721],
              [35.60514068603533, 36.70541763305687],
              [35.60680389404291, 36.70541763305687],
            ],
          ],
          [
            [
              [35.68264007568365, 36.716251373291016],
              [35.67958450317383, 36.71263885498075],
              [35.67736053466825, 36.7140274047851],
              [35.680973052978516, 36.716251373291016],
              [35.68264007568365, 36.716251373291016],
            ],
          ],
          [
            [
              [35.69708251953142, 36.72735977172874],
              [35.70291519165045, 36.724304199219034],
              [35.70291519165045, 36.72347259521507],
              [35.69736099243181, 36.72375106811546],
              [35.69708251953142, 36.72735977172874],
            ],
          ],
          [
            [
              [36.329639434814624, 37.92000961303711],
              [36.31517028808622, 37.88559722900396],
              [36.31903839111345, 37.83251953125],
              [36.36219787597662, 37.75340270996094],
              [36.302368164062614, 37.651248931884936],
              [36.153835296630916, 37.63694381713884],
              [36.033290863037166, 37.57089233398443],
              [35.88317108154325, 37.35688018798834],
              [35.881771087646484, 37.241584777832145],
              [35.904296875000114, 37.20827102661144],
              [35.85282516479492, 37.12870788574219],
              [35.87482452392595, 37.121696472168026],
              [36.000972747802734, 37.17415237426786],
              [36.03230667114258, 37.15906143188488],
              [36.061447143554744, 37.108856201171875],
              [36.04160690307617, 37.025554656982536],
              [35.94699859619146, 36.95690536499052],
              [35.91258621215826, 36.90350723266613],
              [35.93404769897478, 36.87985992431646],
              [35.84180450439453, 36.795139312744254],
              [35.7945823669433, 36.765693664551065],
              [35.666805267333984, 36.76708221435547],
              [35.6270828247072, 36.74569320678734],
              [35.60930633544939, 36.71430587768549],
              [35.61291503906244, 36.73208236694336],
              [35.60319519042969, 36.727085113525334],
              [35.5995826721192, 36.69985961914091],
              [35.5915260314942, 36.71097183227562],
              [35.563194274902344, 36.71263885498075],
              [35.55430603027372, 36.6995849609375],
              [35.570137023926065, 36.70652770996122],
              [35.584583282470646, 36.67958450317394],
              [35.6295814514163, 36.721527099609375],
              [35.62430572509794, 36.733749389648665],
              [35.654304504394474, 36.739860534668026],
              [35.64541625976568, 36.70763778686518],
              [35.65680694580095, 36.72902679443365],
              [35.65402603149414, 36.70791625976557],
              [35.70652770996122, 36.71319580078131],
              [35.704303741455135, 36.72319412231468],
              [35.7234725952149, 36.71263885498075],
              [35.64513778686529, 36.66847229003906],
              [35.62180709838884, 36.604305267334155],
              [35.581806182861385, 36.59069442749052],
              [35.565971374512, 36.56486129760748],
              [35.41819381713873, 36.590137481689396],
              [35.339027404785156, 36.538471221924],
              [35.329582214355526, 36.56791687011713],
              [35.32208251953142, 36.572360992431754],
              [35.34624862670904, 36.60347366333036],
              [35.285137176513615, 36.62680435180664],
              [35.28791809082048, 36.64347076416033],
              [35.27097320556658, 36.65208435058611],
              [35.2640266418457, 36.639305114746264],
              [35.24902725219738, 36.654026031494254],
              [35.27152633666998, 36.66180419921875],
              [35.25097274780302, 36.6781959533692],
              [35.18069458007841, 36.69291687011719],
              [35.163471221924, 36.67597198486351],
              [35.17597198486345, 36.66152954101574],
              [35.273471832275675, 36.60874938964861],
              [35.3245849609375, 36.55875015258812],
              [34.997917175293026, 36.713470458984546],
              [34.91521453857422, 36.724861145019645],
              [34.949817657470646, 36.7540168762207],
              [35.034801483154354, 36.770996093750284],
              [35.06715011596697, 36.81790924072271],
              [35.06958389282255, 36.8526496887207],
              [35.05463027954107, 36.97039413452154],
              [35.00078582763683, 37.041458129882926],
              [34.92519378662115, 37.0896911621096],
              [34.90010833740263, 37.17629623413086],
              [34.78625869750982, 37.379280090332145],
              [34.78827667236334, 37.465160369873104],
              [34.860763549804744, 37.525032043456974],
              [34.85847854614258, 37.57877349853527],
              [34.81658554077154, 37.65838241577154],
              [34.826660156250284, 37.684917449951286],
              [34.86949157714844, 37.71004486083979],
              [35.02579116821306, 37.69889450073242],
              [35.08160018920927, 37.718662261963004],
              [35.21365356445324, 37.83214187622076],
              [35.20755767822294, 37.91330337524414],
              [35.24167633056646, 37.95356369018572],
              [35.45680999755865, 37.91956710815424],
              [35.621017456054744, 37.95576095581066],
              [35.680976867676065, 38.05966186523432],
              [36.01338195800787, 38.185642242431584],
              [36.161430358887, 38.4135093688966],
              [36.30536651611334, 38.463748931884766],
              [36.37761306762707, 38.46636962890625],
              [36.42207336425781, 38.442195892333984],
              [36.49144363403326, 38.31632614135742],
              [36.42615890502947, 38.25278854370117],
              [36.33535766601574, 37.99667358398449],
              [36.329639434814624, 37.92000961303711],
            ],
          ],
        ],
      },
      properties: {
        name: 'Adana',
        label: {
          lat: 37.47316758107313,
          lng: 35.22990927566686,
        },
      },
      id: 1,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [38.65533828735357, 38.09172439575201],
            [38.85887527465832, 38.09242630004883],
            [39.00511550903326, 38.11749267578125],
            [39.074615478515796, 38.14497375488281],
            [39.11173629760748, 38.18469238281273],
            [39.160182952880916, 38.17333602905296],
            [39.20501708984369, 38.19129943847656],
            [39.24630737304693, 38.16666030883812],
            [39.210086822509766, 38.05253982543945],
            [39.073436737060604, 37.99180603027361],
            [38.99199676513689, 37.91375732421875],
            [38.976436614990234, 37.88441848754894],
            [38.97814941406256, 37.795402526855696],
            [38.95181274414068, 37.74911117553711],
            [38.83071136474615, 37.69311904907238],
            [38.83985519409174, 37.658622741699276],
            [38.8294410705567, 37.6424446105957],
            [38.615886688232536, 37.57777023315424],
            [38.47832489013666, 37.48891067504883],
            [38.330547332763786, 37.48437881469732],
            [38.15669631958025, 37.406925201416016],
            [38.06077194213867, 37.4311904907226],
            [37.98249435424833, 37.496170043945426],
            [37.7957878112793, 37.5446510314942],
            [37.679069519043026, 37.512031555175895],
            [37.62296295166021, 37.51213455200224],
            [37.5731277465822, 37.55051803588867],
            [37.45948791503912, 37.58237457275396],
            [37.416450500488395, 37.61639785766624],
            [37.422187805176065, 37.703323364257926],
            [37.59421539306652, 37.82491683959972],
            [37.73728942871122, 37.83412933349632],
            [37.76950454711931, 37.86634826660179],
            [37.83566284179693, 37.882831573486385],
            [37.980312347412166, 37.860988616943644],
            [38.18105316162115, 37.91896057128906],
            [38.13481521606451, 38.089435577392635],
            [38.39860153198248, 38.19963455200201],
            [38.5370826721192, 38.23062896728521],
            [38.634452819824276, 38.19916915893566],
            [38.62433242797846, 38.169216156006144],
            [38.562923431396484, 38.12447357177746],
            [38.65533828735357, 38.09172439575201],
          ],
        ],
      },
      properties: {
        name: 'Adıyaman',
        label: {
          lat: 37.74696624784911,
          lng: 37.996248866347294,
        },
      },
      id: 2,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.362766265869197, 39.16468429565424],
            [31.386358261108683, 39.11867141723644],
            [31.4598522186281, 39.088176727295206],
            [31.696891784668253, 39.09305953979515],
            [31.708700180053995, 38.95373535156273],
            [31.6233043670656, 38.817733764648665],
            [31.58945655822771, 38.72563552856445],
            [31.6107826232913, 38.67497253417963],
            [31.679281234741325, 38.63260269165045],
            [31.260772705078296, 38.427665710449276],
            [31.20930480957037, 38.439853668213004],
            [31.12550926208496, 38.51361846923828],
            [31.088424682617244, 38.5123291015625],
            [30.799964904785327, 38.2902374267581],
            [30.640510559082202, 38.245807647705135],
            [30.517358779907283, 38.18640518188471],
            [30.366300582886026, 38.07125473022461],
            [30.265552520752237, 38.016117095947266],
            [30.22363090515165, 37.98092269897472],
            [30.18260765075712, 37.9011611938476],
            [30.19958305358915, 37.84968566894531],
            [30.167104721069393, 37.81391525268555],
            [30.09053611755371, 37.776737213134766],
            [29.966999053955135, 37.78396606445335],
            [29.845273971557788, 37.76081848144531],
            [29.81536865234392, 37.81905364990257],
            [29.72046852111822, 37.852550506591854],
            [29.663770675659237, 37.852550506591854],
            [29.665998458862475, 37.98868942260748],
            [29.924520492553825, 38.10348129272478],
            [30.020292282104776, 38.17622375488281],
            [30.041278839111328, 38.22135543823259],
            [30.03680038452154, 38.251564025878906],
            [29.922199249267862, 38.41290664672874],
            [29.755413055419922, 38.45410919189453],
            [29.77183532714872, 38.50595855712919],
            [29.87275886535673, 38.64421844482433],
            [29.894367218017862, 38.70968246459984],
            [30.074789047241268, 38.78848648071295],
            [30.115364074706974, 38.820873260498104],
            [30.27036857605009, 39.08821105957054],
            [30.384635925293253, 39.12631988525396],
            [30.43370437622076, 39.16427230834972],
            [30.45332908630388, 39.20599746704107],
            [30.50550842285162, 39.189422607421875],
            [30.542961120605753, 39.13069152832031],
            [30.6117458343507, 39.07914733886719],
            [30.639776229858512, 39.076957702636946],
            [30.766630172729776, 39.12854385375999],
            [30.799478530883846, 39.172389984130916],
            [30.885963439941577, 39.21287155151373],
            [30.989156723022518, 39.15921020507824],
            [31.141860961914347, 39.218502044677734],
            [31.24177551269537, 39.28451919555664],
            [31.30526924133318, 39.273185729980526],
            [31.362766265869197, 39.16468429565424],
          ],
        ],
      },
      properties: {
        name: 'Afyon',
        label: {
          lat: 38.71367944513601,
          lng: 30.507422229611695,
        },
      },
      id: 3,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [43.39566040039057, 39.925796508789176],
            [43.39422988891596, 39.79460525512701],
            [43.456417083740234, 39.767475128173885],
            [43.47832870483427, 39.766723632812614],
            [43.5319442749024, 39.820419311523494],
            [43.62248992919939, 39.82235717773443],
            [43.74055480957048, 39.79948043823242],
            [43.999706268310604, 39.68526458740246],
            [44.15977859497082, 39.69419860839855],
            [44.23257827758795, 39.671707153320426],
            [44.3003501892091, 39.67086791992193],
            [44.380176544189624, 39.69319534301769],
            [44.49647140502958, 39.69598007202171],
            [44.489604949951456, 39.630126953125114],
            [44.43618774414068, 39.560661315918196],
            [44.45337677001959, 39.50155639648449],
            [44.4333610534668, 39.47306823730469],
            [44.441123962402514, 39.435874938964844],
            [44.423660278320426, 39.4098014831543],
            [44.30173492431646, 39.3714714050293],
            [44.22431182861334, 39.41028976440441],
            [44.17476272583025, 39.40239334106445],
            [44.1518440246582, 39.377182006835994],
            [44.138137817382926, 39.37977981567394],
            [44.143608093261776, 39.400177001953125],
            [44.069816589355526, 39.40531921386719],
            [44.04974365234392, 39.360752105712834],
            [44.03281784057617, 39.37202072143555],
            [43.96207427978521, 39.35651016235363],
            [43.716354370117244, 39.37020492553734],
            [43.64554214477545, 39.302429199218864],
            [43.5928192138673, 39.287895202636946],
            [43.494350433349894, 39.327377319336165],
            [43.42657852172857, 39.38888549804682],
            [43.293762207031534, 39.40276336669933],
            [43.19167327880865, 39.32806777954107],
            [43.10197830200224, 39.32246017456055],
            [43.07938003540056, 39.30751419067394],
            [43.08466720581049, 39.284191131592024],
            [43.166938781738565, 39.23722457885742],
            [43.16763305664068, 39.16597366333019],
            [43.14973449707037, 39.139167785644645],
            [42.97164154052763, 39.08096313476585],
            [42.827857971191406, 39.06509017944347],
            [42.749843597412166, 39.03714752197277],
            [42.72988891601568, 39.159004211425895],
            [42.672210693359375, 39.24966812133812],
            [42.62761688232439, 39.27266311645508],
            [42.516819000244425, 39.37535095214838],
            [42.466396331787166, 39.46373367309599],
            [42.463413238525675, 39.48609924316412],
            [42.523639678955135, 39.56861877441406],
            [42.50621795654325, 39.72973632812494],
            [42.474822998047046, 39.76498413085949],
            [42.285240173340014, 39.81406784057623],
            [42.25519943237322, 39.861167907714844],
            [42.2776527404788, 39.88196563720703],
            [42.40620422363287, 39.873390197753906],
            [42.566364288330135, 39.94755172729515],
            [42.638339996337834, 39.91758728027372],
            [42.7108917236331, 39.91766357421875],
            [43.10322189331072, 40.00832748413086],
            [43.3728103637697, 39.960422515869084],
            [43.39566040039057, 39.925796508789176],
          ],
        ],
      },
      properties: {
        name: 'Ağrı',
        label: {
          lat: 39.63478918156396,
          lng: 43.02495183828307,
        },
      },
      id: 4,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [34.2052116394043, 38.84115219116222],
            [34.26256942749052, 38.793670654296875],
            [34.205261230469034, 38.67776489257818],
            [34.273029327392635, 38.62049484252958],
            [34.348003387451286, 38.473419189453125],
            [34.394397735595646, 38.43891906738287],
            [34.36829757690447, 38.36765289306652],
            [34.36320114135748, 38.2909202575683],
            [34.39450073242182, 38.24264526367193],
            [34.38952255249029, 38.16189575195307],
            [34.32982254028326, 38.13497161865246],
            [34.26839065551758, 38.05600738525402],
            [34.18675994873075, 38.070056915283146],
            [34.14690780639654, 38.05195236206055],
            [34.12569427490246, 38.01376342773443],
            [33.77833557128912, 37.95623016357433],
            [33.495018005371264, 37.93255615234381],
            [33.41340637207048, 37.95118713378906],
            [33.3625679016115, 38.00362014770519],
            [33.240116119384936, 38.21535110473644],
            [33.242633819580135, 38.25516128540062],
            [33.30143737792986, 38.347045898437614],
            [33.318119049072436, 38.42950057983421],
            [33.38059997558611, 38.562381744384766],
            [33.465042114257756, 38.63647079467779],
            [33.68149948120117, 38.711006164550895],
            [33.82563781738287, 38.714866638183594],
            [33.923976898193416, 38.78068542480486],
            [33.94691085815458, 38.829227447509936],
            [33.8883056640625, 38.954170227050895],
            [33.9267005920413, 39.008110046386776],
            [34.07765579223633, 38.90355300903332],
            [34.17686462402338, 38.88210296630854],
            [34.2052116394043, 38.84115219116222],
          ],
        ],
      },
      properties: {
        name: 'Aksaray',
        label: {
          lat: 38.39409893905368,
          lng: 33.65797386109001,
        },
      },
      id: 68,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [35.7025527954101, 40.877315521240234],
            [35.840560913085994, 40.86432647705101],
            [35.955291748046875, 40.87558364868164],
            [36.06103515625006, 40.84314727783226],
            [36.18094253540045, 40.90474319458019],
            [36.20392608642584, 40.98003387451172],
            [36.25976181030302, 40.979282379150504],
            [36.372375488281534, 40.952079772949276],
            [36.37617874145525, 40.90769958496105],
            [36.4480056762697, 40.86983108520536],
            [36.41676330566412, 40.82258224487305],
            [36.45636749267595, 40.770137786865234],
            [36.472808837890625, 40.707481384277344],
            [36.44152450561552, 40.63232803344738],
            [36.32520294189459, 40.523677825927734],
            [36.20240020751959, 40.45898437500006],
            [36.1100692749024, 40.44609451293945],
            [36.03977584838873, 40.45986938476557],
            [35.95844650268555, 40.50232696533209],
            [35.84466171264654, 40.501518249511776],
            [35.71618652343756, 40.32625579834007],
            [35.5763778686524, 40.27421951293945],
            [35.529628753662394, 40.235530853271484],
            [35.51206970214861, 40.189777374267635],
            [35.37136840820318, 40.195156097412166],
            [35.33233642578119, 40.228908538818416],
            [35.343681335449276, 40.35832595825195],
            [35.448406219482365, 40.46772384643566],
            [35.46423721313471, 40.5735321044923],
            [35.42771530151373, 40.615207672119254],
            [35.25703811645519, 40.666099548340014],
            [35.15071868896513, 40.67067337036144],
            [35.082084655762, 40.71263122558594],
            [35.02510070800798, 40.843399047851676],
            [35.04604339599604, 40.852909088134766],
            [35.04957199096674, 40.95141220092779],
            [35.09133148193365, 41.03227615356468],
            [35.093154907226506, 41.09054183959961],
            [35.48538970947271, 41.012321472168026],
            [35.643894195556925, 40.92682647705078],
            [35.66569137573259, 40.89455795288109],
            [35.7025527954101, 40.877315521240234],
          ],
        ],
      },
      properties: {
        name: 'Amasya',
        label: {
          lat: 40.71813764864346,
          lng: 35.545387287609074,
        },
      },
      id: 5,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [33.187957763672046, 40.41364669799805],
            [33.22098541259771, 40.351249694824446],
            [33.2674293518067, 40.331134796142805],
            [33.330764770507756, 40.33474349975609],
            [33.364143371581974, 40.38593292236334],
            [33.40986251831072, 40.38897705078125],
            [33.72912216186518, 40.27840805053711],
            [33.652736663818416, 40.201866149902344],
            [33.57646942138689, 40.048053741455135],
            [33.61725234985357, 39.966354370117415],
            [33.616443634033374, 39.91255950927757],
            [33.59539413452177, 39.884044647217024],
            [33.43414688110357, 39.81398773193371],
            [33.356254577636776, 39.751121520996094],
            [33.31986618041992, 39.64878463745117],
            [33.317638397216854, 39.574645996094034],
            [33.2855339050293, 39.46186065673851],
            [33.23331832885748, 39.37669372558594],
            [33.28668594360357, 39.33038711547863],
            [33.36938476562506, 39.317165374755916],
            [33.390270233154354, 39.27744674682617],
            [33.36560821533209, 39.22562789917015],
            [33.41689682006836, 39.16110992431652],
            [33.52802276611345, 39.2547988891601],
            [33.59801483154314, 39.17142486572277],
            [33.942905426025675, 39.03599166870117],
            [33.8883056640625, 38.954170227050895],
            [33.946762084960994, 38.81260299682617],
            [33.923976898193416, 38.78068542480486],
            [33.82899475097673, 38.716121673584155],
            [33.68149948120117, 38.711006164550895],
            [33.465042114257756, 38.63647079467779],
            [33.36212921142584, 38.791782379150504],
            [33.37403869628935, 39.037906646728516],
            [33.18780136108427, 39.276828765869084],
            [33.115245819091854, 39.22088241577154],
            [33.05522155761719, 39.218933105468864],
            [33.021648406982706, 39.15932846069347],
            [32.96263122558622, 39.126510620117244],
            [32.89254760742193, 39.154331207275504],
            [32.83474731445318, 39.15232849121105],
            [32.742153167724666, 39.082061767578125],
            [32.70268630981451, 39.03284835815441],
            [32.5559196472168, 39.04980850219738],
            [32.46858978271496, 38.99460601806652],
            [32.2944526672365, 39.06810379028326],
            [32.129978179931925, 39.0306282043457],
            [32.083663940429744, 39.04292297363281],
            [31.883207321167276, 39.173801422119254],
            [31.99277877807623, 39.22740173339844],
            [32.011322021484546, 39.38178634643572],
            [31.99344062805193, 39.50458908081055],
            [31.907976150512866, 39.613700866699276],
            [31.849052429199276, 39.730388641357536],
            [31.847255706787166, 39.76829147338873],
            [31.88599014282238, 39.808479309082145],
            [31.857683181762752, 39.87451553344749],
            [31.797164916992244, 39.8831901550293],
            [31.695951461791992, 39.98823165893566],
            [31.617036819458292, 40.01634979248058],
            [31.175989151001033, 40.04402542114258],
            [31.02343177795416, 40.019157409668026],
            [30.94405746459978, 40.02215957641607],
            [30.919401168823356, 40.035682678222656],
            [30.913637161254826, 40.0991401672365],
            [30.873971939086914, 40.14034652709961],
            [30.955003738403605, 40.22293853759777],
            [31.047548294067383, 40.2725639343264],
            [31.037288665771484, 40.37631988525385],
            [31.06073379516596, 40.41575241088867],
            [31.14426994323742, 40.39905548095703],
            [31.26392936706543, 40.346771240234375],
            [31.566928863525675, 40.30855178833008],
            [31.705093383789347, 40.34394454956066],
            [31.79364585876482, 40.33181762695318],
            [31.9033527374267, 40.34561157226557],
            [32.14555358886719, 40.424667358398494],
            [32.37283325195318, 40.4155387878418],
            [32.47593688964861, 40.5302276611331],
            [32.430423736572266, 40.65179443359392],
            [32.50134658813505, 40.704257965088004],
            [32.65491485595709, 40.702560424804744],
            [32.955661773681925, 40.59830474853527],
            [33.187957763672046, 40.41364669799805],
          ],
        ],
      },
      properties: {
        name: 'Ankara',
        label: {
          lat: 39.93164888262017,
          lng: 32.47361032870717,
        },
      },
      id: 6,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [29.63902854919462, 36.12125015258795],
              [29.645696640014933, 36.11569595336937],
              [29.62791633605974, 36.10763931274414],
              [29.62874984741228, 36.11125183105497],
              [29.63902854919462, 36.12125015258795],
            ],
          ],
          [
            [
              [29.662639617920206, 36.1365318298341],
              [29.660417556762752, 36.13013839721697],
              [29.654581069946573, 36.132915496826286],
              [29.65486145019537, 36.13430404663103],
              [29.662639617920206, 36.1365318298341],
            ],
          ],
          [
            [
              [29.755695343017862, 36.141250610351506],
              [29.76625061035162, 36.13152694702171],
              [29.738750457763615, 36.12263870239269],
              [29.740415573120174, 36.127082824707315],
              [29.755695343017862, 36.141250610351506],
            ],
          ],
          [
            [
              [29.655416488647745, 36.144306182861555],
              [29.656250000000284, 36.14291763305681],
              [29.65319442749029, 36.141250610351506],
              [29.65319442749029, 36.14347076416021],
              [29.655416488647745, 36.144306182861555],
            ],
          ],
          [
            [
              [29.624584197998104, 36.153472900390796],
              [29.62791633605974, 36.15152740478544],
              [29.62180519104021, 36.15069580078148],
              [29.62208366394043, 36.15236282348644],
              [29.624584197998104, 36.153472900390796],
            ],
          ],
          [
            [
              [29.632085800170955, 36.153472900390796],
              [29.632360458374308, 36.15208435058605],
              [29.62874984741228, 36.15152740478544],
              [29.62902832031267, 36.15236282348644],
              [29.632085800170955, 36.153472900390796],
            ],
          ],
          [
            [
              [29.49208259582514, 36.16041564941429],
              [29.494581222534237, 36.15708160400385],
              [29.496528625488338, 36.159584045410156],
              [29.51736068725603, 36.15708160400385],
              [29.48624992370634, 36.15069580078148],
              [29.49208259582514, 36.16041564941429],
            ],
          ],
          [
            [
              [29.626806259155558, 36.16263961791998],
              [29.627082824706974, 36.16097259521507],
              [29.62486076354986, 36.15986251831072],
              [29.624027252197322, 36.162082672119425],
              [29.626806259155558, 36.16263961791998],
            ],
          ],
          [
            [
              [29.629304885864315, 36.16347122192377],
              [29.630138397216854, 36.162361145019815],
              [29.629583358764705, 36.16041564941429],
              [29.62791633605974, 36.161529541015625],
              [29.629304885864315, 36.16347122192377],
            ],
          ],
          [
            [
              [29.592914581298885, 36.16652679443382],
              [29.589860916137752, 36.149860382080135],
              [29.60708427429205, 36.144584655761946],
              [29.559305191040096, 36.120971679687784],
              [29.592914581298885, 36.16652679443382],
            ],
          ],
          [
            [
              [29.872915267944506, 36.1690292358399],
              [29.873472213745117, 36.167640686035384],
              [29.870693206787394, 36.16624832153343],
              [29.871250152587947, 36.16875076293974],
              [29.872915267944506, 36.1690292358399],
            ],
          ],
          [
            [
              [29.836805343628214, 36.17124938964844],
              [29.838193893432788, 36.168193817138786],
              [29.836250305175838, 36.16708374023443],
              [29.83402633666998, 36.1690292358399],
              [29.836805343628214, 36.17124938964844],
            ],
          ],
          [
            [
              [29.833196640014933, 36.16930389404314],
              [29.83263969421381, 36.17124938964844],
              [29.836250305175838, 36.17208480834961],
              [29.835971832275504, 36.17124938964844],
              [29.833196640014933, 36.16930389404314],
            ],
          ],
          [
            [
              [29.54847145080572, 36.18708419799816],
              [29.551807403564737, 36.18402862548828],
              [29.551807403564737, 36.18291854858393],
              [29.545972824096623, 36.18458175659208],
              [29.54847145080572, 36.18708419799816],
            ],
          ],
          [
            [
              [29.91263961791998, 36.19152832031256],
              [29.912361145019645, 36.188194274902344],
              [29.910417556762866, 36.188194274902344],
              [29.909860610961914, 36.1893043518067],
              [29.91263961791998, 36.19152832031256],
            ],
          ],
          [
            [
              [30.407638549804744, 36.19208145141596],
              [30.409025192261026, 36.179584503174055],
              [30.406806945800724, 36.1754150390625],
              [30.402639389038143, 36.190971374512],
              [30.407638549804744, 36.19208145141596],
            ],
          ],
          [
            [
              [29.91486167907715, 36.19763946533209],
              [29.881250381469727, 36.1690292358399],
              [29.881805419921932, 36.17680740356457],
              [29.84069442749029, 36.1690292358399],
              [29.91486167907715, 36.19763946533209],
            ],
          ],
          [
            [
              [30.405416488647404, 36.202915191650504],
              [30.4029159545899, 36.19680404663097],
              [30.399305343628214, 36.19763946533209],
              [30.401805877685717, 36.2023620605471],
              [30.405416488647404, 36.202915191650504],
            ],
          ],
          [
            [
              [29.439306259155558, 36.20458221435564],
              [29.437084197998104, 36.199306488037394],
              [29.43541717529314, 36.19902801513683],
              [29.434860229492358, 36.203472137451456],
              [29.439306259155558, 36.20458221435564],
            ],
          ],
          [
            [
              [29.899305343627987, 36.20652770996111],
              [29.903747558593807, 36.20375061035185],
              [29.90263938903803, 36.20124816894554],
              [29.899026870727596, 36.20264053344749],
              [29.899305343627987, 36.20652770996111],
            ],
          ],
          [
            [
              [29.90736007690424, 36.21291732788103],
              [29.90263938903803, 36.20680618286133],
              [29.89486122131359, 36.209304809570426],
              [29.897361755371094, 36.211528778076115],
              [29.90736007690424, 36.21291732788103],
            ],
          ],
          [
            [
              [29.36541748046892, 36.218193054199446],
              [29.351528167724894, 36.21014022827177],
              [29.3462505340579, 36.208751678467024],
              [29.347360610962085, 36.214027404785384],
              [29.36541748046892, 36.218193054199446],
            ],
          ],
          [
            [
              [29.37402725219755, 36.22458267211937],
              [29.37347030639677, 36.219860076904354],
              [29.367639541626033, 36.220695495605696],
              [29.36902809143095, 36.22402954101557],
              [29.37402725219755, 36.22458267211937],
            ],
          ],
          [
            [
              [30.472917556762752, 36.240695953369425],
              [30.4809703826906, 36.232082366943644],
              [30.479583740234432, 36.23014068603533],
              [30.46986389160162, 36.23680496215843],
              [30.472917556762752, 36.240695953369425],
            ],
          ],
          [
            [
              [30.1443061828615, 36.26541519165062],
              [30.14291572570818, 36.26374816894548],
              [30.139862060546932, 36.264862060547046],
              [30.139862060546932, 36.26541519165062],
              [30.1443061828615, 36.26541519165062],
            ],
          ],
          [
            [
              [30.55347251892107, 36.460971832275504],
              [30.554027557373104, 36.457359313964844],
              [30.547082901001147, 36.457359313964844],
              [30.550693511963175, 36.460971832275504],
              [30.55347251892107, 36.460971832275504],
            ],
          ],
          [
            [
              [31.663749694824162, 36.64764022827154],
              [31.664306640625284, 36.645973205566406],
              [31.66124916076666, 36.64708328247093],
              [31.66124916076666, 36.64764022827154],
              [31.663749694824162, 36.64764022827154],
            ],
          ],
          [
            [
              [30.589305877685547, 36.80430603027344],
              [30.5904159545899, 36.803195953369084],
              [30.5904159545899, 36.800693511963175],
              [30.58791732788086, 36.80208206176758],
              [30.589305877685547, 36.80430603027344],
            ],
          ],
          [
            [
              [31.449348449707315, 37.344013214111385],
              [31.727830886840934, 37.32756423950195],
              [31.846702575683764, 37.28829956054699],
              [32.23294830322283, 37.00030899047857],
              [32.29104614257841, 36.85093307495117],
              [32.42606353759777, 36.82072830200207],
              [32.47058486938482, 36.7511253356933],
              [32.45649719238298, 36.674057006835994],
              [32.50381469726568, 36.561042785644645],
              [32.55423355102556, 36.5082168579101],
              [32.65814208984381, 36.446079254150504],
              [32.63582229614252, 36.38359451293945],
              [32.64662170410156, 36.28344345092768],
              [32.58005905151373, 36.11024856567377],
              [32.534862518310604, 36.092082977295036],
              [32.48791503906244, 36.109027862549055],
              [32.295417785644815, 36.2343063354495],
              [32.274860382080135, 36.28902816772461],
              [32.215972900390796, 36.33569335937506],
              [32.165973663330135, 36.417083740234375],
              [32.02958297729498, 36.53819274902344],
              [32.00569534301775, 36.542915344238565],
              [32.00041580200201, 36.53041839599615],
              [31.985696792602653, 36.52736282348644],
              [31.96875, 36.55597305297863],
              [31.774583816528605, 36.604026794433594],
              [31.7459716796875, 36.63819503784191],
              [31.672082901001033, 36.64402770996088],
              [31.561250686645565, 36.71180725097679],
              [31.386249542236385, 36.76402664184576],
              [31.38708305358915, 36.780693054199446],
              [31.329584121704386, 36.80930709838884],
              [31.00652694702177, 36.85819625854498],
              [30.757360458374194, 36.844860076904354],
              [30.700138092041072, 36.88458251953125],
              [30.622360229492358, 36.850692749023665],
              [30.574861526489542, 36.794860839843864],
              [30.571250915527514, 36.674861907958984],
              [30.554582595825252, 36.645973205566406],
              [30.55985832214367, 36.61152648925787],
              [30.591527938843058, 36.589305877685604],
              [30.557916641235295, 36.543472290039176],
              [30.56541633605957, 36.53263854980463],
              [30.541528701782397, 36.522361755371094],
              [30.507362365722827, 36.46875000000017],
              [30.509580612182788, 36.43986129760759],
              [30.481252670288143, 36.434028625488224],
              [30.491807937622127, 36.42152786254877],
              [30.476804733276538, 36.39875030517595],
              [30.529584884643498, 36.33430480957031],
              [30.467081069946573, 36.314304351806754],
              [30.46819496154791, 36.29902648925781],
              [30.488750457763842, 36.2993049621582],
              [30.487638473510742, 36.279026031494254],
              [30.40569305419939, 36.209304809570426],
              [30.408193588256893, 36.27541732788097],
              [30.3701362609865, 36.26874923706049],
              [30.28125190734869, 36.314582824707145],
              [30.20041656494169, 36.31541824340826],
              [30.14958381652849, 36.30097198486351],
              [30.151805877685604, 36.27208328247076],
              [30.13819313049322, 36.27791595459007],
              [30.116529464721737, 36.24736022949219],
              [30.06152534484869, 36.25958251953148],
              [29.98125076293951, 36.21430969238298],
              [29.922361373901424, 36.23402786254894],
              [29.890972137451172, 36.211528778076115],
              [29.886804580688533, 36.193748474121264],
              [29.845972061157283, 36.196254730224894],
              [29.829027175903377, 36.18902969360346],
              [29.85041618347185, 36.19319534301769],
              [29.800693511963175, 36.1654167175293],
              [29.829305648803768, 36.1690292358399],
              [29.792638778686694, 36.14291763305681],
              [29.75986289978033, 36.14014053344755],
              [29.78347206115734, 36.15791702270536],
              [29.722917556762866, 36.16347122192377],
              [29.682638168335018, 36.13041687011719],
              [29.678195953369197, 36.152915954589844],
              [29.654581069946573, 36.147083282470874],
              [29.630416870117244, 36.16958236694353],
              [29.641805648803768, 36.18375015258789],
              [29.650417327881144, 36.173473358154354],
              [29.64486122131342, 36.196254730224894],
              [29.58374977111822, 36.18597412109398],
              [29.630416870117244, 36.205417633056754],
              [29.45875167846674, 36.2212486267091],
              [29.44152832031267, 36.21041488647461],
              [29.455139160156307, 36.22569274902372],
              [29.411806106567553, 36.22430419921881],
              [29.40430641174345, 36.244304656982536],
              [29.417085647583292, 36.26069259643583],
              [29.392917633056925, 36.2640266418457],
              [29.368473052978572, 36.26263809204113],
              [29.374862670898494, 36.24874877929693],
              [29.353197097778605, 36.229583740234375],
              [29.31374931335455, 36.246807098388786],
              [29.25625228881853, 36.300140380859546],
              [29.29875755310087, 36.31876373291044],
              [29.32847785949724, 36.40187454223644],
              [29.32709121704113, 36.44231796264643],
              [29.57402038574247, 36.61486434936529],
              [29.604988098144702, 36.779148101806754],
              [29.6735973358156, 36.87476730346697],
              [29.684257507324503, 36.919002532958984],
              [29.752204895019474, 36.9354133605957],
              [29.809103012085018, 36.99095535278326],
              [29.848285675049, 37.12187194824219],
              [29.920265197754077, 37.18822860717785],
              [30.04769325256342, 37.237758636474666],
              [30.31538772583025, 37.30717086791992],
              [30.361600875854663, 37.29970932006836],
              [30.39347648620611, 37.24317550659191],
              [30.44412612915056, 37.22361755371122],
              [30.750419616699276, 37.2364311218264],
              [30.805181503296183, 37.22457885742199],
              [30.881935119628906, 37.36235427856451],
              [30.93602561950712, 37.37379455566406],
              [30.996772766113452, 37.342758178710994],
              [31.17972755432146, 37.389701843261946],
              [31.238805770874023, 37.42179489135759],
              [31.323301315307617, 37.42438888549816],
              [31.374643325805607, 37.370304107666016],
              [31.449348449707315, 37.344013214111385],
            ],
          ],
        ],
      },
      properties: {
        name: 'Antalya',
        label: {
          lat: 37.06967727413832,
          lng: 30.810036496552787,
        },
      },
      id: 7,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [42.7628822326663, 41.58436965942383],
            [42.83630752563505, 41.58284378051758],
            [42.82082748413097, 41.53591918945318],
            [42.793460845947436, 41.51644134521507],
            [42.809623718261776, 41.49266052246105],
            [42.85192489624052, 41.47278594970709],
            [42.86620330810564, 41.4991073608399],
            [42.895412445068644, 41.50369644165039],
            [42.90453720092779, 41.48081207275402],
            [42.96959304809582, 41.45151138305687],
            [43.024772644043026, 41.378250122070256],
            [43.101520538330135, 41.354579925537166],
            [43.1296119689942, 41.317916870117244],
            [43.2023353576663, 41.30036544799805],
            [43.12392044067411, 41.25409317016624],
            [43.19209671020525, 41.25211334228521],
            [43.23177719116228, 41.19274902343756],
            [43.226543426513956, 41.17605972290045],
            [43.28223037719755, 41.181869506835994],
            [43.26377487182617, 41.15536499023443],
            [43.26222610473661, 41.09014511108393],
            [43.22616577148443, 41.03093338012718],
            [43.17438125610357, 41.00304412841808],
            [43.072074890136776, 40.985820770263615],
            [42.91522598266607, 40.92750167846697],
            [42.87519836425798, 40.85858154296881],
            [42.869586944580135, 40.77029800415039],
            [42.8360137939456, 40.71354293823265],
            [42.704601287841854, 40.68149566650385],
            [42.61116790771479, 40.64011383056635],
            [42.54808425903349, 40.64073181152361],
            [42.491706848144645, 40.721416473388786],
            [42.37902069091825, 40.83445358276373],
            [42.332916259765796, 40.924530029296875],
            [42.33081436157232, 40.982887268066406],
            [42.398357391357706, 41.085273742675895],
            [42.48964691162138, 41.1560173034668],
            [42.557403564453296, 41.185615539550724],
            [42.583225250244084, 41.22635269165039],
            [42.53187179565458, 41.30082321167015],
            [42.472846984863565, 41.439739227295036],
            [42.520328521728686, 41.44004821777338],
            [42.51613616943388, 41.479164123535156],
            [42.56949996948242, 41.51092529296898],
            [42.57986831665045, 41.566108703613565],
            [42.60232162475603, 41.583797454833984],
            [42.70830154418974, 41.59800720214844],
            [42.7628822326663, 41.58436965942383],
          ],
        ],
      },
      properties: {
        name: 'Ardahan',
        label: {
          lat: 41.11868449494667,
          lng: 42.53120214018065,
        },
      },
      id: 75,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [41.58960723876953, 41.51329803466791],
            [41.6549530029298, 41.48361206054693],
            [41.708831787109546, 41.497718811035156],
            [41.7156524658206, 41.47513961791998],
            [41.78124237060575, 41.4641685485841],
            [41.82311248779297, 41.434616088867415],
            [41.95518493652372, 41.524646759033146],
            [42.04813003540045, 41.49452972412115],
            [42.087154388427905, 41.51176452636713],
            [42.18389511108404, 41.51451492309599],
            [42.203910827637, 41.493595123291016],
            [42.281776428222656, 41.495216369628906],
            [42.3340225219726, 41.47102355957037],
            [42.40765380859369, 41.466583251953125],
            [42.472846984863565, 41.439739227295036],
            [42.53187179565458, 41.30082321167015],
            [42.583225250244084, 41.22635269165039],
            [42.557403564453296, 41.185615539550724],
            [42.48964691162138, 41.1560173034668],
            [42.398357391357706, 41.085273742675895],
            [42.33081436157232, 40.982887268066406],
            [42.273120880127124, 40.9653129577639],
            [42.09929656982422, 40.963840484619254],
            [42.01268005371111, 40.93065643310547],
            [41.973175048828125, 40.85636520385742],
            [41.90370178222685, 40.640537261963004],
            [41.824424743652514, 40.61821365356457],
            [41.71423721313471, 40.66050338745123],
            [41.64821624755865, 40.661705017089844],
            [41.428695678710994, 40.563056945800724],
            [41.362621307373104, 40.57928466796875],
            [41.33960342407255, 40.6501579284668],
            [41.39697265625017, 40.74471664428722],
            [41.3855819702149, 40.77217483520536],
            [41.199081420898494, 40.78024673461914],
            [41.12230682373047, 40.80845260620117],
            [41.33703231811529, 41.031253814697266],
            [41.407253265380916, 41.06505966186529],
            [41.42398071289074, 41.093452453613395],
            [41.40925979614258, 41.11717605590832],
            [41.36881256103521, 41.11997222900402],
            [41.3067703247072, 41.155185699462834],
            [41.25561904907232, 41.208522796630916],
            [41.24785232543974, 41.25560760498041],
            [41.21147537231445, 41.30291748046869],
            [41.27236175537138, 41.344860076904354],
            [41.41069412231451, 41.386528015136776],
            [41.474029541015796, 41.46152877807617],
            [41.52180480957037, 41.482639312744254],
            [41.54819488525385, 41.526275634765625],
            [41.58960723876953, 41.51329803466791],
          ],
        ],
      },
      properties: {
        name: 'Artvin',
        label: {
          lat: 41.237946035449035,
          lng: 41.7994963930076,
        },
      },
      id: 8,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [27.329860687256087, 37.331249237060774],
              [27.333749771118505, 37.33013916015625],
              [27.331527709961392, 37.3218040466308],
              [27.325416564941463, 37.32541656494146],
              [27.329860687256087, 37.331249237060774],
            ],
          ],
          [
            [
              [27.41152763366739, 37.413471221923885],
              [27.410692214965877, 37.40902709960949],
              [27.407917022705533, 37.40902709960949],
              [27.408470153808935, 37.41180419921898],
              [27.41152763366739, 37.413471221923885],
            ],
          ],
          [
            [
              [27.181804656982422, 37.563472747802905],
              [27.18291664123535, 37.56124877929716],
              [27.182361602783374, 37.560138702392805],
              [27.180416107177848, 37.56124877929716],
              [27.181804656982422, 37.563472747802905],
            ],
          ],
          [
            [
              [27.140417098998967, 37.61375045776373],
              [27.142360687256257, 37.60625076293945],
              [27.159860610962312, 37.58680725097685],
              [27.13902854919479, 37.60736083984381],
              [27.140417098998967, 37.61375045776373],
            ],
          ],
          [
            [
              [27.005971908569677, 37.65347290039085],
              [27.004583358764762, 37.64930725097679],
              [26.999860763550146, 37.64930725097679],
              [27.001249313354492, 37.65208435058594],
              [27.005971908569677, 37.65347290039085],
            ],
          ],
          [
            [
              [27.014862060547102, 37.65513992309576],
              [27.014028549194336, 37.6523628234865],
              [27.009304046630973, 37.65263748168968],
              [27.010139465332486, 37.654304504394645],
              [27.014862060547102, 37.65513992309576],
            ],
          ],
          [
            [
              [27.01847267150896, 37.69263839721697],
              [27.0181941986084, 37.69041824340826],
              [27.015972137451456, 37.6906929016115],
              [27.015693664550895, 37.692359924316406],
              [27.01847267150896, 37.69263839721697],
            ],
          ],
          [
            [
              [28.815587997436808, 38.03673553466808],
              [28.869655609131087, 37.982742309570426],
              [28.793079376220817, 37.90647888183622],
              [28.76422882080078, 37.84311676025402],
              [28.849018096923828, 37.763168334961165],
              [28.87846755981451, 37.691711425781534],
              [28.740436553955192, 37.600101470947266],
              [28.614013671875057, 37.610515594482536],
              [28.573816299438533, 37.591552734375114],
              [28.550529479980753, 37.570991516113224],
              [28.556762695312727, 37.544166564941406],
              [28.604200363159407, 37.47769927978527],
              [28.461118698120117, 37.497226715088004],
              [28.294479370117188, 37.586898803710994],
              [28.220544815063704, 37.562210083007926],
              [28.14990234375, 37.47454833984375],
              [27.884967803955192, 37.4570426940918],
              [27.698598861694563, 37.49717712402338],
              [27.506229400634936, 37.574592590332145],
              [27.444992065429744, 37.505565643310604],
              [27.414861679077262, 37.41570281982433],
              [27.368749618530614, 37.39958190917969],
              [27.359861373901424, 37.372081756591854],
              [27.32930564880371, 37.378471374511776],
              [27.330415725708065, 37.342639923095874],
              [27.28541755676315, 37.35625076293951],
              [27.253749847412507, 37.335693359375],
              [27.191528320312955, 37.35374832153343],
              [27.21791648864746, 37.39236068725597],
              [27.20902824401901, 37.398750305175895],
              [27.23069381713873, 37.40569305419922],
              [27.218471527099837, 37.41986083984381],
              [27.22763824462885, 37.472362518310774],
              [27.22513961792032, 37.48791503906273],
              [27.181804656982422, 37.47402954101568],
              [27.202638626099088, 37.489860534668026],
              [27.200971603393782, 37.516250610351506],
              [27.194583892822266, 37.53263854980497],
              [27.18986129760765, 37.49124908447294],
              [27.18013954162643, 37.48291778564453],
              [27.191528320312955, 37.545696258545036],
              [27.16791725158697, 37.536251068115234],
              [27.159585952758732, 37.58541488647478],
              [27.17541885376022, 37.56180572509777],
              [27.170974731445426, 37.55902862548845],
              [27.171249389648835, 37.54930496215832],
              [27.174583435058707, 37.54763793945335],
              [27.217361450195483, 37.59069442749035],
              [27.124305725097656, 37.630973815918026],
              [27.002916336059627, 37.6590270996096],
              [27.031248092651424, 37.69013977050787],
              [27.099306106567496, 37.680416107177734],
              [27.229305267333984, 37.72069549560558],
              [27.2665252685548, 37.78569412231445],
              [27.267639160156534, 37.815692901611385],
              [27.235416412353516, 37.83902740478533],
              [27.241249084472884, 37.86013793945324],
              [27.263193130493164, 37.86597061157221],
              [27.26513862609886, 37.891803741455135],
              [27.35456848144537, 37.891254425049055],
              [27.441749572753963, 37.91611480712896],
              [27.494209289550838, 37.943946838378906],
              [27.523767471313477, 37.98232269287132],
              [27.72010993957548, 37.985515594482536],
              [27.77575492858881, 37.972328186035156],
              [27.923608779907283, 37.99508666992193],
              [27.938676834106502, 38.018360137939396],
              [27.95366859436035, 38.006706237793026],
              [28.071899414062727, 38.02942657470726],
              [28.249021530151367, 38.01900100708008],
              [28.57966613769537, 38.110542297363395],
              [28.696769714355526, 38.1111297607423],
              [28.71974372863798, 38.09927368164074],
              [28.71170043945341, 38.077957153320426],
              [28.815587997436808, 38.03673553466808],
            ],
          ],
        ],
      },
      properties: {
        name: 'Aydın',
        label: {
          lat: 37.811483994008526,
          lng: 27.834995089720202,
        },
      },
      id: 9,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [26.59874916076666, 39.30347061157232],
              [26.602916717529297, 39.28319549560558],
              [26.577360153198185, 39.27708435058605],
              [26.590972900390966, 39.30180740356457],
              [26.59874916076666, 39.30347061157232],
            ],
          ],
          [
            [
              [26.529584884643782, 39.32097244262718],
              [26.52736282348667, 39.3204154968264],
              [26.52486038208002, 39.32125091552757],
              [26.53069686889654, 39.322082519531534],
              [26.529584884643782, 39.32097244262718],
            ],
          ],
          [
            [
              [26.65930557250988, 39.324584960937614],
              [26.65930557250988, 39.32291793823248],
              [26.656248092651424, 39.32374954223627],
              [26.656248092651424, 39.324584960937614],
              [26.65930557250988, 39.324584960937614],
            ],
          ],
          [
            [
              [26.539304733276765, 39.33180618286133],
              [26.543750762939396, 39.325416564941406],
              [26.53069686889654, 39.324584960937614],
              [26.531806945800895, 39.33180618286133],
              [26.539304733276765, 39.33180618286133],
            ],
          ],
          [
            [
              [26.606527328491325, 39.34291839599604],
              [26.612638473510856, 39.33319473266624],
              [26.5951385498048, 39.336250305175724],
              [26.6020832061771, 39.342639923095646],
              [26.606527328491325, 39.34291839599604],
            ],
          ],
          [
            [
              [26.577638626098746, 39.344860076904354],
              [26.579862594604833, 39.339305877685774],
              [26.572917938232536, 39.33319473266624],
              [26.57430648803711, 39.34152603149414],
              [26.577638626098746, 39.344860076904354],
            ],
          ],
          [
            [
              [26.695138931274528, 39.34958267211937],
              [26.696805953979492, 39.343193054199446],
              [26.683471679687443, 39.344860076904354],
              [26.683471679687443, 39.34680557250988],
              [26.695138931274528, 39.34958267211937],
            ],
          ],
          [
            [
              [26.5951385498048, 39.35041809082031],
              [26.601526260376147, 39.34430694580095],
              [26.585695266723803, 39.34291839599604],
              [26.585695266723803, 39.348751068115405],
              [26.5951385498048, 39.35041809082031],
            ],
          ],
          [
            [
              [26.672359466552734, 39.354583740234375],
              [26.671527862548942, 39.35235977172846],
              [26.664861679077603, 39.35208511352562],
              [26.66625022888178, 39.35347366333019],
              [26.672359466552734, 39.354583740234375],
            ],
          ],
          [
            [
              [26.697082519531648, 39.37236022949219],
              [26.698749542236385, 39.369304656982536],
              [26.695693969726904, 39.36736297607422],
              [26.694028854370174, 39.371528625488224],
              [26.697082519531648, 39.37236022949219],
            ],
          ],
          [
            [
              [26.727081298828182, 39.37930679321306],
              [26.727363586425952, 39.37680435180664],
              [26.724027633667106, 39.3770828247072],
              [26.724306106567496, 39.378471374511946],
              [26.727081298828182, 39.37930679321306],
            ],
          ],
          [
            [
              [26.768474578857422, 39.3795814514163],
              [26.768474578857422, 39.374862670898494],
              [26.759860992431584, 39.37263870239258],
              [26.761249542236328, 39.37597274780285],
              [26.768474578857422, 39.3795814514163],
            ],
          ],
          [
            [
              [26.707916259765625, 39.38263702392578],
              [26.7095832824711, 39.37374877929693],
              [26.703195571899414, 39.37402725219749],
              [26.702917098999023, 39.37985992431646],
              [26.707916259765625, 39.38263702392578],
            ],
          ],
          [
            [
              [26.572360992431584, 39.38513946533203],
              [26.575416564941463, 39.380973815918196],
              [26.5695858001709, 39.378192901611555],
              [26.56847381591831, 39.38402938842768],
              [26.572360992431584, 39.38513946533203],
            ],
          ],
          [
            [
              [26.614583969116552, 39.395973205566406],
              [26.670139312744197, 39.389862060547046],
              [26.623195648193416, 39.37014007568388],
              [26.69069480896013, 39.33347320556646],
              [26.622638702392635, 39.32652664184593],
              [26.60791587829607, 39.35180664062523],
              [26.623472213745572, 39.356529235839844],
              [26.617359161377067, 39.380416870117415],
              [26.59874916076666, 39.38569259643583],
              [26.614583969116552, 39.395973205566406],
            ],
          ],
          [
            [
              [26.59013938903803, 39.39736175537132],
              [26.603195190429858, 39.394859313964844],
              [26.588193893433072, 39.36763763427757],
              [26.575695037842024, 39.389862060547046],
              [26.59013938903803, 39.39736175537132],
            ],
          ],
          [
            [
              [26.71236038208002, 39.409862518310604],
              [26.711526870727653, 39.40625],
              [26.705972671509244, 39.40569305419939],
              [26.706806182861442, 39.40819549560547],
              [26.71236038208002, 39.409862518310604],
            ],
          ],
          [
            [
              [27.79013633728067, 40.37819290161133],
              [27.78791427612299, 40.3737487792971],
              [27.781805038452603, 40.37291717529297],
              [27.781251907348633, 40.37569427490263],
              [27.79013633728067, 40.37819290161133],
            ],
          ],
          [
            [
              [28.09180641174322, 40.45458221435547],
              [28.094028472900504, 40.44958496093767],
              [28.085971832275447, 40.45208358764677],
              [28.09041595459007, 40.45541763305664],
              [28.09180641174322, 40.45458221435547],
            ],
          ],
          [
            [
              [28.066804885864656, 40.46291732788109],
              [28.074861526489315, 40.46097183227539],
              [28.080415725708292, 40.45180511474638],
              [28.062915802002237, 40.45763778686535],
              [28.066804885864656, 40.46291732788109],
            ],
          ],
          [
            [
              [27.66319465637207, 40.46680450439476],
              [27.667085647583463, 40.4462509155274],
              [27.65569686889677, 40.445415496826456],
              [27.650693893432617, 40.45291519165056],
              [27.66319465637207, 40.46680450439476],
            ],
          ],
          [
            [
              [28.09874725341814, 40.46930694580101],
              [28.105417251587028, 40.46875000000023],
              [28.105417251587028, 40.467918395996094],
              [28.098194122314908, 40.46597290039057],
              [28.09874725341814, 40.46930694580101],
            ],
          ],
          [
            [
              [27.565971374511832, 40.46958160400402],
              [27.5668048858642, 40.46736145019531],
              [27.56430625915567, 40.465415954590014],
              [27.561807632446573, 40.468471527099666],
              [27.565971374511832, 40.46958160400402],
            ],
          ],
          [
            [
              [27.62125015258789, 40.51124954223661],
              [27.623750686645565, 40.497638702392805],
              [27.651527404785554, 40.49319458007841],
              [27.632360458374023, 40.47208404541033],
              [27.649583816528263, 40.45208358764677],
              [27.577917098999478, 40.462638854980696],
              [27.582639694213924, 40.482639312744425],
              [27.60791587829584, 40.48152923584007],
              [27.599304199218807, 40.508750915527344],
              [27.62125015258789, 40.51124954223661],
            ],
          ],
          [
            [
              [27.709583282470703, 40.5259704589846],
              [27.710418701171875, 40.52513885498047],
              [27.710136413574673, 40.52265167236328],
              [27.708196640014933, 40.52458190917969],
              [27.709583282470703, 40.5259704589846],
            ],
          ],
          [
            [
              [27.583471298217887, 40.52819442749052],
              [27.58625030517578, 40.50569534301769],
              [27.580415725708008, 40.494583129882756],
              [27.572360992431754, 40.498195648193416],
              [27.583471298217887, 40.52819442749052],
            ],
          ],
          [
            [
              [27.7537517547608, 40.52847290039091],
              [27.77736091613781, 40.52624893188499],
              [27.784860610961914, 40.50597381591825],
              [27.794305801392056, 40.51930618286133],
              [27.870695114136197, 40.51708221435541],
              [28.031805038452546, 40.48125076293951],
              [28.00597190856928, 40.43986129760748],
              [27.89680480957071, 40.39041519165062],
              [27.954584121704443, 40.35291671752941],
              [28.060693740845124, 40.38236236572271],
              [28.215667724609546, 40.39819335937506],
              [28.139453887939794, 40.31338882446312],
              [28.1234397888187, 40.209861755371264],
              [28.123510360717773, 40.11376953125006],
              [28.138450622558594, 40.078830718994254],
              [28.21094131469738, 40.03118896484398],
              [28.30317497253418, 39.869155883789006],
              [28.33790016174345, 39.86425018310564],
              [28.52121162414562, 39.76625823974632],
              [28.67019081115734, 39.755977630615234],
              [28.787443161010913, 39.624740600586165],
              [28.909473419189453, 39.62299346923834],
              [28.947071075439453, 39.605796813964844],
              [28.96330642700218, 39.58925628662132],
              [28.934938430786246, 39.550872802734546],
              [28.940580368041935, 39.519817352295036],
              [28.883300781250227, 39.366607666015625],
              [28.793338775634766, 39.283752441406364],
              [28.661375045776367, 39.2337074279788],
              [28.66218757629406, 39.163825988769474],
              [28.60289764404297, 39.1800346374514],
              [28.466716766357536, 39.12395095825201],
              [28.166194915771484, 39.042678833007926],
              [28.112621307373274, 39.062858581543026],
              [28.057016372680835, 39.172363281250114],
              [27.99714279174816, 39.22052001953142],
              [27.895751953125114, 39.2360725402832],
              [27.8823184967041, 39.26954650878906],
              [27.917137145996037, 39.329010009765625],
              [27.896583557128906, 39.35721206665045],
              [27.881540298462085, 39.345581054687614],
              [27.79146385192871, 39.35728836059582],
              [27.679256439208984, 39.34687423706055],
              [27.612707138061694, 39.36009979248047],
              [27.516485214233455, 39.41384506225586],
              [27.407686233520792, 39.38151550292969],
              [27.176755905151424, 39.42146682739258],
              [26.957500457763672, 39.259422302246094],
              [26.78491020202671, 39.1717643737793],
              [26.739028930664062, 39.20041656494152],
              [26.71819686889654, 39.25902938842779],
              [26.60958480834978, 39.272361755371264],
              [26.625415802002124, 39.31152725219755],
              [26.65041732788086, 39.32347106933588],
              [26.65680694580078, 39.30374908447271],
              [26.630418777465877, 39.29708480834961],
              [26.670972824097134, 39.27902603149437],
              [26.663749694824276, 39.30513763427763],
              [26.689029693603572, 39.313194274902344],
              [26.70180320739786, 39.34069442749035],
              [26.80569458007824, 39.39208221435575],
              [26.79708480834961, 39.43236160278343],
              [26.854860305786133, 39.439861297607706],
              [26.858472824096964, 39.477359771728516],
              [26.931249618530273, 39.48541641235374],
              [26.95347023010254, 39.55180740356451],
              [26.922639846802042, 39.5837516784668],
              [26.88125038147001, 39.58514022827154],
              [26.838472366333235, 39.5579185485841],
              [26.774583816528548, 39.571250915527344],
              [26.662944793701286, 39.55847549438482],
              [26.6665878295899, 39.650680541992415],
              [26.688920974731445, 39.697902679443416],
              [26.738092422485522, 39.718643188476676],
              [26.845289230346737, 39.71005630493164],
              [26.980264663696403, 39.78216171264654],
              [27.091777801513672, 39.81017303466808],
              [27.15715980529785, 39.81030654907238],
              [27.264280319214095, 39.7708168029788],
              [27.423446655273494, 39.829936981201286],
              [27.472572326660156, 39.88761520385759],
              [27.492630004882812, 39.93980789184599],
              [27.487668991088924, 39.96401596069347],
              [27.450334548950195, 39.98967361450195],
              [27.506595611572436, 40.12036132812494],
              [27.472787857055835, 40.20105743408203],
              [27.575317382812614, 40.27116012573242],
              [27.587085723877124, 40.31819534301769],
              [27.632917404174975, 40.32680511474615],
              [27.659584045410213, 40.306804656982365],
              [27.760972976684513, 40.30625152587896],
              [27.87986183166504, 40.374305725097884],
              [27.824306488037394, 40.3995819091798],
              [27.795139312744254, 40.38402938842802],
              [27.78319358825678, 40.40902709960943],
              [27.74541664123575, 40.430416107177905],
              [27.75180625915567, 40.44930648803711],
              [27.686527252197664, 40.47236251831049],
              [27.685140609741325, 40.503192901611385],
              [27.7537517547608, 40.52847290039091],
            ],
          ],
          [
            [
              [27.517639160156477, 40.53791809082031],
              [27.552917480469148, 40.5212516784668],
              [27.523471832275447, 40.500415802002124],
              [27.537082672119254, 40.488193511962834],
              [27.489582061767692, 40.467918395996094],
              [27.47819328308117, 40.4940261840822],
              [27.517639160156477, 40.53791809082031],
            ],
          ],
          [
            [
              [27.501806259155728, 40.553749084472656],
              [27.50652694702194, 40.547637939453125],
              [27.465139389038313, 40.53902816772484],
              [27.46708488464361, 40.547637939453125],
              [27.501806259155728, 40.553749084472656],
            ],
          ],
          [
            [
              [27.759582519531364, 40.63347244262724],
              [27.7587509155274, 40.63124847412132],
              [27.756526947021882, 40.63180541992193],
              [27.756526947021882, 40.632915496826286],
              [27.759582519531364, 40.63347244262724],
            ],
          ],
          [
            [
              [27.48541641235346, 40.647083282470874],
              [27.489860534668082, 40.64625167846708],
              [27.488193511962947, 40.63652801513672],
              [27.479585647583463, 40.64152908325207],
              [27.48541641235346, 40.647083282470874],
            ],
          ],
          [
            [
              [27.679027557373388, 40.664028167724894],
              [27.68041419982916, 40.66236114501959],
              [27.676805496216275, 40.65847396850597],
              [27.676527023315884, 40.661251068115234],
              [27.679027557373388, 40.664028167724894],
            ],
          ],
          [
            [
              [27.635416030884244, 40.668193817138956],
              [27.744028091430835, 40.632637023925895],
              [27.608749389648608, 40.57430648803734],
              [27.529306411743562, 40.59680557250982],
              [27.53263854980503, 40.64680480957048],
              [27.635416030884244, 40.668193817138956],
            ],
          ],
        ],
      },
      properties: {
        name: 'Balıkesir',
        label: {
          lat: 39.69770554621674,
          lng: 27.684919092036427,
        },
      },
      id: 10,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [32.38930511474604, 41.755416870117415],
              [32.38986206054716, 41.751804351806584],
              [32.38874816894548, 41.75125122070335],
              [32.38708496093756, 41.75374984741211],
              [32.38930511474604, 41.755416870117415],
            ],
          ],
          [
            [
              [32.6841583251956, 41.83443832397461],
              [32.761165618896655, 41.7322998046875],
              [32.827293395996094, 41.595649719238395],
              [32.92557525634771, 41.553955078125],
              [32.8231658935548, 41.51309204101574],
              [32.79067993164068, 41.525810241699276],
              [32.7556343078615, 41.489173889160384],
              [32.69793319702154, 41.46401596069336],
              [32.6317977905274, 41.35578155517578],
              [32.42853927612322, 41.254291534424055],
              [32.35403823852545, 41.23849105834972],
              [32.30512619018572, 41.306194305420036],
              [32.02547073364252, 41.548965454101506],
              [32.028751373291186, 41.5745849609375],
              [32.06208419799833, 41.570137023925724],
              [32.052082061767635, 41.58152770996105],
              [32.149307250976676, 41.60680389404314],
              [32.1798629760745, 41.632083892822266],
              [32.17347335815458, 41.640693664550895],
              [32.22874832153332, 41.670696258545036],
              [32.224582672119425, 41.68569564819359],
              [32.28319549560558, 41.719581604004134],
              [32.34041595458996, 41.722915649414006],
              [32.38208389282232, 41.75374984741211],
              [32.415416717529354, 41.73958206176786],
              [32.49874877929716, 41.80152893066406],
              [32.57291793823259, 41.810974121093864],
              [32.58013916015631, 41.82736206054693],
              [32.6841583251956, 41.83443832397461],
            ],
          ],
        ],
      },
      properties: {
        name: 'Bartın',
        label: {
          lat: 41.608074744740975,
          lng: 32.31339719736135,
        },
      },
      id: 74,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [41.58572387695324, 38.54240417480463],
            [41.63222503662115, 38.50775527954113],
            [41.66092300415045, 38.426647186279524],
            [41.680023193359546, 38.34867858886719],
            [41.67819213867193, 38.20679855346691],
            [41.6461448669433, 38.102352142333984],
            [41.60668945312506, 38.038478851318416],
            [41.48127746582048, 38.02124786376959],
            [41.480823516845874, 37.986244201660156],
            [41.432540893554744, 37.95641326904308],
            [41.4121208190918, 37.91577911376959],
            [41.51866149902361, 37.85847473144531],
            [41.73163986206072, 37.85505676269531],
            [41.73792648315447, 37.8255729675293],
            [41.70092010498058, 37.77768707275396],
            [41.754611968994254, 37.74295043945335],
            [41.838973999023494, 37.76421737670921],
            [41.8682403564456, 37.75908279418951],
            [41.8738899230957, 37.74024581909191],
            [41.686473846435604, 37.67586898803711],
            [41.573192596435604, 37.57748413085932],
            [41.4461212158206, 37.55442810058594],
            [41.18900680542009, 37.556800842285384],
            [41.05128097534197, 37.71851730346691],
            [41.051792144775675, 37.73957443237305],
            [41.09960174560547, 37.76951217651367],
            [41.11236953735357, 37.80470275878906],
            [41.05167770385759, 37.825115203857536],
            [41.033123016357365, 37.85990142822277],
            [41.105842590332315, 37.91629791259771],
            [41.21151351928728, 38.105602264404354],
            [41.22935867309599, 38.17604446411144],
            [41.21520614624029, 38.21622085571289],
            [41.21492385864275, 38.333042144775504],
            [41.232952117920036, 38.39165115356445],
            [41.261119842529354, 38.43730926513666],
            [41.35118865966797, 38.471626281738565],
            [41.42137908935547, 38.47715377807623],
            [41.434333801269474, 38.49729156494146],
            [41.416931152344034, 38.522247314453125],
            [41.43031311035185, 38.53088378906273],
            [41.58572387695324, 38.54240417480463],
          ],
        ],
      },
      properties: {
        name: 'Batman',
        label: {
          lat: 38.190610154438076,
          lng: 41.260804667401075,
        },
      },
      id: 72,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [40.50198745727539, 40.524814605712834],
            [40.52688598632818, 40.48198318481451],
            [40.562980651855526, 40.30159378051769],
            [40.631130218505916, 40.24741744995123],
            [40.78762054443365, 40.227943420410156],
            [40.79770660400408, 40.20346832275402],
            [40.764133453369254, 40.15393447875999],
            [40.64613723754883, 40.11261749267584],
            [40.4773902893067, 40.02457046508789],
            [40.37506103515631, 40.02386474609375],
            [40.11088943481474, 40.070037841796875],
            [39.879669189453125, 40.00830078125023],
            [39.78475570678705, 39.931087493896484],
            [39.70485687255865, 39.975437164306754],
            [39.69057846069353, 40.01388931274414],
            [39.74072265625006, 40.07666397094732],
            [39.801929473876896, 40.115879058837834],
            [39.817634582519815, 40.15013122558594],
            [39.82343292236345, 40.249820709228686],
            [39.85456085205084, 40.3255500793457],
            [39.88367080688482, 40.3472251892091],
            [39.988433837890625, 40.36897277832037],
            [40.04511260986334, 40.42015075683605],
            [40.09298324584955, 40.512348175048885],
            [40.20972061157221, 40.50019073486334],
            [40.48347854614275, 40.535343170166016],
            [40.50198745727539, 40.524814605712834],
          ],
        ],
      },
      properties: {
        name: 'Bayburt',
        label: {
          lat: 40.24792395600428,
          lng: 39.9824167843465,
        },
      },
      id: 69,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.137876510620288, 40.368118286132756],
            [30.30372619628912, 40.402862548828125],
            [30.465574264526424, 40.38898468017584],
            [30.62383460998541, 40.335178375244254],
            [30.726753234863338, 40.171913146972656],
            [30.571363449096623, 40.14687728881859],
            [30.523212432861612, 40.00673294067394],
            [30.464849472045955, 39.95089340209955],
            [30.35621070861822, 39.9370231628418],
            [30.248657226562784, 39.85490798950207],
            [30.12443351745634, 39.86803054809593],
            [30.058496475219783, 39.84362411499029],
            [29.999553680419922, 39.77170181274437],
            [30.002939224243164, 39.72935867309593],
            [30.044765472412166, 39.693233489990234],
            [29.952077865600756, 39.68215942382835],
            [29.722852706909237, 39.74099349975609],
            [29.68674087524431, 39.82540512084961],
            [29.69292449951189, 39.87970352172863],
            [29.67700767517084, 39.90554428100603],
            [29.77089500427263, 39.9065055847168],
            [29.78856849670416, 39.93006134033203],
            [29.789287567138956, 39.967704772949276],
            [29.72355651855497, 40.00169372558605],
            [29.68801116943365, 40.06284332275396],
            [29.73137855529791, 40.190849304199446],
            [29.799266815185717, 40.23756027221674],
            [29.83152389526373, 40.285297393799],
            [29.805931091308707, 40.34535980224615],
            [29.80528068542486, 40.41008758544916],
            [29.838851928711108, 40.472503662109546],
            [29.891553878784464, 40.5150718688966],
            [29.941497802734432, 40.53152847290039],
            [29.981578826904297, 40.46556854248075],
            [30.137876510620288, 40.368118286132756],
          ],
        ],
      },
      properties: {
        name: 'Bilecik',
        label: {
          lat: 40.117646460988965,
          lng: 29.976274500129005,
        },
      },
      id: 11,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [40.94224929809576, 39.514541625976676],
            [41.02952194213884, 39.46599578857439],
            [41.1310348510745, 39.45877838134771],
            [41.2186927795413, 39.35533905029297],
            [41.18736267089861, 39.332496643066406],
            [41.171733856201286, 39.28934097290062],
            [41.204399108886776, 39.16355514526367],
            [41.23756408691412, 39.15412902832031],
            [41.274139404297046, 39.11057281494152],
            [41.274494171142635, 39.02955627441406],
            [41.15594863891596, 38.90488433837896],
            [41.26630401611328, 38.72560119628912],
            [40.91010284423834, 38.59239578247093],
            [40.52542114257824, 38.61225128173828],
            [40.49867248535162, 38.59278869628906],
            [40.47573471069347, 38.51073837280279],
            [40.44480895996094, 38.478462219238395],
            [40.29214859008806, 38.47479248046898],
            [40.297912597656534, 38.549640655517635],
            [40.23947143554693, 38.60807037353533],
            [40.24125289916992, 38.645938873291016],
            [40.28793334960943, 38.726707458496264],
            [40.35682296752947, 38.725006103515625],
            [40.386886596679744, 38.8065643310548],
            [40.35352325439459, 38.86205291748058],
            [40.320285797119254, 38.86981201171898],
            [40.286796569824276, 38.94425582885742],
            [40.284648895263956, 39.041481018066634],
            [40.39783859252947, 39.15583801269531],
            [40.38748931884771, 39.195796966552734],
            [40.354022979736385, 39.22611618041992],
            [40.0097732543947, 39.089889526367244],
            [40.04188919067383, 39.13946533203125],
            [40.03049850463873, 39.19946670532232],
            [40.064739227295206, 39.26797866821312],
            [40.098674774170206, 39.31428146362305],
            [40.20206451416021, 39.28889083862305],
            [40.390830993652344, 39.382858276367244],
            [40.33533477783203, 39.427463531494254],
            [40.51652145385748, 39.5039901733399],
            [40.54322814941406, 39.54778289794922],
            [40.68346405029314, 39.51169967651373],
            [40.862430572509766, 39.565601348876896],
            [40.90938568115263, 39.550853729248104],
            [40.94224929809576, 39.514541625976676],
          ],
        ],
      },
      properties: {
        name: 'Bingöl',
        label: {
          lat: 39.10466976203652,
          lng: 40.55441105303814,
        },
      },
      id: 12,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [43.13637161254883, 38.92792129516613],
            [43.197910308838004, 38.8801727294923],
            [43.196823120117244, 38.828151702880916],
            [43.178493499756144, 38.79753494262695],
            [43.056091308593864, 38.72330474853521],
            [42.964450836181754, 38.61788177490246],
            [42.9462432861331, 38.614349365234375],
            [42.8891716003418, 38.52491760253906],
            [42.72961044311529, 38.45822143554693],
            [42.68778610229509, 38.42295074462902],
            [42.739238739013615, 38.277294158935774],
            [42.7185440063476, 38.20607376098633],
            [42.75567626953131, 38.175254821777344],
            [42.79895782470709, 38.16839981079107],
            [42.777313232421875, 38.127155303955135],
            [42.8357009887697, 38.06550598144537],
            [42.73911666870117, 38.013481140137],
            [42.49808883666998, 38.109996795654354],
            [42.371692657470646, 38.13842010498058],
            [42.298156738281534, 38.18778610229509],
            [42.20790863037138, 38.21693801879883],
            [42.095233917236385, 38.20076751708996],
            [42.025947570801065, 38.12945938110357],
            [41.97900390625006, 38.15625381469738],
            [41.91657638549833, 38.148315429687614],
            [41.67486572265625, 38.19519042968773],
            [41.67907714843767, 38.35854721069359],
            [41.63345336914057, 38.50515365600586],
            [41.59266662597673, 38.540195465088175],
            [41.52218246459961, 38.541912078857706],
            [41.57016754150408, 38.58500671386719],
            [41.62169647216797, 38.59952545166021],
            [41.863296508789006, 38.590469360351506],
            [41.940517425537166, 38.61808013916027],
            [42.056205749511776, 38.69475173950195],
            [42.054039001464844, 38.728683471679744],
            [41.998836517334155, 38.78861618041992],
            [42.002147674560604, 38.814769744873104],
            [42.136615753173885, 38.823856353759766],
            [42.13997268676758, 38.87031555175781],
            [42.310134887695426, 38.93563461303711],
            [42.4895858764649, 38.9266815185548],
            [42.56119918823248, 38.94335556030279],
            [42.68435287475603, 38.926906585693416],
            [42.76899337768549, 38.94040298461914],
            [42.749843597412166, 39.03714752197277],
            [42.827857971191406, 39.06509017944347],
            [43.02248382568365, 39.09549331665056],
            [43.00571441650396, 38.98618316650396],
            [43.13637161254883, 38.92792129516613],
          ],
        ],
      },
      properties: {
        name: 'Bitlis',
        label: {
          lat: 38.58415728668491,
          lng: 42.13947478945768,
        },
      },
      id: 13,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.912191390991495, 41.01945114135742],
            [32.28520965576189, 41.00830078125006],
            [32.28196716308611, 40.94109725952171],
            [32.50800323486328, 40.862258911132926],
            [32.540092468261776, 40.80879592895536],
            [32.521430969238395, 40.72862625122093],
            [32.430423736572266, 40.65179443359392],
            [32.47593688964861, 40.5302276611331],
            [32.38796997070307, 40.423839569091854],
            [32.32307052612322, 40.41284942626976],
            [32.14555358886719, 40.424667358398494],
            [31.9033527374267, 40.34561157226557],
            [31.79364585876482, 40.33181762695318],
            [31.705093383789347, 40.34394454956066],
            [31.566928863525675, 40.30855178833008],
            [31.26392936706543, 40.346771240234375],
            [31.14426994323742, 40.39905548095703],
            [31.06073379516596, 40.41575241088867],
            [31.037288665771484, 40.37631988525385],
            [31.047548294067383, 40.2725639343264],
            [30.955003738403605, 40.22293853759777],
            [30.873971939086914, 40.14034652709961],
            [30.726753234863338, 40.171913146972656],
            [30.636177062988338, 40.30845642089844],
            [30.62383460998541, 40.335178375244254],
            [30.6464271545413, 40.38548660278343],
            [30.59591865539568, 40.44455718994152],
            [30.676174163818644, 40.51831817626959],
            [30.82930183410673, 40.51985549926752],
            [30.9108257293704, 40.5385627746582],
            [30.946756362915096, 40.57278442382807],
            [30.954557418823242, 40.682250976562614],
            [31.026567459106445, 40.65954208374029],
            [31.190750122070483, 40.68179702758789],
            [31.264896392822322, 40.646827697753906],
            [31.36094474792492, 40.66146087646496],
            [31.42705917358404, 40.70133590698265],
            [31.43151664733898, 40.805057525634766],
            [31.469253540039233, 40.87095642089844],
            [31.60422897338873, 40.8813362121582],
            [31.690898895263956, 40.91467666625971],
            [31.73953056335455, 40.94845199584961],
            [31.757904052734432, 40.987693786621094],
            [31.75791931152355, 41.01557540893549],
            [31.736297607421932, 41.042720794677734],
            [31.912191390991495, 41.01945114135742],
          ],
        ],
      },
      properties: {
        name: 'Bolu',
        label: {
          lat: 40.71730569483521,
          lng: 31.826121571291583,
        },
      },
      id: 14,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.54076385498047, 37.703563690185774],
            [30.651264190674, 37.700595855712834],
            [30.70260238647461, 37.6779670715332],
            [30.76529884338396, 37.52559661865229],
            [30.907865524292163, 37.398216247558594],
            [30.915895462036417, 37.37248611450207],
            [30.870082855224666, 37.35358428955078],
            [30.805181503296183, 37.22457885742199],
            [30.750419616699276, 37.23643112182623],
            [30.44412612915056, 37.22361755371105],
            [30.39347648620611, 37.24317550659191],
            [30.356336593627987, 37.302886962890625],
            [30.288280487060547, 37.305519104003906],
            [30.04769325256342, 37.237758636474666],
            [29.877441406250057, 37.16139221191429],
            [29.84602165222185, 37.11684417724621],
            [29.8244247436524, 37.01425552368187],
            [29.737199783325195, 36.92720031738287],
            [29.684257507324503, 36.919002532958984],
            [29.62462997436529, 36.99750900268566],
            [29.546728134155217, 37.027606964111555],
            [29.511768341064737, 37.024211883545036],
            [29.44611740112316, 36.96438980102539],
            [29.394460678100643, 36.952030181884766],
            [29.4083900451663, 37.01031112670927],
            [29.387758255004826, 37.076091766357536],
            [29.395507812500284, 37.15217590332031],
            [29.44138145446783, 37.23631668090832],
            [29.523260116577433, 37.31515121459961],
            [29.579244613647518, 37.41019439697277],
            [29.57953453063959, 37.43535614013683],
            [29.530990600586108, 37.46260452270508],
            [29.526779174804858, 37.5913848876956],
            [29.865327835083292, 37.77055358886736],
            [29.994150161743335, 37.78136062622076],
            [30.03392410278326, 37.71933364868164],
            [30.08116722106928, 37.703464508056584],
            [30.32950592041027, 37.83989715576183],
            [30.371025085449276, 37.83028030395536],
            [30.438201904296932, 37.754367828369425],
            [30.54076385498047, 37.703563690185774],
          ],
        ],
      },
      properties: {
        name: 'Burdur',
        label: {
          lat: 37.54784939347502,
          lng: 30.063708848592935,
        },
      },
      id: 15,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [28.539026260375977, 40.56708145141607],
              [28.555141448974837, 40.564861297607365],
              [28.53624916076666, 40.54875183105463],
              [28.5454158782959, 40.5259704589846],
              [28.524583816528377, 40.51124954223661],
              [28.517915725708065, 40.565139770507926],
              [28.539026260375977, 40.56708145141607],
            ],
          ],
          [
            [
              [29.928827285766886, 40.558509826660156],
              [29.941497802734432, 40.53152847290039],
              [29.856920242309855, 40.48979568481451],
              [29.809238433837947, 40.42584228515631],
              [29.805931091308707, 40.34535980224615],
              [29.833244323730753, 40.29028701782232],
              [29.799266815185717, 40.23756027221674],
              [29.73137855529791, 40.190849304199446],
              [29.68801116943365, 40.06284332275396],
              [29.72355651855497, 40.00169372558605],
              [29.789287567138956, 39.967704772949276],
              [29.782350540161417, 39.91889572143572],
              [29.760942459106502, 39.9033012390139],
              [29.615415573120117, 39.891330718994254],
              [29.53948783874506, 39.89305877685547],
              [29.45207023620617, 39.92456817626976],
              [29.411384582519702, 39.909908294677734],
              [29.336360931396655, 39.77615356445318],
              [29.267078399658203, 39.692760467529354],
              [29.247165679931697, 39.5811576843264],
              [29.223285675048885, 39.55531311035179],
              [29.092315673828125, 39.543609619140625],
              [28.99761009216303, 39.566928863525504],
              [28.909473419189453, 39.62299346923834],
              [28.807842254638672, 39.6169128417971],
              [28.77256011962902, 39.63481521606457],
              [28.67019081115734, 39.755977630615234],
              [28.52121162414562, 39.76625823974632],
              [28.33790016174345, 39.86425018310564],
              [28.30317497253418, 39.869155883789006],
              [28.21094131469738, 40.03118896484398],
              [28.138450622558594, 40.078830718994254],
              [28.123510360717773, 40.11376953125006],
              [28.14102172851591, 40.319377899170036],
              [28.215667724609546, 40.39819335937506],
              [28.510417938232365, 40.395137786865234],
              [28.490692138672216, 40.37958145141624],
              [28.482360839844148, 40.36319351196295],
              [28.51597023010254, 40.394859313964844],
              [28.650970458984602, 40.35930633544933],
              [28.796806335449162, 40.39430618286144],
              [28.871250152588175, 40.38486099243181],
              [28.92597198486328, 40.35597229003906],
              [28.98013877868675, 40.35597229003906],
              [29.054027557373217, 40.36319351196295],
              [29.085971832275447, 40.41764068603521],
              [29.154306411743335, 40.42541503906256],
              [29.09180641174339, 40.4745826721192],
              [29.03236198425293, 40.478588104248104],
              [29.010364532470874, 40.497295379638786],
              [29.045017242431754, 40.559192657470874],
              [29.26760673522955, 40.55602264404297],
              [29.362733840942667, 40.580024719238224],
              [29.45255661010748, 40.555171966552734],
              [29.564767837524414, 40.55538940429699],
              [29.78633308410656, 40.613414764404524],
              [29.92487716674833, 40.577526092529354],
              [29.928827285766886, 40.558509826660156],
            ],
          ],
        ],
      },
      properties: {
        name: 'Bursa',
        label: {
          lat: 40.085873184451856,
          lng: 28.764055246286617,
        },
      },
      id: 16,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [26.0534725189209, 39.84736251831055],
              [26.075693130493164, 39.8365287780764],
              [26.083751678466797, 39.80125045776373],
              [26.06180572509811, 39.78708267211914],
              [25.962083816528377, 39.8370819091798],
              [26.0534725189209, 39.84736251831055],
            ],
          ],
          [
            [
              [26.08652687072788, 39.920417785644815],
              [26.087360382080078, 39.917640686035156],
              [26.081247329712312, 39.9181938171389],
              [26.08430480957037, 39.920139312744254],
              [26.08652687072788, 39.920417785644815],
            ],
          ],
          [
            [
              [26.053194046020508, 39.931526184081974],
              [26.053747177124478, 39.92986297607439],
              [26.050138473511026, 39.92986297607439],
              [26.051250457763786, 39.931526184081974],
              [26.053194046020508, 39.931526184081974],
            ],
          ],
          [
            [
              [26.060972213745174, 39.940692901611555],
              [26.072916030884244, 39.93624877929716],
              [26.07847213745123, 39.93847274780302],
              [26.079860687255973, 39.937362670898665],
              [26.067640304565487, 39.931251525879134],
              [26.060972213745174, 39.940692901611555],
            ],
          ],
          [
            [
              [25.944583892822322, 40.24124908447277],
              [25.977083206176758, 40.216251373291186],
              [25.965972900390625, 40.15013885498047],
              [25.988470077514876, 40.14430618286133],
              [26.013748168945597, 40.163749694824446],
              [25.993749618530444, 40.131526947021484],
              [25.739027023315487, 40.09069442749018],
              [25.665136337280273, 40.12430572509777],
              [25.670694351196403, 40.15375137329124],
              [25.78513717651373, 40.210414886474666],
              [25.84291648864746, 40.21125030517601],
              [25.944583892822322, 40.24124908447277],
            ],
          ],
          [
            [
              [26.714027404785156, 40.38874816894531],
              [26.715414047241666, 40.38124847412121],
              [26.70541572570812, 40.383193969726506],
              [26.707082748413427, 40.385971069336165],
              [26.714027404785156, 40.38874816894531],
            ],
          ],
          [
            [
              [27.286527633666935, 40.47513961792015],
              [27.333749771118335, 40.41125106811529],
              [27.304861068725756, 40.400970458984375],
              [27.308750152588175, 40.371807098388786],
              [27.49319648742693, 40.307083129882756],
              [27.580728530883732, 40.31188583374029],
              [27.575317382812614, 40.27116012573242],
              [27.468250274658146, 40.19468688964855],
              [27.50711631774908, 40.125858306884766],
              [27.450334548950195, 39.98967361450195],
              [27.487668991088924, 39.96401596069347],
              [27.492630004882812, 39.93980789184599],
              [27.472572326660156, 39.88761520385759],
              [27.423446655273494, 39.829936981201286],
              [27.264280319214095, 39.7708168029788],
              [27.15715980529785, 39.81030654907238],
              [27.091777801513672, 39.81017303466808],
              [26.980264663696403, 39.78216171264654],
              [26.845289230346737, 39.71005630493164],
              [26.723983764648665, 39.715759277343864],
              [26.688920974731445, 39.697902679443416],
              [26.669155120849837, 39.65981674194347],
              [26.66930580139166, 39.55764007568371],
              [26.657917022705135, 39.55180740356451],
              [26.459581375122013, 39.521251678466854],
              [26.37624931335455, 39.49652862548828],
              [26.368194580078296, 39.480415344238395],
              [26.264862060546875, 39.483196258545036],
              [26.24180793762207, 39.46374893188471],
              [26.229858398437784, 39.474582672119254],
              [26.131250381469783, 39.45291519165039],
              [26.063194274902287, 39.47819519042969],
              [26.105693817138672, 39.58541488647472],
              [26.142360687255916, 39.612640380859375],
              [26.163473129272404, 39.659305572509936],
              [26.139862060546818, 39.75708389282255],
              [26.158472061157227, 39.776527404785156],
              [26.163751602172795, 39.81791687011719],
              [26.137083053588924, 39.840972900390625],
              [26.159305572509993, 39.88291549682623],
              [26.149858474731616, 39.91569519042963],
              [26.1773624420166, 39.98903274536127],
              [26.198194503784123, 40.00986099243164],
              [26.269582748413086, 40.0006942749024],
              [26.333194732666186, 40.02763748168951],
              [26.365972518920955, 40.10013961792015],
              [26.409860610961914, 40.119304656982365],
              [26.397361755371037, 40.145694732666016],
              [26.40875053405756, 40.1548614501956],
              [26.403194427490405, 40.19680404663086],
              [26.449028015136832, 40.1940269470216],
              [26.524583816528605, 40.21764373779297],
              [26.572639465331974, 40.2801399230957],
              [26.606527328491325, 40.28125000000023],
              [26.693195343017635, 40.35291671752941],
              [26.689861297607365, 40.365695953369254],
              [26.752359390258903, 40.40291595459007],
              [26.91319465637207, 40.406528472900504],
              [26.953193664550952, 40.38375091552746],
              [27.03319358825695, 40.38958358764643],
              [27.089860916137923, 40.442081451416186],
              [27.155138015747127, 40.4520835876466],
              [27.20513916015642, 40.4343070983889],
              [27.286527633666935, 40.47513961792015],
            ],
          ],
          [
            [
              [27.04261207580595, 40.74805068969732],
              [27.029438018799055, 40.59069442749029],
              [26.996250152588118, 40.55569458007818],
              [26.900138854980412, 40.53625106811518],
              [26.699306488037166, 40.45430374145508],
              [26.70013809204113, 40.41986083984392],
              [26.64125061035162, 40.40319442749029],
              [26.631248474121094, 40.362361907958984],
              [26.591249465942383, 40.321250915527514],
              [26.509859085083065, 40.28819274902355],
              [26.424583435058878, 40.22069549560547],
              [26.358194351196516, 40.20319366455078],
              [26.38097381591814, 40.143196105957145],
              [26.224304199218807, 40.04958343505871],
              [26.16986083984375, 40.045970916748274],
              [26.278472900390682, 40.215694427490234],
              [26.278749465942496, 40.25374984741222],
              [26.22930526733421, 40.28874969482433],
              [26.24652862548828, 40.29958343505865],
              [26.24264144897461, 40.31375122070324],
              [26.21846961975109, 40.31958389282221],
              [26.308471679687443, 40.365970611572266],
              [26.331806182861612, 40.3637504577639],
              [26.45569419860857, 40.441528320312614],
              [26.625415802002124, 40.50847244262695],
              [26.703750610351562, 40.51041793823265],
              [26.74736022949213, 40.559028625488565],
              [26.74875068664545, 40.54624938964872],
              [26.769584655761776, 40.54513931274437],
              [26.834863662719783, 40.58124923706083],
              [26.81875038146967, 40.6470832824707],
              [26.759315490722713, 40.69137954711914],
              [26.783828735351562, 40.74620056152344],
              [26.85856628417963, 40.744842529296875],
              [26.987554550170955, 40.80205917358421],
              [27.02488708496088, 40.791057586670206],
              [27.04261207580595, 40.74805068969732],
            ],
          ],
        ],
      },
      properties: {
        name: 'Çanakkale',
        label: {
          lat: 40.04927711913622,
          lng: 26.486093922258313,
        },
      },
      id: 17,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [33.78607177734375, 40.96249008178722],
            [33.82974624633795, 40.91614532470703],
            [34.03589248657232, 40.85097122192377],
            [34.057151794433594, 40.800819396972884],
            [34.04485702514654, 40.680839538574446],
            [34.10348129272472, 40.520450592041016],
            [34.15930557250982, 40.431739807129134],
            [34.15694808959961, 40.398799896240234],
            [34.1071968078615, 40.32553863525402],
            [33.96546936035162, 40.260776519775504],
            [33.718235015869425, 40.28034591674805],
            [33.40986251831072, 40.38897705078125],
            [33.364143371581974, 40.38593292236334],
            [33.330764770507756, 40.33474349975609],
            [33.2674293518067, 40.331134796142805],
            [33.22098541259771, 40.351249694824446],
            [33.17174530029314, 40.434806823730526],
            [32.96144866943371, 40.59566879272484],
            [32.65491485595709, 40.702560424804744],
            [32.50134658813505, 40.704257965088004],
            [32.539924621582145, 40.79755020141613],
            [32.519256591796875, 40.83922576904308],
            [32.587478637695256, 40.89188003540062],
            [32.6919403076173, 40.957851409912166],
            [33.027935028076456, 41.01646423339844],
            [33.07714080810564, 41.088871002197266],
            [33.18547439575207, 41.07445526123047],
            [33.2963294982913, 41.02467346191406],
            [33.349895477295206, 40.97469711303722],
            [33.40762329101591, 40.95941925048828],
            [33.8348770141601, 41.09566879272472],
            [33.85814666748041, 41.07776641845726],
            [33.86064910888672, 41.05282211303711],
            [33.791225433349666, 40.99592971801752],
            [33.78607177734375, 40.96249008178722],
          ],
        ],
      },
      properties: {
        name: 'Çankırı',
        label: {
          lat: 40.74337055557698,
          lng: 33.17236440530898,
        },
      },
      id: 18,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [34.819057464599666, 41.20172119140631],
            [34.85211944580095, 41.19771957397455],
            [34.892101287841854, 41.253662109375114],
            [34.94060516357439, 41.20204162597656],
            [34.97922515869146, 41.0832786560058],
            [35.01823425292986, 41.07475662231445],
            [35.093154907226506, 41.09054183959961],
            [35.09133148193365, 41.03227615356468],
            [35.04957199096674, 40.95141220092779],
            [35.04604339599604, 40.852909088134766],
            [35.02510070800798, 40.843399047851676],
            [35.09455871582031, 40.695533752441634],
            [35.16113281250006, 40.66824340820335],
            [35.25703811645519, 40.666099548340014],
            [35.346443176269815, 40.64120483398449],
            [35.42771530151373, 40.615207672119254],
            [35.46203994750982, 40.578224182129134],
            [35.448406219482365, 40.46772384643566],
            [35.343681335449276, 40.35832595825195],
            [35.33233642578119, 40.228908538818416],
            [35.288646697998104, 40.213741302490234],
            [35.16777420043957, 40.2132301330567],
            [35.17874526977556, 40.090763092041016],
            [35.05699539184599, 40.02979278564453],
            [34.91966629028349, 40.05079650878906],
            [34.78937911987333, 39.99235153198248],
            [34.394672393798885, 39.99183654785156],
            [34.32065582275419, 39.947689056396484],
            [34.154014587402514, 39.93353271484398],
            [34.05434417724615, 39.90491104125988],
            [34.06595611572271, 39.95508575439476],
            [34.1991729736331, 40.03972244262707],
            [34.14983749389677, 40.07336425781256],
            [34.105388641357536, 40.131149291992415],
            [34.08119583129911, 40.22275161743164],
            [33.96546936035162, 40.260776519775504],
            [34.1071968078615, 40.32553863525402],
            [34.161037445068416, 40.41214370727539],
            [34.04485702514654, 40.680839538574446],
            [34.057151794433594, 40.800819396972884],
            [34.03589248657232, 40.85097122192377],
            [34.27776718139654, 40.92724227905302],
            [34.27907180786133, 40.976325988769645],
            [34.22607040405279, 41.00858306884777],
            [34.210571289062614, 41.040046691894645],
            [34.29096221923845, 41.16743850708008],
            [34.43107604980497, 41.304927825927734],
            [34.466541290283374, 41.30647277832037],
            [34.521492004394815, 41.27654266357433],
            [34.819057464599666, 41.20172119140631],
          ],
        ],
      },
      properties: {
        name: 'Çorum',
        label: {
          lat: 40.616901960802956,
          lng: 34.5120610961828,
        },
      },
      id: 19,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.85498237609869, 38.42560577392584],
            [29.928991317749194, 38.406925201416016],
            [30.041721343994197, 38.2337265014649],
            [30.020292282104776, 38.17622375488281],
            [29.924520492553825, 38.10348129272478],
            [29.665998458862475, 37.98868942260748],
            [29.663770675659237, 37.852550506591854],
            [29.72046852111822, 37.852550506591854],
            [29.81536865234392, 37.81905364990257],
            [29.845273971557788, 37.76081848144531],
            [29.526779174804858, 37.5913848876956],
            [29.530990600586108, 37.46260452270508],
            [29.57953453063959, 37.43535614013683],
            [29.579244613647518, 37.41019439697277],
            [29.523260116577433, 37.31515121459961],
            [29.411666870117244, 37.18967819213867],
            [29.387758255004826, 37.076091766357536],
            [29.334857940673885, 37.035694122314396],
            [29.328029632568416, 36.95631408691406],
            [29.262014389038256, 36.88135910034191],
            [29.19094657897955, 36.88718414306652],
            [29.081838607788143, 36.99150466918945],
            [29.07584381103527, 37.047645568847656],
            [29.05659675598173, 37.07457733154297],
            [29.063364028930664, 37.104351043701286],
            [29.0329914093017, 37.144401550293026],
            [28.928304672241268, 37.20682525634777],
            [28.786222457886026, 37.24433517456066],
            [28.74400711059576, 37.35529327392578],
            [28.614433288574332, 37.39347839355469],
            [28.611564636230753, 37.472900390625114],
            [28.550529479980753, 37.570991516113224],
            [28.60674095153837, 37.60981369018549],
            [28.740436553955192, 37.600101470947266],
            [28.87957382202171, 37.69700241088867],
            [28.849018096923828, 37.763168334961165],
            [28.76422882080078, 37.84311676025402],
            [28.793079376220817, 37.90647888183622],
            [28.866380691528377, 37.9932594299317],
            [28.799518585205362, 38.0478324890139],
            [28.70470046997076, 38.087642669677734],
            [28.789449691772518, 38.14189910888672],
            [28.801586151123104, 38.218879699707145],
            [28.92095375061041, 38.265453338623104],
            [29.22126007080078, 38.195537567138956],
            [29.42590332031267, 38.26173400878912],
            [29.54411315917963, 38.19533920288097],
            [29.57591819763178, 38.19177246093756],
            [29.594125747680607, 38.27232742309593],
            [29.64810752868658, 38.34411239624035],
            [29.68351745605497, 38.430995941162166],
            [29.755413055419922, 38.45410919189453],
            [29.85498237609869, 38.42560577392584],
          ],
        ],
      },
      properties: {
        name: 'Denizli',
        label: {
          lat: 37.76319411114031,
          lng: 29.050774988350163,
        },
      },
      id: 20,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [41.393245697021484, 38.59392929077154],
            [41.381370544433594, 38.54735183715826],
            [41.433452606201456, 38.49269866943365],
            [41.41843032836931, 38.47577667236334],
            [41.35118865966797, 38.471626281738565],
            [41.247844696045206, 38.426227569580135],
            [41.21492385864275, 38.333042144775504],
            [41.21520614624029, 38.21622085571289],
            [41.22935867309599, 38.17604446411144],
            [41.21151351928728, 38.105602264404354],
            [41.105842590332315, 37.91629791259771],
            [41.03360366821295, 37.86264419555687],
            [41.05167770385759, 37.825115203857536],
            [41.11236953735357, 37.80470275878906],
            [41.09494400024431, 37.765148162841854],
            [41.051792144775675, 37.73957443237305],
            [40.80224990844732, 37.717403411865234],
            [40.752021789550895, 37.730331420898494],
            [40.715831756591854, 37.761577606201286],
            [40.64764404296881, 37.76625823974621],
            [40.60204696655302, 37.787681579589844],
            [40.54299545288086, 37.733390808105526],
            [40.535087585449276, 37.67518997192394],
            [40.5161018371582, 37.650424957275504],
            [40.41819000244146, 37.6458854675293],
            [40.27312088012701, 37.56756973266624],
            [40.09448623657255, 37.589130401611555],
            [40.01730346679699, 37.5563125610351],
            [39.881374359130916, 37.55633163452154],
            [39.86167144775402, 37.60364151000982],
            [39.86046981811552, 37.746318817138786],
            [39.82324218750017, 37.787952423095646],
            [39.76156616210966, 37.83341598510742],
            [39.66156768798834, 37.84016799926769],
            [39.41362762451183, 37.995002746581974],
            [39.25479507446295, 37.99920654296875],
            [39.17874908447283, 38.030654907226676],
            [39.22737503051769, 38.07843399047863],
            [39.24422836303711, 38.172023773193416],
            [39.20501708984369, 38.19129943847656],
            [39.160182952880916, 38.17333602905296],
            [39.11173629760748, 38.18469238281273],
            [39.14226913452154, 38.27321624755865],
            [39.119144439697436, 38.33825683593756],
            [39.26699066162138, 38.36811065673828],
            [39.33853530883795, 38.33818817138672],
            [39.39870071411161, 38.33542633056652],
            [39.57147216796892, 38.36953735351568],
            [39.73397445678722, 38.37126541137695],
            [39.81111526489275, 38.4249267578125],
            [39.86201477050787, 38.49816513061546],
            [40.05464172363287, 38.475044250488395],
            [40.437953948974666, 38.476139068603516],
            [40.466030120849894, 38.492721557617415],
            [40.497112274170206, 38.5901451110841],
            [40.52542114257824, 38.61225128173828],
            [40.91010284423834, 38.59239578247093],
            [41.26630401611328, 38.72560119628912],
            [41.371963500976506, 38.6430358886721],
            [41.393245697021484, 38.59392929077154],
          ],
        ],
      },
      properties: {
        name: 'Diyarbakır',
        label: {
          lat: 38.16223225038511,
          lng: 40.04102577041725,
        },
      },
      id: 21,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.339487075805778, 41.13582611083979],
            [31.43902778625494, 41.05629730224604],
            [31.736297607421932, 41.042720794677734],
            [31.75791931152355, 41.01557540893549],
            [31.757904052734432, 40.987693786621094],
            [31.735439300537166, 40.94449996948248],
            [31.668218612671012, 40.904876708984375],
            [31.60422897338873, 40.8813362121582],
            [31.469253540039233, 40.87095642089844],
            [31.43151664733898, 40.805057525634766],
            [31.42705917358404, 40.70133590698265],
            [31.36094474792492, 40.66146087646496],
            [31.264896392822322, 40.646827697753906],
            [31.190750122070483, 40.68179702758789],
            [31.026567459106445, 40.65954208374029],
            [30.954557418823242, 40.682250976562614],
            [30.986114501953296, 40.72135162353527],
            [30.89267539978033, 40.77858734130854],
            [30.87307357788086, 40.82920074462896],
            [30.906887054443416, 40.897171020507926],
            [31.00865745544445, 40.961486816406364],
            [31.03475379943842, 41.00601959228521],
            [30.97593688964872, 41.072639465332145],
            [31.217081069946573, 41.09791564941406],
            [31.339487075805778, 41.13582611083979],
          ],
        ],
      },
      properties: {
        name: 'Düzce',
        label: {
          lat: 40.93740747412791,
          lng: 31.14904193300502,
        },
      },
      id: 81,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [26.738752365112646, 40.61902618408209],
              [26.740417480468807, 40.61264038085932],
              [26.730972290039404, 40.614582061767635],
              [26.732084274292163, 40.61680603027355],
              [26.738752365112646, 40.61902618408209],
            ],
          ],
          [
            [
              [26.75652694702154, 40.62208175659174],
              [26.758472442627408, 40.6198616027832],
              [26.75430488586443, 40.61875152587885],
              [26.754581451416016, 40.62152862548851],
              [26.75652694702154, 40.62208175659174],
            ],
          ],
          [
            [
              [26.03069496154785, 40.75374984741211],
              [26.030689239502294, 40.752361297607365],
              [26.031805038452205, 40.749584197998104],
              [26.030139923095703, 40.75152587890625],
              [26.03069496154785, 40.75374984741211],
            ],
          ],
          [
            [
              [26.010969161987703, 40.78958892822294],
              [26.021804809570256, 40.779304504394645],
              [26.026807785034407, 40.77236175537132],
              [26.02736091613781, 40.76903152465843],
              [26.010969161987703, 40.78958892822294],
            ],
          ],
          [
            [
              [26.97304725646967, 41.972370147705135],
              [26.988868713378906, 41.91792678833019],
              [26.953647613525334, 41.73678207397461],
              [26.9095973968507, 41.679828643798885],
              [26.921703338623104, 41.65630340576183],
              [26.997392654419002, 41.62268066406273],
              [26.99989509582548, 41.55601119995123],
              [26.919303894043196, 41.46986007690441],
              [26.87914657592796, 41.388225555420036],
              [26.898347854614258, 41.34303283691406],
              [26.89655685424833, 41.294040679931584],
              [26.93860054016136, 41.23728561401373],
              [26.93921089172369, 41.195243835449446],
              [26.89196395874029, 41.13861846923834],
              [26.772720336914176, 41.10102081298851],
              [26.744598388671932, 41.060417175293026],
              [26.74397468566889, 41.03450775146496],
              [26.783018112182617, 40.999576568603516],
              [26.730768203735806, 40.902725219726676],
              [26.728576660156307, 40.814212799072266],
              [26.783828735351562, 40.74620056152344],
              [26.759315490722713, 40.69137954711914],
              [26.79263877868658, 40.65680694580101],
              [26.609861373901367, 40.63680648803711],
              [26.533750534057617, 40.591251373291016],
              [26.461250305175724, 40.61680603027355],
              [26.414026260376318, 40.59847259521513],
              [26.374305725097997, 40.60819625854492],
              [26.304027557373217, 40.5904159545899],
              [26.124584197998047, 40.59097290039085],
              [26.088472366333008, 40.60819625854492],
              [26.060972213745174, 40.63763809204124],
              [26.06236076354992, 40.68319320678734],
              [26.031528472900618, 40.73390197753935],
              [26.125116348267, 40.754512786865234],
              [26.157695770263615, 40.814674377441406],
              [26.21730995178251, 40.836658477783146],
              [26.201379776000977, 40.85223388671875],
              [26.228288650512695, 40.89812088012695],
              [26.24975585937517, 40.891414642333984],
              [26.264711380004883, 40.921726226806584],
              [26.29023361206066, 40.899761199951286],
              [26.301431655884073, 40.91019821167015],
              [26.28898620605497, 40.93489837646507],
              [26.353076934814453, 40.95466613769531],
              [26.323467254638842, 40.98362731933588],
              [26.35173606872553, 41.00104141235363],
              [26.35911369323759, 41.02755355834972],
              [26.319107055664347, 41.063545227050724],
              [26.327295303344954, 41.11148834228521],
              [26.309978485107422, 41.1176376342774],
              [26.33097839355463, 41.14646530151384],
              [26.306446075439567, 41.175109863281364],
              [26.331590652465934, 41.254291534424055],
              [26.410427093505803, 41.258857727050724],
              [26.528671264648665, 41.346923828125114],
              [26.592201232910213, 41.32866668701166],
              [26.63687133789091, 41.356079101562614],
              [26.63391494751005, 41.4283981323245],
              [26.60487937927246, 41.491004943847656],
              [26.596136093139876, 41.61547088623058],
              [26.536483764648665, 41.62702560424816],
              [26.496963500976562, 41.669059753418026],
              [26.368787765503157, 41.71422958374018],
              [26.33962821960455, 41.75893020629883],
              [26.377365112304858, 41.83274078369152],
              [26.54617881774925, 41.84154891967796],
              [26.581527709960994, 41.87805175781256],
              [26.58583641052269, 41.90520477294933],
              [26.569192886352596, 41.92753219604492],
              [26.623439788818644, 41.976928710937614],
              [26.751115798950423, 41.95451354980486],
              [26.781169891357706, 41.97798538208019],
              [26.838518142700252, 41.969402313232536],
              [26.865001678466797, 41.98744964599621],
              [26.97284698486328, 42.00579452514654],
              [26.97304725646967, 41.972370147705135],
            ],
          ],
        ],
      },
      properties: {
        name: 'Edirne',
        label: {
          lat: 41.199716394366035,
          lng: 26.36017407469721,
        },
      },
      id: 22,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [40.34999847412104, 39.10704803466797],
            [40.28809738159208, 39.05596542358393],
            [40.28541564941412, 38.95002746582031],
            [40.320285797119254, 38.86981201171898],
            [40.357448577880916, 38.85798263549799],
            [40.38602828979498, 38.80131912231457],
            [40.35682296752947, 38.725006103515625],
            [40.28368759155302, 38.723560333252124],
            [40.239067077636776, 38.63198089599615],
            [40.23947143554693, 38.60807037353533],
            [40.29603576660156, 38.55552673339855],
            [40.29214859008806, 38.47479248046898],
            [40.05464172363287, 38.475044250488395],
            [39.86201477050787, 38.49816513061546],
            [39.81111526489275, 38.4249267578125],
            [39.73397445678722, 38.37126541137695],
            [39.57147216796892, 38.36953735351568],
            [39.39870071411161, 38.33542633056652],
            [39.33853530883795, 38.33818817138672],
            [39.26699066162138, 38.36811065673828],
            [38.968620300293026, 38.30895233154291],
            [38.8217391967774, 38.40439605712896],
            [38.684249877929744, 38.41202545166021],
            [38.525379180908374, 38.46200180053722],
            [38.429889678955135, 38.47502899169933],
            [38.37929534912138, 38.512310028076286],
            [38.34922790527361, 38.57312011718744],
            [38.38140487670904, 38.64058303833008],
            [38.471988677978686, 38.736061096191406],
            [38.62973022460966, 38.75020980834955],
            [38.631317138672046, 38.876541137695426],
            [38.58731842041021, 38.97253036499046],
            [38.613189697265625, 39.010799407958984],
            [38.68186950683611, 39.00462722778332],
            [38.753204345703296, 39.03481674194336],
            [38.783012390136776, 38.987480163574276],
            [38.769435882568644, 38.89875411987316],
            [38.808502197265625, 38.87729644775402],
            [39.048492431640625, 38.89308929443382],
            [39.49058151245123, 38.749164581299055],
            [39.63027191162115, 38.80181884765625],
            [39.727626800537166, 38.803623199462834],
            [39.80643463134783, 38.83753585815441],
            [39.891315460205135, 38.9417343139649],
            [39.89322280883795, 38.99279022216797],
            [39.86791610717768, 39.045005798339844],
            [39.9225807189942, 39.08842849731445],
            [40.028297424316406, 39.094463348388786],
            [40.13597869873075, 39.14826583862316],
            [40.359775543213004, 39.226669311523665],
            [40.39783859252947, 39.15583801269531],
            [40.34999847412104, 39.10704803466797],
          ],
        ],
      },
      properties: {
        name: 'Elazığ',
        label: {
          lat: 38.607534275553675,
          lng: 39.11010219631108,
        },
      },
      id: 23,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [40.26528167724638, 39.90684127807617],
            [40.4804420471192, 39.906944274902344],
            [40.509937286376896, 39.89397811889654],
            [40.53995132446295, 39.844947814941406],
            [40.530143737793026, 39.79112625122076],
            [40.563358306884766, 39.751308441162166],
            [40.69152832031256, 39.690715789795036],
            [40.6196174621582, 39.579704284668026],
            [40.62028884887701, 39.52821731567377],
            [40.54322814941406, 39.54778289794922],
            [40.142089843750284, 39.5576286315918],
            [39.986354827881144, 39.51869201660179],
            [39.88587951660162, 39.54994583129911],
            [39.77057266235357, 39.51818084716808],
            [39.69773864746111, 39.45171737670927],
            [39.66516876220709, 39.441463470458984],
            [39.618003845215014, 39.444042205810604],
            [39.60741424560558, 39.481758117676065],
            [39.585163116455135, 39.48873519897455],
            [39.477455139160156, 39.4769744873048],
            [39.31540298461931, 39.49990081787104],
            [39.153591156006144, 39.47578430175804],
            [39.097686767578296, 39.46172332763683],
            [38.96605682373064, 39.37565994262695],
            [38.819885253906534, 39.31785202026367],
            [38.79290771484375, 39.27995681762701],
            [38.833896636963004, 39.257617950439624],
            [38.92637634277344, 39.25006484985357],
            [38.917270660400675, 39.22851943969738],
            [38.7714576721192, 39.18029785156256],
            [38.72623825073259, 39.113128662109375],
            [38.753204345703296, 39.03481674194336],
            [38.68186950683611, 39.00462722778332],
            [38.65647125244135, 39.05071258544916],
            [38.617038726806925, 39.079467773437614],
            [38.52343368530268, 39.11494064331055],
            [38.416332244873104, 39.11750030517578],
            [38.35454559326172, 39.13976669311529],
            [38.39357757568371, 39.213386535644645],
            [38.39641189575195, 39.41117095947277],
            [38.34907150268583, 39.5365562438966],
            [38.366264343261776, 39.683441162109375],
            [38.413822174072266, 39.746189117431754],
            [38.43944168090826, 39.75685119628906],
            [38.450466156005916, 39.7869110107423],
            [38.52255249023466, 39.797157287597884],
            [38.554382324219034, 39.826526641845646],
            [38.52223587036144, 39.84823226928722],
            [38.402069091797046, 39.82606506347656],
            [38.36834716796881, 39.837001800537394],
            [38.38290023803728, 39.89551925659191],
            [38.447406768798885, 39.96938323974615],
            [38.72418212890619, 39.956573486328125],
            [38.75243377685564, 39.97180938720703],
            [38.77371978759777, 40.04879760742199],
            [38.92853927612333, 40.062679290771484],
            [39.11577224731451, 40.01247024536144],
            [39.11574554443388, 40.000827789306754],
            [39.384086608887, 39.88770294189453],
            [39.47190856933611, 39.87245178222673],
            [39.75101470947271, 39.911785125732365],
            [39.879669189453125, 40.00830078125023],
            [40.121814727783374, 40.069835662841854],
            [40.28641510009771, 40.039066314697266],
            [40.24314117431652, 39.947322845458984],
            [40.26528167724638, 39.90684127807617],
          ],
        ],
      },
      properties: {
        name: 'Erzincan',
        label: {
          lat: 39.77425575536759,
          lng: 38.9435164614704,
        },
      },
      id: 24,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [42.33081436157232, 40.982887268066406],
            [42.332916259765796, 40.924530029296875],
            [42.37902069091825, 40.83445358276373],
            [42.491706848144645, 40.721416473388786],
            [42.567897796630916, 40.614326477050895],
            [42.538536071777514, 40.44420623779325],
            [42.509208679199276, 40.40768432617193],
            [42.271778106689624, 40.31632232666021],
            [42.14982986450224, 40.28962326049816],
            [42.13726806640631, 40.26054382324213],
            [42.205627441406534, 40.16657257080078],
            [42.36748123168974, 40.13149261474615],
            [42.498966217041186, 40.041206359863224],
            [42.55170440673845, 39.97406005859369],
            [42.566364288330135, 39.94755172729515],
            [42.40620422363287, 39.873390197753906],
            [42.2776527404788, 39.88196563720703],
            [42.25519943237322, 39.861167907714844],
            [42.285240173340014, 39.81406784057623],
            [42.49176406860357, 39.75294876098633],
            [42.50790786743181, 39.72431564331055],
            [42.523639678955135, 39.56861877441406],
            [42.47146987915039, 39.488586425781364],
            [42.32644271850597, 39.459419250488395],
            [42.21374511718756, 39.40992355346691],
            [42.19287490844732, 39.381523132324276],
            [42.22022247314453, 39.34602355957048],
            [42.218486785888786, 39.32173919677746],
            [42.074256896972656, 39.222366333007926],
            [41.83882522583025, 39.162235260009766],
            [41.72012329101568, 39.17336654663109],
            [41.64963912963867, 39.20930862426752],
            [41.515937805176065, 39.33350372314459],
            [41.386318206787394, 39.383571624755916],
            [41.2186927795413, 39.35533905029297],
            [41.1310348510745, 39.45877838134771],
            [41.02952194213884, 39.46599578857439],
            [40.94934082031267, 39.508766174316634],
            [40.90058135986334, 39.55487060546875],
            [40.856491088867244, 39.56525802612305],
            [40.68346405029314, 39.51169967651373],
            [40.62548446655302, 39.524215698242415],
            [40.6196174621582, 39.579704284668026],
            [40.69152832031256, 39.690715789795036],
            [40.563358306884766, 39.751308441162166],
            [40.530143737793026, 39.79112625122076],
            [40.53995132446295, 39.844947814941406],
            [40.509937286376896, 39.89397811889654],
            [40.4804420471192, 39.906944274902344],
            [40.26528167724638, 39.90684127807617],
            [40.244785308838175, 39.93095779418968],
            [40.28641510009771, 40.039066314697266],
            [40.48427581787104, 40.026412963867244],
            [40.64613723754883, 40.11261749267584],
            [40.75914382934576, 40.15104293823248],
            [40.79587173461931, 40.198104858398494],
            [40.78182983398432, 40.23067092895519],
            [40.63780975341825, 40.245708465576286],
            [40.59257507324247, 40.26642990112305],
            [40.58805847167969, 40.29078292846674],
            [40.559944152832145, 40.30656433105486],
            [40.52688598632818, 40.48198318481451],
            [40.4984970092774, 40.535331726074276],
            [40.82793426513683, 40.65369033813488],
            [41.12230682373047, 40.80845260620117],
            [41.199081420898494, 40.78024673461914],
            [41.3855819702149, 40.77217483520536],
            [41.39697265625017, 40.74471664428722],
            [41.33960342407255, 40.6501579284668],
            [41.362621307373104, 40.57928466796875],
            [41.428695678710994, 40.563056945800724],
            [41.65904998779314, 40.66276931762695],
            [41.71423721313471, 40.66050338745123],
            [41.83464050292997, 40.61849594116211],
            [41.90903854370117, 40.646457672119254],
            [41.973175048828125, 40.85636520385742],
            [42.01268005371111, 40.93065643310547],
            [42.09929656982422, 40.963840484619254],
            [42.273120880127124, 40.9653129577639],
            [42.33081436157232, 40.982887268066406],
          ],
        ],
      },
      properties: {
        name: 'Erzurum',
        label: {
          lat: 39.96897813601216,
          lng: 41.13709650205734,
        },
      },
      id: 25,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.972843170166186, 40.018688201904354],
            [31.175989151001033, 40.04402542114258],
            [31.617036819458292, 40.01634979248058],
            [31.695951461791992, 39.98823165893566],
            [31.797164916992244, 39.8831901550293],
            [31.857683181762752, 39.87451553344749],
            [31.88599014282238, 39.808479309082145],
            [31.847255706787166, 39.76829147338873],
            [31.849052429199276, 39.730388641357536],
            [31.896219253540096, 39.63234329223661],
            [31.995899200439737, 39.49590301513672],
            [32.0114288330081, 39.312587738037166],
            [31.991197586059627, 39.22510147094738],
            [31.86066818237333, 39.167995452880916],
            [31.838905334472656, 39.106754302978516],
            [31.77247047424345, 39.07804870605469],
            [31.6680526733399, 39.0982398986817],
            [31.471307754516886, 39.0867462158206],
            [31.386358261108683, 39.11867141723644],
            [31.30526924133318, 39.273185729980526],
            [31.24177551269537, 39.28451919555664],
            [31.141860961914347, 39.218502044677734],
            [30.989156723022518, 39.15921020507824],
            [30.885963439941577, 39.21287155151373],
            [30.799478530883846, 39.172389984130916],
            [30.766630172729776, 39.12854385375999],
            [30.618543624877987, 39.07700729370117],
            [30.533037185669002, 39.139522552490234],
            [30.50550842285162, 39.189422607421875],
            [30.45332908630388, 39.20599746704107],
            [30.41478919982916, 39.28709411621094],
            [30.321493148803654, 39.361034393310604],
            [30.314607620239315, 39.483478546142635],
            [30.13921356201172, 39.62137222290045],
            [30.18699836730957, 39.69670867919933],
            [30.044765472412166, 39.693233489990234],
            [30.000635147094897, 39.73457717895536],
            [30.002716064453182, 39.78552246093773],
            [30.0730113983156, 39.852836608886776],
            [30.136020660400675, 39.86830139160179],
            [30.248657226562784, 39.85490798950207],
            [30.35621070861822, 39.9370231628418],
            [30.427679061889762, 39.9382896423341],
            [30.482061386108683, 39.96120071411133],
            [30.523212432861612, 40.00673294067394],
            [30.571363449096623, 40.14687728881859],
            [30.726753234863338, 40.171913146972656],
            [30.859945297241154, 40.14501571655285],
            [30.913637161254826, 40.0991401672365],
            [30.921283721924112, 40.03337478637701],
            [30.972843170166186, 40.018688201904354],
          ],
        ],
      },
      properties: {
        name: 'Eskişehir',
        label: {
          lat: 39.62730525228934,
          lng: 30.764861186242143,
        },
      },
      id: 26,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [37.91703033447283, 37.511512756347656],
            [37.991966247558594, 37.491725921631144],
            [38.05150604248064, 37.43758773803711],
            [37.98842239379877, 37.43914031982433],
            [37.93680572509794, 37.40411758422874],
            [37.84837341308611, 37.312484741210994],
            [37.83034515380871, 37.24394226074219],
            [37.880939483642635, 37.057415008545036],
            [37.97619247436552, 36.97856521606451],
            [38.01262283325224, 36.92795562744146],
            [38.010631561279354, 36.825210571289176],
            [37.908031463623104, 36.785701751708984],
            [37.79120635986334, 36.74859619140642],
            [37.65513992309576, 36.731410980224666],
            [37.50850296020536, 36.65539550781256],
            [37.435653686523494, 36.78142929077177],
            [37.24035644531256, 36.86549377441406],
            [37.19807815551758, 36.965221405029524],
            [37.14458847045927, 37.00689315795893],
            [37.01332473754894, 37.010478973388786],
            [36.97225952148466, 36.993789672851676],
            [36.90999221801786, 36.902648925781364],
            [36.792087554931925, 36.843338012695256],
            [36.7839546203615, 36.806518554687614],
            [36.6755447387697, 36.84560012817383],
            [36.62614440917986, 36.84095001220709],
            [36.442592620849666, 36.95328521728521],
            [36.539062500000114, 37.113624572753906],
            [36.728641510009936, 37.27605056762695],
            [36.89641189575207, 37.365814208984546],
            [36.92829513549833, 37.349662780761946],
            [36.9666366577149, 37.230720520019474],
            [37.01084136962908, 37.217384338378906],
            [37.04829406738287, 37.23469924926758],
            [37.089210510253906, 37.28264236450207],
            [37.18589782714838, 37.332862854004134],
            [37.59473419189459, 37.39747619628923],
            [37.621623992920206, 37.43280792236351],
            [37.62296295166021, 37.51213455200224],
            [37.679069519043026, 37.512031555175895],
            [37.77766036987299, 37.54558563232433],
            [37.91703033447283, 37.511512756347656],
          ],
        ],
      },
      properties: {
        name: 'Gaziantep',
        label: {
          lat: 37.1763105476896,
          lng: 37.05582233694022,
        },
      },
      id: 27,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [38.43736267089861, 40.92986297607422],
              [38.43847274780279, 40.928470611572266],
              [38.43513870239275, 40.928749084472656],
              [38.4356956481933, 40.93069458007835],
              [38.43736267089861, 40.92986297607422],
            ],
          ],
          [
            [
              [39.163471221923885, 41.07930374145508],
              [39.17869949340826, 41.07402801513666],
              [39.14806747436552, 41.03693771362299],
              [39.11791610717802, 40.95093536376959],
              [39.1192893981933, 40.8454208374024],
              [39.14960861206049, 40.775512695312784],
              [39.10797882080095, 40.758464813232365],
              [39.02652740478533, 40.75756072998058],
              [38.952190399170206, 40.711280822753906],
              [38.84720993041998, 40.561927795410156],
              [38.85500335693388, 40.46141433715826],
              [38.983440399170206, 40.42817306518555],
              [39.0709877014163, 40.364284515380916],
              [39.04844284057623, 40.333206176757926],
              [38.961185455322266, 40.29854965209972],
              [38.909038543701286, 40.25615692138666],
              [38.90629959106445, 40.14979553222656],
              [38.950401306152344, 40.09682083129883],
              [38.93473052978544, 40.06813430786144],
              [38.86236953735346, 40.04825973510765],
              [38.77371978759777, 40.04879760742199],
              [38.57074737548834, 40.116062164306584],
              [38.45939254760759, 40.09647750854492],
              [38.251918792724666, 40.19630432128906],
              [38.228839874267635, 40.32080459594732],
              [38.15539932250982, 40.528263092041016],
              [38.11658096313505, 40.6118354797365],
              [38.00863647460943, 40.748332977295206],
              [38.123195648193416, 40.95513916015631],
              [38.20041656494135, 40.93791580200207],
              [38.28319549560541, 40.94513702392578],
              [38.35625076293951, 40.90902709960966],
              [38.389583587646655, 40.92430496215843],
              [38.4298629760745, 40.911251068115405],
              [38.52902603149414, 40.916526794433594],
              [38.62347412109369, 40.97319412231457],
              [38.67486190795927, 40.949028015136776],
              [38.714862823486385, 40.95069503784191],
              [38.81652832031267, 41.01152801513672],
              [38.87152862548834, 41.01124954223633],
              [38.93347167968767, 41.04375076293957],
              [39.05291748046881, 41.036804199218864],
              [39.163471221923885, 41.07930374145508],
            ],
          ],
        ],
      },
      properties: {
        name: 'Giresun',
        label: {
          lat: 40.630429226469296,
          lng: 38.29468775037353,
        },
      },
      id: 28,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [39.17561721801758, 40.76031875610363],
            [39.313480377197436, 40.66615295410179],
            [39.65062713623064, 40.5599250793457],
            [39.72409057617193, 40.57740783691423],
            [39.766292572021655, 40.67451095581066],
            [39.80594635009771, 40.71657562255888],
            [39.84022521972673, 40.69247055053705],
            [39.831077575683594, 40.618892669677905],
            [39.89093780517595, 40.61500549316412],
            [39.92637252807623, 40.573833465576115],
            [39.96866989135759, 40.560638427734375],
            [39.99657058715826, 40.591430664062614],
            [39.97467422485363, 40.63690185546875],
            [40.004878997802734, 40.65853500366211],
            [40.10813140869169, 40.57054519653332],
            [40.07474136352539, 40.466796875],
            [40.04135513305681, 40.4155731201173],
            [39.988433837890625, 40.36897277832037],
            [39.88367080688482, 40.3472251892091],
            [39.85456085205084, 40.3255500793457],
            [39.82343292236345, 40.249820709228686],
            [39.82063674926758, 40.15822982788086],
            [39.80493545532255, 40.120574951171875],
            [39.74072265625006, 40.07666397094732],
            [39.69057846069353, 40.01388931274414],
            [39.7164382934572, 39.96063232421898],
            [39.78475570678705, 39.931087493896484],
            [39.77601242065447, 39.923477172851676],
            [39.6178817749024, 39.88530349731445],
            [39.438926696777344, 39.87340545654314],
            [39.26388931274431, 39.934585571289006],
            [39.11574554443388, 40.000827789306754],
            [39.11577224731451, 40.01247024536144],
            [38.92853927612333, 40.062679290771484],
            [38.950401306152344, 40.09682083129883],
            [38.90629959106445, 40.14979553222656],
            [38.909038543701286, 40.25615692138666],
            [38.961185455322266, 40.29854965209972],
            [39.04844284057623, 40.333206176757926],
            [39.0709877014163, 40.364284515380916],
            [38.983440399170206, 40.42817306518555],
            [38.85500335693388, 40.46141433715826],
            [38.84974288940458, 40.57057571411144],
            [38.928970336914176, 40.69153594970709],
            [39.02652740478533, 40.75756072998058],
            [39.10797882080095, 40.758464813232365],
            [39.14960861206049, 40.775512695312784],
            [39.17561721801758, 40.76031875610363],
          ],
        ],
      },
      properties: {
        name: 'Gümüşhane',
        label: {
          lat: 40.48227100054565,
          lng: 39.06443376787287,
        },
      },
      id: 29,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [44.23672103881836, 37.72581100463867],
            [44.24645996093756, 37.6920623779298],
            [44.21875762939459, 37.64070129394537],
            [44.24623870849615, 37.62623977661133],
            [44.32952880859392, 37.65622329711914],
            [44.428737640381144, 37.64877700805664],
            [44.51017761230486, 37.6978836059572],
            [44.57461929321295, 37.767143249511776],
            [44.610614776611385, 37.75423049926758],
            [44.63830184936529, 37.716304779052734],
            [44.58086013793951, 37.64654159545921],
            [44.63534164428705, 37.608364105224666],
            [44.638813018799, 37.57563018798828],
            [44.616718292236385, 37.55250549316406],
            [44.62445068359381, 37.48171997070324],
            [44.6026153564456, 37.444278717041016],
            [44.662406921386776, 37.427494049072266],
            [44.68934249877947, 37.38499069213867],
            [44.73342895507841, 37.37773895263683],
            [44.82329940795904, 37.307567596435604],
            [44.83383941650408, 37.27449417114252],
            [44.7782096862793, 37.224006652832145],
            [44.80496597290039, 37.148143768310774],
            [44.77106475830078, 37.16749191284174],
            [44.63774108886719, 37.186740875244425],
            [44.51138305664068, 37.09354782104492],
            [44.3506813049317, 37.04928588867199],
            [44.365116119384936, 37.026351928711165],
            [44.31998062133795, 36.96705627441412],
            [44.268787384033374, 36.98297119140625],
            [44.24353790283203, 37.026706695556754],
            [44.246902465820256, 37.05009460449213],
            [44.20225143432623, 37.098056793213004],
            [44.24228286743181, 37.1566619873048],
            [44.26858520507818, 37.155235290527344],
            [44.29009628295927, 37.17499923706055],
            [44.278858184814396, 37.23628234863281],
            [44.237377166748104, 37.27907180786127],
            [44.14183807373064, 37.315654754638786],
            [44.03302764892584, 37.32502746582037],
            [43.970607757568644, 37.286735534668026],
            [43.9512672424317, 37.25539779663097],
            [43.896213531494425, 37.23456192016607],
            [43.66655731201189, 37.23086547851574],
            [43.5009841918947, 37.26836013793957],
            [43.43782043457031, 37.33258056640619],
            [43.436573028564396, 37.52254486083979],
            [43.49570465087896, 37.72740173339838],
            [43.67584609985357, 37.715328216552734],
            [43.78456878662104, 37.726203918457145],
            [43.892715454101506, 37.700431823730526],
            [43.96967315673834, 37.7267951965332],
            [44.0651931762697, 37.71755218505865],
            [44.20137023925798, 37.76893234252947],
            [44.23672103881836, 37.72581100463867],
          ],
        ],
      },
      properties: {
        name: 'Hakkari',
        label: {
          lat: 37.5102583063504,
          lng: 43.865873767673655,
        },
      },
      id: 30,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [36.185138702392635, 36.724304199219034],
              [36.188751220703125, 36.72319412231468],
              [36.188751220703125, 36.72263717651373],
              [36.18597412109381, 36.72236251831055],
              [36.185138702392635, 36.724304199219034],
            ],
          ],
          [
            [
              [36.06156921386736, 37.023487091064396],
              [36.254726409912166, 37.008663177490405],
              [36.34716796875006, 36.95531463623064],
              [36.442592620849666, 36.953285217285384],
              [36.62614440917986, 36.84095001220709],
              [36.66854476928711, 36.836769104004134],
              [36.678554534912166, 36.81852340698248],
              [36.62707138061529, 36.757701873779524],
              [36.63688278198242, 36.705108642578296],
              [36.588047027587834, 36.63603973388672],
              [36.59989166259771, 36.56200408935541],
              [36.552886962890796, 36.49698257446312],
              [36.58913803100597, 36.397804260253906],
              [36.62255859375006, 36.39120101928705],
              [36.627742767334155, 36.354164123535156],
              [36.60783767700224, 36.32987976074213],
              [36.666233062744425, 36.33023071289074],
              [36.6710968017581, 36.3023567199707],
              [36.70032882690441, 36.29220581054693],
              [36.70477294921881, 36.250331878662166],
              [36.6183509826663, 36.2165908813476],
              [36.58386230468756, 36.23211288452177],
              [36.495422363281534, 36.23447036743181],
              [36.47106552124035, 36.20180130004877],
              [36.39754867553728, 36.2232398986817],
              [36.40058135986334, 36.1914634704591],
              [36.37670516967768, 36.16939544677757],
              [36.39784240722673, 36.08376312255865],
              [36.378593444824276, 36.00100326538086],
              [36.3441696166995, 35.99237442016596],
              [36.31720352172846, 36.004100799560604],
              [36.29788970947283, 35.991699218750114],
              [36.30253219604492, 35.957408905029354],
              [36.212722778320426, 35.95149230957031],
              [36.180915832519474, 35.90173721313488],
              [36.18305206298845, 35.83557128906256],
              [36.16907119750982, 35.815425872802905],
              [36.11644744873041, 35.865512847900504],
              [36.01867675781256, 35.881103515625],
              [36.02288818359381, 35.92449951171881],
              [36.008483886719034, 35.94030761718773],
              [35.935798645019815, 35.91867446899437],
              [35.918472290039006, 35.93233108520508],
              [35.97902679443365, 36.01902770996094],
              [35.89680480957037, 36.15791702270536],
              [35.780418395996264, 36.2987518310548],
              [35.780971527099666, 36.32236099243164],
              [35.815971374511776, 36.36041641235374],
              [35.85347366333019, 36.36902618408203],
              [35.860416412353686, 36.39569473266624],
              [35.895973205566406, 36.41541671752941],
              [35.90958404541021, 36.44513702392595],
              [35.982639312744425, 36.47430419921875],
              [36.03680419921881, 36.533748626708984],
              [36.14875030517578, 36.59069442749052],
              [36.194583892822436, 36.59597396850609],
              [36.21569442749052, 36.65930557250982],
              [36.19263839721708, 36.70513916015648],
              [36.20208358764654, 36.727085113525334],
              [36.18708419799833, 36.72902679443365],
              [36.205970764160156, 36.78236007690441],
              [36.14847183227545, 36.85514068603527],
              [36.129585266113565, 36.853195190429744],
              [36.14069366455095, 36.862083435058764],
              [36.085693359375114, 36.90513992309593],
              [36.01708221435541, 36.930137634277344],
              [35.93763732910162, 36.8865318298341],
              [35.94486236572271, 36.874305725097656],
              [35.945693969726676, 36.86430740356451],
              [35.913639068603686, 36.8955192565918],
              [35.95418167114269, 36.96366119384777],
              [36.04160690307617, 37.025554656982536],
              [36.06156921386736, 37.023487091064396],
            ],
          ],
        ],
      },
      properties: {
        name: 'Hatay',
        label: {
          lat: 36.3337044499222,
          lng: 35.9609948319641,
        },
      },
      id: 31,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [43.69572830200207, 40.18729782104498],
            [43.71363067626953, 40.166362762451286],
            [43.655036926269815, 40.14826202392578],
            [43.655479431152514, 40.11077117919933],
            [43.718761444091854, 40.07968521118181],
            [43.769920349121264, 40.0795211791995],
            [43.90547943115263, 40.01846694946289],
            [44.282360076904354, 40.04839324951183],
            [44.48470687866228, 39.96729660034174],
            [44.557548522949276, 39.903785705566634],
            [44.601554870605526, 39.82548522949213],
            [44.62551116943354, 39.828296661377124],
            [44.62156677246111, 39.815410614013786],
            [44.67524337768572, 39.787746429443416],
            [44.69823455810564, 39.793563842773494],
            [44.7006912231447, 39.767551422119254],
            [44.7176055908206, 39.76768493652338],
            [44.812736511230526, 39.6770133972168],
            [44.82022094726591, 39.62520980834984],
            [44.72192764282221, 39.70727539062517],
            [44.656444549560604, 39.73276519775419],
            [44.623455047607536, 39.77722167968744],
            [44.49647140502958, 39.69598007202171],
            [44.25063323974615, 39.67041397094749],
            [44.15977859497082, 39.69419860839855],
            [43.99331665039068, 39.686500549316406],
            [43.74055480957048, 39.79948043823242],
            [43.62248992919939, 39.82235717773443],
            [43.5319442749024, 39.820419311523494],
            [43.47832870483427, 39.766723632812614],
            [43.39422988891596, 39.79460525512701],
            [43.39402008056646, 39.93553543090843],
            [43.375995635986385, 39.959014892578125],
            [43.35047149658203, 39.9627571105957],
            [43.34629821777361, 39.99917984008789],
            [43.293140411376896, 40.06836318969755],
            [43.297000885009936, 40.09724807739258],
            [43.315303802490405, 40.11288452148449],
            [43.38040161132807, 40.11241149902344],
            [43.393310546875114, 40.13174819946289],
            [43.38365554809576, 40.16720962524414],
            [43.411888122558594, 40.18202590942394],
            [43.563655853271655, 40.18433761596691],
            [43.66280746459978, 40.218669891357536],
            [43.69572830200207, 40.18729782104498],
          ],
        ],
      },
      properties: {
        name: 'Iğdır',
        label: {
          lat: 39.941739073207934,
          lng: 43.8459176563722,
        },
      },
      id: 76,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.45230293273943, 37.852764129638786],
            [31.450740814209098, 37.77799987792969],
            [31.336086273193416, 37.43759536743164],
            [31.323301315307617, 37.42438888549816],
            [31.231279373169002, 37.420497894287166],
            [31.17972755432129, 37.389701843261946],
            [30.996772766113452, 37.342758178710994],
            [30.915895462036417, 37.37248611450207],
            [30.889757156372355, 37.42609786987316],
            [30.76529884338396, 37.52559661865229],
            [30.70260238647461, 37.6779670715332],
            [30.651264190674, 37.700595855712834],
            [30.50423812866211, 37.7170295715332],
            [30.41355323791521, 37.77392959594732],
            [30.371025085449276, 37.83028030395536],
            [30.32089614868164, 37.837131500244254],
            [30.08116722106928, 37.703464508056584],
            [30.04684448242216, 37.70895004272472],
            [30.002939224243164, 37.7548828125],
            [30.01048660278326, 37.77233886718756],
            [30.084434509277628, 37.774665832519645],
            [30.173227310180835, 37.81985473632824],
            [30.20322036743181, 37.85691070556635],
            [30.18260765075712, 37.9011611938476],
            [30.22363090515165, 37.98092269897472],
            [30.265552520752237, 38.016117095947266],
            [30.366300582886026, 38.07125473022461],
            [30.517358779907283, 38.18640518188471],
            [30.640510559082202, 38.245807647705135],
            [30.799964904785327, 38.2902374267581],
            [30.877569198608455, 38.36164474487316],
            [31.103597640991268, 38.51663589477545],
            [31.13091659545927, 38.510589599609375],
            [31.20930480957037, 38.439853668213004],
            [31.250438690185604, 38.42662429809576],
            [31.243375778198413, 38.38523483276373],
            [31.262851715087947, 38.360977172851676],
            [31.615524291992358, 38.11956024169922],
            [31.61683845520048, 38.0888214111331],
            [31.599279403686694, 38.065040588378906],
            [31.474828720093058, 38.020690917968864],
            [31.42659378051775, 37.97075271606451],
            [31.423555374145565, 37.90834808349621],
            [31.45230293273943, 37.852764129638786],
          ],
        ],
      },
      properties: {
        name: 'Isparta',
        label: {
          lat: 37.93795833522034,
          lng: 30.74812819755692,
        },
      },
      id: 32,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [29.114028930664233, 40.820693969726676],
              [29.11430549621582, 40.81763839721697],
              [29.11041641235397, 40.820137023925895],
              [29.110971450805778, 40.820693969726676],
              [29.114028930664233, 40.820693969726676],
            ],
          ],
          [
            [
              [29.143749237060774, 40.85597229003935],
              [29.148193359375, 40.849582672119425],
              [29.148473739623967, 40.846248626709155],
              [29.140417098999478, 40.85041809082037],
              [29.143749237060774, 40.85597229003935],
            ],
          ],
          [
            [
              [28.995695114135685, 40.866527557373274],
              [28.995695114135685, 40.86347198486345],
              [28.991249084473054, 40.86208343505871],
              [28.9901390075687, 40.86597061157232],
              [28.995695114135685, 40.866527557373274],
            ],
          ],
          [
            [
              [29.129583358764762, 40.875694274902344],
              [29.13958358764654, 40.869861602783374],
              [29.11291885375988, 40.83847045898432],
              [29.106805801391545, 40.860973358154354],
              [29.129583358764762, 40.875694274902344],
            ],
          ],
          [
            [
              [28.973192214965877, 40.87708282470726],
              [28.974584579467773, 40.87402725219755],
              [28.969305038452205, 40.87402725219755],
              [28.969583511352596, 40.875972747802905],
              [28.973192214965877, 40.87708282470726],
            ],
          ],
          [
            [
              [29.09708595275913, 40.88541793823248],
              [29.10430526733404, 40.872917175293196],
              [29.074861526489315, 40.86791610717785],
              [29.07541656494186, 40.87402725219755],
              [29.09708595275913, 40.88541793823248],
            ],
          ],
          [
            [
              [29.077638626098974, 40.88652801513683],
              [29.079860687255916, 40.884029388427734],
              [29.07652854919462, 40.881248474121264],
              [29.07597160339367, 40.88513946533209],
              [29.077638626098974, 40.88652801513683],
            ],
          ],
          [
            [
              [29.06013870239292, 40.886806488037394],
              [29.068195343017578, 40.88513946533209],
              [29.07236099243164, 40.878749847412166],
              [29.052917480469205, 40.87652587890648],
              [29.06013870239292, 40.886806488037394],
            ],
          ],
          [
            [
              [29.051805496215877, 40.91485977172846],
              [29.057916641235806, 40.90625],
              [29.045139312744368, 40.902084350586165],
              [29.039028167725007, 40.91236114501976],
              [29.051805496215877, 40.91485977172846],
            ],
          ],
          [
            [
              [29.256526947021598, 41.23541641235357],
              [29.588193893432674, 41.16986083984381],
              [29.60958290100092, 41.18236160278326],
              [29.674583435058594, 41.16152954101574],
              [29.862083435058594, 41.14374923706049],
              [29.882982254028377, 41.09217834472656],
              [29.848857879638842, 41.06917572021507],
              [29.748725891113565, 41.05318450927746],
              [29.644767761230582, 41.00930404663086],
              [29.496175765991495, 41.035736083984375],
              [29.481319427490405, 41.0007019042971],
              [29.43189430236822, 40.97430038452154],
              [29.419984817504826, 40.92051315307623],
              [29.348457336425952, 40.891124725342024],
              [29.322084426879996, 40.85878372192377],
              [29.261529922485522, 40.85514068603521],
              [29.24763870239275, 40.87208175659191],
              [29.144582748413143, 40.90069580078125],
              [29.09708595275896, 40.95013809204113],
              [29.03152847290056, 40.96625137329107],
              [29.037639617920092, 40.97958374023449],
              [29.02180480957037, 40.978195190429915],
              [29.00597190856945, 41.00986099243164],
              [29.008750915527344, 41.02597045898432],
              [29.051527023315884, 41.048194885254134],
              [29.06597137451172, 41.10291671752941],
              [29.096250534057617, 41.11791610717796],
              [29.070972442627067, 41.14319610595709],
              [29.087083816528377, 41.1787490844726],
              [29.165416717529467, 41.224582672119254],
              [29.256526947021598, 41.23541641235357],
            ],
          ],
          [
            [
              [28.199028015136832, 41.54597091674816],
              [28.272918701171875, 41.49569320678711],
              [28.63097190856962, 41.35013961791992],
              [28.684305191040153, 41.347915649414176],
              [28.78430557250988, 41.30208206176758],
              [28.81125259399414, 41.30541610717779],
              [28.96597290039074, 41.25319290161144],
              [29.07819366455078, 41.254581451416016],
              [29.11180686950712, 41.23819351196289],
              [29.10958480834961, 41.210140228271484],
              [29.037359237671126, 41.15597152709961],
              [29.07236099243164, 41.124862670898665],
              [29.05708312988287, 41.0818061828615],
              [29.033193588256893, 41.0498619079591],
              [28.975973129272518, 41.02152633666992],
              [28.94013977050804, 41.048194885254134],
              [28.9487495422365, 41.057640075683594],
              [28.944026947021484, 41.06458282470709],
              [28.93625068664562, 41.045417785644474],
              [28.963472366333065, 41.02152633666992],
              [28.986803054809684, 41.017082214355526],
              [28.984863281250114, 41.004859924316406],
              [28.9368057250976, 41.00125122070318],
              [28.875139236450423, 40.96847152709961],
              [28.85014152526867, 40.97430419921875],
              [28.82430458068859, 40.95402908325195],
              [28.76430511474615, 40.98152923583979],
              [28.620138168334904, 40.96041488647472],
              [28.595138549804744, 40.97347259521496],
              [28.588472366333235, 41.01763916015625],
              [28.564027786254883, 41.017082214355526],
              [28.54124832153326, 40.984306335449446],
              [28.407083511352766, 41.045417785644474],
              [28.259582519531648, 41.06236267089855],
              [28.233472824097134, 41.07764053344749],
              [28.123260498046932, 41.05986022949247],
              [28.057348251342773, 41.15075302124052],
              [28.087570190429744, 41.21114730834984],
              [28.15098190307623, 41.24227523803734],
              [28.199129104614258, 41.363262176513956],
              [28.23168945312517, 41.499076843261776],
              [28.179122924804744, 41.52955627441423],
              [28.199028015136832, 41.54597091674816],
            ],
          ],
        ],
      },
      properties: {
        name: 'İstanbul',
        label: {
          lat: 41.175159880754244,
          lng: 28.680613969275946,
        },
      },
      id: 34,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [26.881528854370174, 38.02430725097662],
              [26.884859085083065, 38.02264022827171],
              [26.8840274810791, 38.020973205566406],
              [26.880416870117244, 38.020694732666016],
              [26.881528854370174, 38.02430725097662],
            ],
          ],
          [
            [
              [27.014028549194336, 38.04569625854492],
              [27.01430511474615, 38.04347229003906],
              [27.0123615264896, 38.04347229003906],
              [27.011806488037223, 38.04486083984398],
              [27.014028549194336, 38.04569625854492],
            ],
          ],
          [
            [
              [26.85597229003946, 38.046527862548885],
              [26.855417251586914, 38.044303894043196],
              [26.85375022888178, 38.04486083984398],
              [26.85402870178217, 38.04624938964872],
              [26.85597229003946, 38.046527862548885],
            ],
          ],
          [
            [
              [26.803749084472713, 38.15319442749052],
              [26.804027557373104, 38.152084350586165],
              [26.80208396911638, 38.149307250976506],
              [26.80236053466797, 38.152362823486555],
              [26.803749084472713, 38.15319442749052],
            ],
          ],
          [
            [
              [26.80569458007824, 38.16263961792015],
              [26.803194046020735, 38.158195495605526],
              [26.800971984863622, 38.15708160400402],
              [26.801528930664006, 38.16180419921898],
              [26.80569458007824, 38.16263961792015],
            ],
          ],
          [
            [
              [26.438194274902685, 38.18847274780285],
              [26.440416336059798, 38.18624877929716],
              [26.43958282470703, 38.18264007568371],
              [26.435972213745174, 38.185138702392805],
              [26.438194274902685, 38.18847274780285],
            ],
          ],
          [
            [
              [26.433195114136083, 38.19874954223661],
              [26.43402862548828, 38.193195343017635],
              [26.42791748046875, 38.19430541992199],
              [26.428194046020906, 38.19569396972656],
              [26.433195114136083, 38.19874954223661],
            ],
          ],
          [
            [
              [26.769306182861385, 38.20097351074247],
              [26.772083282471044, 38.19958496093756],
              [26.77180671691906, 38.19819259643566],
              [26.769306182861385, 38.19847106933605],
              [26.769306182861385, 38.20097351074247],
            ],
          ],
          [
            [
              [26.45180511474649, 38.20124816894531],
              [26.448194503784634, 38.19597244262695],
              [26.441804885864713, 38.19819259643566],
              [26.4429168701173, 38.20041656494135],
              [26.45180511474649, 38.20124816894531],
            ],
          ],
          [
            [
              [26.208471298217887, 38.29791641235357],
              [26.210695266723974, 38.29486083984375],
              [26.210695266723974, 38.2904167175293],
              [26.20791625976608, 38.292915344238395],
              [26.208471298217887, 38.29791641235357],
            ],
          ],
          [
            [
              [26.67847251892124, 38.333751678467024],
              [26.679307937622184, 38.33013916015642],
              [26.674303054810025, 38.32930374145508],
              [26.674028396606445, 38.33208465576172],
              [26.67847251892124, 38.333751678467024],
            ],
          ],
          [
            [
              [26.454027175903434, 38.36847305297874],
              [26.457916259765852, 38.360694885253906],
              [26.452915191650845, 38.359027862549],
              [26.445970535278377, 38.36486053466797],
              [26.454027175903434, 38.36847305297874],
            ],
          ],
          [
            [
              [26.7895832061771, 38.37781143188499],
              [26.792083740234602, 38.374862670898665],
              [26.783195495605582, 38.36736297607439],
              [26.784585952758903, 38.37569427490246],
              [26.7895832061771, 38.37781143188499],
            ],
          ],
          [
            [
              [26.466249465942496, 38.38208389282238],
              [26.466806411743278, 38.375415802001896],
              [26.46152687072771, 38.37430572509771],
              [26.461250305175724, 38.375415802001896],
              [26.466249465942496, 38.38208389282238],
            ],
          ],
          [
            [
              [26.449306488037223, 38.39041519165045],
              [26.450971603393555, 38.387359619140796],
              [26.449028015136832, 38.38569259643566],
              [26.447639465332088, 38.389583587646655],
              [26.449306488037223, 38.39041519165045],
            ],
          ],
          [
            [
              [26.44958305358881, 38.39485931396507],
              [26.449028015136832, 38.39180374145536],
              [26.44680595397972, 38.3909721374514],
              [26.447916030884073, 38.39430618286127],
              [26.44958305358881, 38.39485931396507],
            ],
          ],
          [
            [
              [26.790138244628906, 38.39986038208008],
              [26.79236030578619, 38.395694732666016],
              [26.784860610961914, 38.393196105957315],
              [26.784027099609375, 38.39597320556658],
              [26.790138244628906, 38.39986038208008],
            ],
          ],
          [
            [
              [26.469305038452546, 38.39791488647472],
              [26.46902847290039, 38.395416259765625],
              [26.468194961548193, 38.40041732788103],
              [26.469583511352937, 38.40041732788103],
              [26.469305038452546, 38.39791488647472],
            ],
          ],
          [
            [
              [26.46458244323736, 38.40263748168974],
              [26.46847152709961, 38.39152908325201],
              [26.465417861938533, 38.386806488037394],
              [26.46152687072771, 38.395416259765625],
              [26.46458244323736, 38.40263748168974],
            ],
          ],
          [
            [
              [26.491527557373047, 38.40541839599621],
              [26.49291610717796, 38.404304504394645],
              [26.490417480468864, 38.40347290039085],
              [26.489860534667912, 38.404861450195426],
              [26.491527557373047, 38.40541839599621],
            ],
          ],
          [
            [
              [26.770139694213924, 38.41069412231457],
              [26.77375030517578, 38.407360076904354],
              [26.76986122131393, 38.404304504394645],
              [26.76819229126022, 38.410415649414006],
              [26.770139694213924, 38.41069412231457],
            ],
          ],
          [
            [
              [26.795692443848054, 38.41541671752958],
              [26.799306869506893, 38.407360076904354],
              [26.793193817138956, 38.40652847290056],
              [26.792083740234602, 38.41069412231457],
              [26.795692443848054, 38.41541671752958],
            ],
          ],
          [
            [
              [26.782917022705192, 38.41819381713884],
              [26.785417556762695, 38.416248321533374],
              [26.785139083862305, 38.41458511352539],
              [26.780416488647518, 38.415973663330135],
              [26.782917022705192, 38.41819381713884],
            ],
          ],
          [
            [
              [26.308471679687443, 38.42347335815441],
              [26.315139770507926, 38.41791534423828],
              [26.31347274780279, 38.41430664062523],
              [26.308471679687443, 38.41736221313505],
              [26.308471679687443, 38.42347335815441],
            ],
          ],
          [
            [
              [26.385972976684513, 38.4362487792971],
              [26.38958358764694, 38.422084808349666],
              [26.372915267944677, 38.42708206176769],
              [26.37347221374506, 38.43180465698248],
              [26.385972976684513, 38.4362487792971],
            ],
          ],
          [
            [
              [26.369583129882812, 38.43791580200201],
              [26.374027252197436, 38.434028625488395],
              [26.368194580078466, 38.42708206176769],
              [26.36736106872553, 38.43736267089861],
              [26.369583129882812, 38.43791580200201],
            ],
          ],
          [
            [
              [26.97402763366705, 38.44097137451172],
              [26.972085952758903, 38.434307098388956],
              [26.969028472900447, 38.43513870239275],
              [26.971805572509766, 38.44180679321306],
              [26.97402763366705, 38.44097137451172],
            ],
          ],
          [
            [
              [26.923471450806005, 38.448192596435774],
              [26.926805496215877, 38.44680404663103],
              [26.927639007568416, 38.444862365722884],
              [26.923749923705998, 38.445693969726676],
              [26.923471450806005, 38.448192596435774],
            ],
          ],
          [
            [
              [26.767362594604833, 38.45541763305687],
              [26.776250839233853, 38.44097137451172],
              [26.764305114746207, 38.43486022949219],
              [26.759307861328182, 38.45264053344738],
              [26.767362594604833, 38.45541763305687],
            ],
          ],
          [
            [
              [26.359861373901424, 38.45624923706066],
              [26.35736083984375, 38.428195953369425],
              [26.33152770996105, 38.422637939453296],
              [26.32513809204113, 38.44124984741211],
              [26.359861373901424, 38.45624923706066],
            ],
          ],
          [
            [
              [26.85041427612333, 38.5345840454101],
              [26.854583740234546, 38.533473968505916],
              [26.854583740234546, 38.5326385498048],
              [26.849027633666992, 38.53430557250971],
              [26.85041427612333, 38.5345840454101],
            ],
          ],
          [
            [
              [26.859027862548942, 38.53430557250971],
              [26.86125183105503, 38.533748626709155],
              [26.8626384735108, 38.5351371765139],
              [26.86347389221197, 38.53319549560575],
              [26.857915878296012, 38.533748626709155],
              [26.860137939453125, 38.536529541015625],
              [26.859027862548942, 38.53430557250971],
            ],
          ],
          [
            [
              [26.698749542236385, 38.54735946655279],
              [26.729305267334098, 38.52986145019531],
              [26.730972290039404, 38.4968070983889],
              [26.749584197998217, 38.48180389404314],
              [26.74236106872553, 38.45875167846708],
              [26.69430541992199, 38.47958374023443],
              [26.698749542236385, 38.54735946655279],
            ],
          ],
          [
            [
              [26.818471908569677, 38.545696258545206],
              [26.826250076293945, 38.53819274902372],
              [26.825971603393953, 38.53152847290045],
              [26.814027786254883, 38.54430389404308],
              [26.818471908569677, 38.545696258545206],
            ],
          ],
          [
            [
              [26.5220832824711, 38.654026031494425],
              [26.52486038208002, 38.65236282348627],
              [26.526805877685717, 38.64986038208019],
              [26.522361755371094, 38.65208435058588],
              [26.5220832824711, 38.654026031494425],
            ],
          ],
          [
            [
              [26.51874923706066, 38.66347122192383],
              [26.51958274841303, 38.65763854980469],
              [26.510694503784578, 38.657081604003906],
              [26.514862060546818, 38.662639617920036],
              [26.51874923706066, 38.66347122192383],
            ],
          ],
          [
            [
              [26.72569465637224, 38.677082061767805],
              [26.729585647583065, 38.67402648925798],
              [26.727916717529354, 38.67013931274414],
              [26.723194122314737, 38.67458343505854],
              [26.72569465637224, 38.677082061767805],
            ],
          ],
          [
            [
              [26.71819686889654, 38.67819595336937],
              [26.71819686889654, 38.67597198486345],
              [26.711526870727653, 38.67402648925798],
              [26.713470458984375, 38.67680740356445],
              [26.71819686889654, 38.67819595336937],
            ],
          ],
          [
            [
              [26.70930480957054, 38.702915191650334],
              [26.72514152526901, 38.69319534301775],
              [26.722917556762752, 38.68680572509783],
              [26.708749771118164, 38.691806793213004],
              [26.70930480957054, 38.702915191650334],
            ],
          ],
          [
            [
              [26.709028244018555, 38.71652603149437],
              [26.70986175537149, 38.71347045898449],
              [26.707916259765625, 38.71097183227556],
              [26.70763969421381, 38.71347045898449],
              [26.709028244018555, 38.71652603149437],
            ],
          ],
          [
            [
              [26.733749389648494, 38.73402786254883],
              [26.734306335449276, 38.73180389404291],
              [26.7318058013916, 38.732639312744254],
              [26.73236083984375, 38.73374938964844],
              [26.733749389648494, 38.73402786254883],
            ],
          ],
          [
            [
              [26.883193969726733, 38.85652923584013],
              [26.88763809204113, 38.847637176513786],
              [26.876249313354435, 38.84736251831055],
              [26.876249313354435, 38.85208511352556],
              [26.883193969726733, 38.85652923584013],
            ],
          ],
          [
            [
              [26.892917633056697, 38.86652755737316],
              [26.89374923706049, 38.864860534668196],
              [26.891805648803768, 38.86208343505854],
              [26.89125061035196, 38.86430740356445],
              [26.892917633056697, 38.86652755737316],
            ],
          ],
          [
            [
              [27.04013824462885, 38.8843040466308],
              [27.038196563720703, 38.885139465332315],
              [27.041250228882177, 38.88652801513672],
              [27.041250228882177, 38.88458251953119],
              [27.04013824462885, 38.8843040466308],
            ],
          ],
          [
            [
              [26.83402824401861, 38.908748626708984],
              [26.83930778503418, 38.90402603149437],
              [26.839027404785213, 38.90097045898466],
              [26.83264160156284, 38.90430450439476],
              [26.83402824401861, 38.908748626708984],
            ],
          ],
          [
            [
              [26.810695648193416, 38.92763900756836],
              [26.825696945190543, 38.92291641235357],
              [26.8223628997805, 38.910972595214844],
              [26.806249618530217, 38.9170837402346],
              [26.810695648193416, 38.92763900756836],
            ],
          ],
          [
            [
              [26.804306030273494, 38.93763732910156],
              [26.806528091430778, 38.935138702392805],
              [26.806528091430778, 38.93402862548828],
              [26.803472518921296, 38.935695648193416],
              [26.804306030273494, 38.93763732910156],
            ],
          ],
          [
            [
              [26.79874992370611, 39.011249542236555],
              [26.79680633544922, 38.99791717529297],
              [26.79236030578619, 38.996250152588004],
              [26.79291725158697, 39.008472442626896],
              [26.79874992370611, 39.011249542236555],
            ],
          ],
          [
            [
              [26.787361145019986, 39.01235961914091],
              [26.788473129272745, 39.005973815918196],
              [26.784027099609375, 39.000137329101676],
              [26.780416488647518, 39.00875091552729],
              [26.787361145019986, 39.01235961914091],
            ],
          ],
          [
            [
              [27.470958709716797, 39.1718826293947],
              [27.504394531249943, 39.11765670776373],
              [27.50539588928217, 39.01988601684582],
              [27.433935165405387, 38.96704864501953],
              [27.387517929077205, 38.95204162597662],
              [27.37003517150879, 38.9268493652346],
              [27.168153762817496, 38.89170837402344],
              [27.131971359253384, 38.80689239501959],
              [27.124540328979947, 38.77974319458019],
              [27.231248855591275, 38.73934555053705],
              [27.279998779296932, 38.572151184082145],
              [27.33832931518566, 38.58828735351585],
              [27.457939147949446, 38.56347656250006],
              [27.56540679931652, 38.48628616333025],
              [27.742670059204045, 38.446926116943644],
              [27.82133483886747, 38.35077285766613],
              [27.853576660156534, 38.33378982543957],
              [28.001060485839787, 38.399547576904524],
              [28.117492675781477, 38.40279769897484],
              [28.145027160644815, 38.39204025268555],
              [28.16123199462919, 38.360778808593864],
              [28.22292518615734, 38.33587265014654],
              [28.433549880981445, 38.295082092285156],
              [28.474098205566577, 38.25453948974621],
              [28.527257919311467, 38.13525772094738],
              [28.559946060180778, 38.108661651611385],
              [28.249021530151367, 38.01900100708008],
              [28.071899414062727, 38.02942657470726],
              [27.95366859436035, 38.006706237793026],
              [27.938676834106502, 38.018360137939396],
              [27.923608779907283, 37.99508666992193],
              [27.77575492858881, 37.972328186035156],
              [27.72010993957548, 37.985515594482536],
              [27.531816482544002, 37.983718872070426],
              [27.441749572753963, 37.91611480712896],
              [27.35456848144537, 37.891254425049055],
              [27.278308868408203, 37.891544342041016],
              [27.260694503784237, 37.912639617920036],
              [27.27486038208025, 37.944583892822266],
              [27.24847030639677, 37.98125076293951],
              [27.217082977294922, 37.99236297607422],
              [27.14291763305664, 37.98374938964838],
              [27.099027633666935, 38.01541519165062],
              [27.07541656494152, 38.01263809204096],
              [27.048194885253906, 38.050140380859546],
              [26.983474731445426, 38.07430648803711],
              [26.8979167938233, 38.061527252197266],
              [26.864305496215934, 38.02847290039085],
              [26.824306488037223, 38.158195495605526],
              [26.7954158782959, 38.1734733581543],
              [26.774860382080135, 38.161251068115234],
              [26.772083282471044, 38.19680404663109],
              [26.790416717529297, 38.199028015137],
              [26.75736045837408, 38.222084045410384],
              [26.73291778564453, 38.20680618286127],
              [26.63597488403326, 38.20735931396507],
              [26.62430572509777, 38.13847351074219],
              [26.603195190429858, 38.143470764160384],
              [26.61486053466797, 38.110973358154524],
              [26.591527938842773, 38.102638244628906],
              [26.570972442627408, 38.14263916015642],
              [26.560417175293082, 38.117362976074446],
              [26.52986145019537, 38.12791824340843],
              [26.51152992248535, 38.1656951904298],
              [26.517915725708292, 38.187084197998274],
              [26.505416870117244, 38.17514038085943],
              [26.48708343505899, 38.18291854858427],
              [26.490695953369254, 38.19569396972656],
              [26.458194732666414, 38.19152832031273],
              [26.441804885864713, 38.21875000000017],
              [26.419584274292447, 38.22124862670927],
              [26.429306030273665, 38.208194732666186],
              [26.431251525878963, 38.199028015137],
              [26.429859161377067, 38.19819259643566],
              [26.38903045654297, 38.222915649414176],
              [26.40180587768583, 38.24486160278343],
              [26.39097023010254, 38.260971069335994],
              [26.378469467163086, 38.26291656494146],
              [26.387361526489258, 38.24736022949236],
              [26.36680603027372, 38.22708511352539],
              [26.334861755371094, 38.225692749023665],
              [26.28541755676281, 38.26514053344738],
              [26.231527328491495, 38.26625061035156],
              [26.233472824096623, 38.29430389404297],
              [26.271804809570767, 38.290138244629134],
              [26.28097152709961, 38.3237495422365],
              [26.302639007568473, 38.32069396972679],
              [26.28513908386242, 38.34208297729492],
              [26.28458404541061, 38.37652587890625],
              [26.3001384735108, 38.355140686035156],
              [26.31597137451172, 38.37625122070324],
              [26.318750381469783, 38.33013916015642],
              [26.344861984252873, 38.334304809570426],
              [26.344861984252873, 38.319305419921875],
              [26.378469467163086, 38.30902862548851],
              [26.384304046630803, 38.348751068115234],
              [26.40180587768583, 38.32347106933594],
              [26.482360839843807, 38.37597274780302],
              [26.475694656372468, 38.401527404785384],
              [26.451250076293945, 38.428195953369425],
              [26.490139007568473, 38.40097045898443],
              [26.515972137451172, 38.428195953369425],
              [26.437915802002294, 38.47680664062517],
              [26.39291763305664, 38.44652938842785],
              [26.412082672119197, 38.49430465698242],
              [26.371528625488338, 38.52986145019531],
              [26.37513732910179, 38.541805267333984],
              [26.38069534301792, 38.52347183227539],
              [26.38069534301792, 38.54402923584007],
              [26.359861373901424, 38.56708526611351],
              [26.352916717529524, 38.63874816894548],
              [26.36069488525436, 38.65986251831055],
              [26.41624832153326, 38.68097305297846],
              [26.474306106567553, 38.67514038085966],
              [26.523471832275447, 38.650142669677734],
              [26.52319526672386, 38.630695343017805],
              [26.562360763549805, 38.60263824462902],
              [26.569305419922102, 38.559581756592024],
              [26.62513923645014, 38.53125000000023],
              [26.64125061035162, 38.469306945801065],
              [26.587917327880916, 38.47041702270525],
              [26.60486030578619, 38.451526641845646],
              [26.584583282471044, 38.42652893066412],
              [26.611528396606502, 38.422359466552905],
              [26.64347267150913, 38.37569427490246],
              [26.644306182861328, 38.339862823486555],
              [26.67375183105503, 38.31208419799816],
              [26.703195571899414, 38.319862365722656],
              [26.6751384735108, 38.34791564941406],
              [26.677917480468864, 38.360416412353516],
              [26.684860229492188, 38.35041809082054],
              [26.688192367553654, 38.351806640625284],
              [26.674581527710018, 38.38791656494135],
              [26.70736122131342, 38.4345817565918],
              [26.73652839660656, 38.42874908447283],
              [26.76652717590332, 38.36680603027344],
              [26.808473587036303, 38.35541534423834],
              [27.017084121704215, 38.41819381713884],
              [27.086805343628043, 38.398471832275504],
              [27.1187496185305, 38.410415649414006],
              [27.148195266723633, 38.44763946533203],
              [27.170692443847884, 38.44124984741211],
              [27.1590251922608, 38.46680450439459],
              [27.111804962158203, 38.448749542236385],
              [27.079305648803768, 38.46708297729515],
              [27.02680778503418, 38.46763992309593],
              [26.97430610656744, 38.45513916015631],
              [26.94847297668474, 38.43180465698248],
              [26.951805114746207, 38.44347381591797],
              [26.919584274291992, 38.45319366455095],
              [26.922361373901822, 38.46763992309593],
              [26.884582519531648, 38.507637023926065],
              [26.835695266723746, 38.52236175537138],
              [26.828193664551065, 38.527084350585994],
              [26.88791656494152, 38.51069259643555],
              [26.882638931274357, 38.53486251831066],
              [26.848192214966218, 38.54291534423834],
              [26.847082138061864, 38.559581756592024],
              [26.842639923095646, 38.55041503906244],
              [26.822914123535497, 38.55041503906244],
              [26.84680557250988, 38.560417175293196],
              [26.83958244323776, 38.58763885498047],
              [26.830417633056754, 38.57819366455084],
              [26.79986190795944, 38.61097335815424],
              [26.7570858001709, 38.615417480468864],
              [26.769584655761776, 38.635971069336165],
              [26.72236061096197, 38.65152740478533],
              [26.753751754761197, 38.66513824462896],
              [26.73069572448742, 38.67458343505854],
              [26.74097061157221, 38.68097305297846],
              [26.72652816772461, 38.721527099609546],
              [26.743194580078296, 38.73152923584007],
              [26.74014091491739, 38.741806030273665],
              [26.780416488647518, 38.73708343505865],
              [26.824028015136832, 38.762359619140625],
              [26.835973739624137, 38.742084503174055],
              [26.858194351196403, 38.753192901611385],
              [26.894582748413427, 38.73374938964844],
              [26.90708351135271, 38.76652908325218],
              [26.92930603027355, 38.75597381591825],
              [26.93902778625494, 38.76597213745123],
              [26.892639160156307, 38.82514190673828],
              [26.91402816772461, 38.817359924316634],
              [26.944303512573526, 38.8365287780764],
              [26.942638397216797, 38.812084197998274],
              [26.969028472900447, 38.80402755737305],
              [26.98430633544922, 38.82263946533203],
              [26.962360382080533, 38.83097076416044],
              [26.97125053405796, 38.84597396850603],
              [27.02569580078125, 38.87263870239269],
              [27.019582748413313, 38.86208343505854],
              [27.034582138061864, 38.855972290039006],
              [27.066249847412507, 38.87708282470709],
              [27.051525115966797, 38.897083282470646],
              [27.03736114501976, 38.893470764160384],
              [27.057083129882926, 38.91319274902338],
              [27.04375076293968, 38.940971374511776],
              [27.006250381469897, 38.91902923584007],
              [27.017915725708008, 38.91347122192394],
              [26.969581604004077, 38.92680740356457],
              [26.957084655761776, 38.93763732910156],
              [26.968471527099894, 38.944305419921875],
              [26.936805725097656, 38.93763732910156],
              [26.939582824707315, 38.925693511962834],
              [26.919584274291992, 38.93986129760742],
              [26.858194351196403, 38.9137496948245],
              [26.84986114501993, 38.93375015258806],
              [26.801250457763615, 38.95069503784197],
              [26.797361373901765, 38.996250152588004],
              [26.815971374512173, 39.025970458984546],
              [26.79874992370611, 39.01514053344721],
              [26.799028396606502, 39.03236007690447],
              [26.88763809204113, 39.075416564941634],
              [26.835695266723746, 39.14208221435541],
              [26.76458358764677, 39.17321395874052],
              [26.957500457763672, 39.259422302246094],
              [27.176755905151424, 39.42146682739258],
              [27.407686233520792, 39.38151550292969],
              [27.45876693725586, 39.29547119140625],
              [27.470958709716797, 39.1718826293947],
            ],
          ],
        ],
      },
      properties: {
        name: 'İzmir',
        label: {
          lat: 38.27317091511179,
          lng: 27.260573873782384,
        },
      },
      id: 35,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [37.039100646972656, 38.5945396423341],
            [37.05988693237333, 38.578189849853516],
            [37.288425445556584, 38.59590911865257],
            [37.274082183838175, 38.554397583007926],
            [37.19495010376005, 38.49284362792969],
            [37.1977615356447, 38.46109771728527],
            [37.36172103881853, 38.46540832519531],
            [37.45554351806652, 38.45201492309593],
            [37.69929885864275, 38.358089447021484],
            [37.773830413818644, 38.31008911132807],
            [37.77216720581072, 38.22153472900402],
            [37.634899139404354, 37.91677093505871],
            [37.52582168579107, 37.77268218994146],
            [37.41357421875006, 37.68510437011736],
            [37.426506042480526, 37.60475921630854],
            [37.5731277465822, 37.55051803588867],
            [37.62296295166021, 37.51213455200224],
            [37.61789703369169, 37.425151824951286],
            [37.55552673339872, 37.38273620605463],
            [37.18589782714838, 37.332862854004134],
            [37.089210510253906, 37.28264236450207],
            [37.04829406738287, 37.23469924926758],
            [37.01084136962908, 37.217384338378906],
            [36.96500015258789, 37.23295974731445],
            [36.9305152893067, 37.34512710571289],
            [36.90557479858427, 37.366729736328125],
            [36.728641510009936, 37.27605056762695],
            [36.65103912353544, 37.32998657226568],
            [36.582782745361385, 37.40520477294933],
            [36.48894882202154, 37.368858337402344],
            [36.37861633300787, 37.34900283813482],
            [36.25526428222685, 37.36342620849621],
            [36.212810516357536, 37.51700973510748],
            [36.2694740295413, 37.582317352295036],
            [36.35985565185564, 37.74528121948259],
            [36.36010360717802, 37.77470779418968],
            [36.31903839111345, 37.83251953125],
            [36.31517028808622, 37.88559722900396],
            [36.33535766601574, 37.99667358398449],
            [36.42892074584972, 38.25798416137695],
            [36.58495712280302, 38.394802093505916],
            [36.67869567871122, 38.50409317016607],
            [36.714694976806584, 38.585800170898665],
            [36.92048263549833, 38.62846374511719],
            [37.039100646972656, 38.5945396423341],
          ],
        ],
      },
      properties: {
        name: 'Kahramanmaraş',
        label: {
          lat: 37.97763634957522,
          lng: 36.476121200897,
        },
      },
      id: 46,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [32.972885131835994, 41.52023315429693],
            [33.044803619384936, 41.41645050048845],
            [33.01094055175798, 41.37084579467779],
            [32.9510574340822, 41.333637237549055],
            [32.91890335083025, 41.28511047363287],
            [32.91732788085943, 41.21456909179699],
            [32.92760467529314, 41.195224761963175],
            [33.01161956787121, 41.15423583984398],
            [33.07714080810564, 41.088871002197266],
            [33.027935028076456, 41.01646423339844],
            [32.6919403076173, 40.957851409912166],
            [32.519256591796875, 40.83922576904308],
            [32.4848175048831, 40.874618530273665],
            [32.28196716308611, 40.94109725952171],
            [32.28520965576189, 41.00830078125006],
            [32.09199523925798, 41.01836776733404],
            [32.109592437744084, 41.12506103515648],
            [32.13407135009794, 41.15750503540039],
            [32.202606201172046, 41.19816970825195],
            [32.30185699462896, 41.23763275146496],
            [32.42853927612322, 41.254291534424055],
            [32.60932159423834, 41.33967208862305],
            [32.656684875488565, 41.3779029846192],
            [32.69793319702154, 41.46401596069336],
            [32.7556343078615, 41.489173889160384],
            [32.793640136719034, 41.527175903320426],
            [32.8231658935548, 41.51309204101574],
            [32.92557525634771, 41.553955078125],
            [32.972885131835994, 41.52023315429693],
          ],
        ],
      },
      properties: {
        name: 'Karabük',
        label: {
          lat: 41.15185766883559,
          lng: 32.26587104120791,
        },
      },
      id: 78,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [33.82967376708996, 37.38158416748058],
            [33.905017852783374, 37.32161712646507],
            [33.9332160949707, 37.272449493408374],
            [34.09875869750971, 37.24098968505871],
            [34.19761276245134, 37.17826080322277],
            [34.09249877929693, 37.131454467773665],
            [33.989757537841854, 37.126686096191634],
            [33.867404937744084, 37.06111907958996],
            [33.75038909912104, 37.02802658081066],
            [33.632530212402344, 37.04732131958019],
            [33.52960968017584, 37.0029754638673],
            [33.388763427734375, 36.9991340637207],
            [33.11583709716814, 36.85238647460943],
            [32.9618453979495, 36.809215545654524],
            [33.04000473022461, 36.67696380615246],
            [33.096580505371264, 36.63430023193354],
            [33.217575073242244, 36.58370590209978],
            [33.23061370849638, 36.55921173095703],
            [33.21320724487322, 36.52260971069347],
            [33.05472183227556, 36.468769073486385],
            [32.795829772949276, 36.431247711181754],
            [32.65814208984381, 36.446079254150504],
            [32.55423355102556, 36.5082168579101],
            [32.50381469726568, 36.561042785644645],
            [32.45649719238298, 36.674057006835994],
            [32.47058486938482, 36.7511253356933],
            [32.60804748535185, 36.78462219238281],
            [32.748134613037394, 36.850887298583984],
            [32.80971908569347, 36.9109458923341],
            [32.616397857666186, 36.94893264770508],
            [32.56579208374052, 36.988525390625],
            [32.564231872558764, 37.01300811767601],
            [32.647991180420206, 37.09346008300781],
            [32.68590164184576, 37.157508850097656],
            [32.69144058227545, 37.21172714233427],
            [32.76886367797857, 37.233978271484375],
            [32.8411598205567, 37.21237945556652],
            [32.900009155273494, 37.213756561279524],
            [32.86283111572271, 37.28112030029297],
            [32.917613983154354, 37.36951446533209],
            [33.05659866333008, 37.38821792602539],
            [33.11162567138672, 37.448928833007756],
            [33.14750671386736, 37.4563179016115],
            [33.20130920410173, 37.4533424377442],
            [33.296306610107706, 37.37743377685547],
            [33.353820800781534, 37.375347137451286],
            [33.38849639892584, 37.39728927612316],
            [33.42147827148443, 37.47786331176758],
            [33.48609542846708, 37.54191970825195],
            [33.64541244506853, 37.604286193847884],
            [33.726142883301065, 37.60812377929693],
            [33.82967376708996, 37.38158416748058],
          ],
        ],
      },
      properties: {
        name: 'Karaman',
        label: {
          lat: 37.23214760913453,
          lng: 33.044353784302146,
        },
      },
      id: 70,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [43.59941482543974, 40.98562622070335],
            [43.6762428283692, 40.92770004272461],
            [43.6761093139649, 40.84443664550798],
            [43.713020324707315, 40.81192016601574],
            [43.74869918823248, 40.73593902587896],
            [43.7363014221192, 40.70790100097662],
            [43.75005340576172, 40.680580139160156],
            [43.67522430419933, 40.57935714721674],
            [43.64200592041021, 40.55900192260759],
            [43.64796829223633, 40.53152084350586],
            [43.63185882568365, 40.53734588623047],
            [43.626861572265796, 40.519538879394645],
            [43.545551300048885, 40.47705078125],
            [43.61880874633795, 40.41806411743164],
            [43.5936927795413, 40.3372802734375],
            [43.639865875244425, 40.27662277221691],
            [43.68171310424822, 40.25849914550798],
            [43.681953430175724, 40.22991943359381],
            [43.57503128051786, 40.186195373535156],
            [43.411888122558594, 40.18202590942394],
            [43.38365554809576, 40.16720962524414],
            [43.393310546875114, 40.13174819946289],
            [43.38040161132807, 40.11241149902344],
            [43.30694961547857, 40.10919952392601],
            [43.29211807250982, 40.07103347778349],
            [43.34629821777361, 39.99917984008789],
            [43.35047149658203, 39.9627571105957],
            [43.10322189331072, 40.00832748413086],
            [42.7108917236331, 39.91766357421875],
            [42.627677917480526, 39.92008972167963],
            [42.566364288330135, 39.94755172729515],
            [42.498966217041186, 40.041206359863224],
            [42.36748123168974, 40.13149261474615],
            [42.205627441406534, 40.16657257080078],
            [42.138141632080135, 40.25527572631847],
            [42.14982986450224, 40.28962326049816],
            [42.271778106689624, 40.31632232666021],
            [42.51459884643572, 40.41061782836914],
            [42.538536071777514, 40.44420623779325],
            [42.57029724121105, 40.59017562866222],
            [42.54808425903349, 40.64073181152361],
            [42.61116790771479, 40.64011383056635],
            [42.704601287841854, 40.68149566650385],
            [42.8360137939456, 40.71354293823265],
            [42.869586944580135, 40.77029800415039],
            [42.87327575683611, 40.85266876220709],
            [42.9088897705081, 40.921489715576286],
            [42.993515014648494, 40.961849212646484],
            [43.11260986328119, 40.9844589233399],
            [43.21897506713884, 41.02573394775402],
            [43.26084136962908, 41.08422470092785],
            [43.26377487182617, 41.15536499023443],
            [43.280563354492244, 41.18324279785179],
            [43.36536788940441, 41.20235061645525],
            [43.43723297119135, 41.1793785095216],
            [43.47128295898443, 41.129795074463004],
            [43.44977951049822, 41.09215164184593],
            [43.47216033935547, 41.02798461914085],
            [43.59941482543974, 40.98562622070335],
          ],
        ],
      },
      properties: {
        name: 'Kars',
        label: {
          lat: 40.42891030418684,
          lng: 42.94697279283942,
        },
      },
      id: 36,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [33.338748931884766, 42.02041625976574],
            [33.67847061157232, 41.98041534423828],
            [34.04680633544922, 41.98208236694336],
            [34.22653198242193, 41.95513916015648],
            [34.225559234619425, 41.87401580810547],
            [34.26716613769537, 41.805038452148665],
            [34.269077301025675, 41.739074707031364],
            [34.4930953979495, 41.72483825683594],
            [34.59929656982433, 41.668979644775504],
            [34.59622573852556, 41.63491439819336],
            [34.56705856323259, 41.59246063232422],
            [34.46514892578131, 41.540878295898494],
            [34.47560119628923, 41.30388641357422],
            [34.43436813354498, 41.30613327026373],
            [34.394657135009766, 41.2771186828615],
            [34.29096221923845, 41.16743850708008],
            [34.210571289062614, 41.040046691894645],
            [34.22607040405279, 41.00858306884777],
            [34.27907180786133, 40.976325988769645],
            [34.27776718139654, 40.92724227905302],
            [34.03589248657232, 40.85097122192377],
            [33.89286422729498, 40.89155578613281],
            [33.82385253906267, 40.91936874389654],
            [33.78824615478521, 40.95132064819336],
            [33.791225433349666, 40.99592971801752],
            [33.86064910888672, 41.05282211303711],
            [33.85814666748041, 41.07776641845726],
            [33.82796859741228, 41.09726715087902],
            [33.44918823242216, 40.9622535705567],
            [33.385791778564396, 40.96100616455084],
            [33.215167999267635, 41.062389373779354],
            [33.14824676513672, 41.087013244628906],
            [33.07714080810564, 41.088871002197266],
            [32.99153137207037, 41.16962051391607],
            [32.92760467529314, 41.195224761963175],
            [32.913772583007926, 41.275463104248274],
            [32.9510574340822, 41.333637237549055],
            [33.01094055175798, 41.37084579467779],
            [33.044803619384936, 41.41645050048845],
            [32.95254898071295, 41.546436309814624],
            [32.827293395996094, 41.595649719238395],
            [32.761165618896655, 41.7322998046875],
            [32.68097305297863, 41.834583282470646],
            [32.914028167724666, 41.87347412109381],
            [33.02736282348661, 41.92736053466825],
            [33.16902923583979, 41.95541763305687],
            [33.338748931884766, 42.02041625976574],
          ],
        ],
      },
      properties: {
        name: 'Kastamonu',
        label: {
          lat: 41.52850671003543,
          lng: 33.30751101460434,
        },
      },
      id: 37,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [35.94820404052763, 39.20082855224604],
            [36.012729644775504, 39.14810180664085],
            [36.06792068481445, 39.129901885986385],
            [36.30744171142578, 39.130260467529524],
            [36.37403869628912, 39.15341186523443],
            [36.45937347412138, 39.1303596496582],
            [36.60339355468744, 39.17564010620123],
            [36.77732849121122, 39.175086975097656],
            [36.88906860351574, 39.13128662109381],
            [36.944854736328296, 39.05715942382824],
            [36.758411407470874, 38.674396514892805],
            [36.7323379516601, 38.591064453125],
            [36.69913864135748, 38.57224273681646],
            [36.67527389526367, 38.49930191040062],
            [36.50911712646496, 38.322906494140625],
            [36.49144363403326, 38.31632614135742],
            [36.47338485717802, 38.336627960205135],
            [36.4083328247072, 38.45562362670921],
            [36.30536651611334, 38.463748931884766],
            [36.146896362304744, 38.40219116210949],
            [36.00793838500982, 38.18138122558594],
            [35.680976867676065, 38.05966186523432],
            [35.621017456054744, 37.95576095581066],
            [35.43716430664068, 37.91958236694336],
            [35.26578140258795, 37.959201812744254],
            [35.312152862548885, 38.040725708007926],
            [35.311183929443416, 38.16899108886719],
            [35.27957916259771, 38.22149658203148],
            [35.236129760742244, 38.254776000976506],
            [35.12228393554699, 38.25902938842785],
            [35.063629150390796, 38.282264709472656],
            [34.99367523193365, 38.42170715332031],
            [34.92252349853521, 38.43228149414068],
            [34.90881347656256, 38.46187591552746],
            [34.90801239013689, 38.50479125976574],
            [34.92678451538103, 38.538246154785156],
            [35.018016815185604, 38.565429687500114],
            [35.070098876953125, 38.613536834716854],
            [35.068992614746264, 38.74825668334972],
            [34.95324707031256, 38.798259735107706],
            [35.002136230469034, 39.013160705566406],
            [35.037403106689624, 39.03805160522461],
            [35.08006668090849, 39.03767395019537],
            [35.2412185668947, 39.00565338134777],
            [35.482967376709155, 39.099575042724666],
            [35.463966369628906, 39.156749725341854],
            [35.47180557250988, 39.18677139282238],
            [35.67707824707037, 39.203239440918026],
            [35.81264877319347, 39.29944610595703],
            [35.885440826416016, 39.27633666992216],
            [35.94820404052763, 39.20082855224604],
          ],
        ],
      },
      properties: {
        name: 'Kayseri',
        label: {
          lat: 38.67902318195044,
          lng: 35.60058901707913,
        },
      },
      id: 38,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [37.435653686523494, 36.78142929077177],
            [37.50850296020536, 36.65539550781256],
            [37.48497772216791, 36.64108657836914],
            [37.14474105834972, 36.66322708129883],
            [37.12191772460943, 36.65938949584961],
            [37.090995788574276, 36.62364578247076],
            [37.028041839599894, 36.66057586669933],
            [37.0560379028322, 36.72425842285162],
            [36.94435119628912, 36.781242370605526],
            [36.80418395996105, 36.798564910888786],
            [36.78188705444353, 36.823947906494254],
            [36.80578994750982, 36.8526229858399],
            [36.90999221801786, 36.902648925781364],
            [36.97225952148466, 36.993789672851676],
            [37.01332473754894, 37.010478973388786],
            [37.124984741210994, 37.01027297973644],
            [37.18312835693365, 36.98589706420927],
            [37.24035644531256, 36.86549377441406],
            [37.435653686523494, 36.78142929077177],
          ],
        ],
      },
      properties: {
        name: 'Kilis',
        label: {
          lat: 36.82962546007697,
          lng: 37.01181533727028,
        },
      },
      id: 79,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [33.91788101196295, 40.26161193847679],
            [34.0790176391601, 40.22452926635748],
            [34.105388641357536, 40.131149291992415],
            [34.198616027831974, 40.03731155395508],
            [34.059497833252124, 39.94801712036144],
            [34.06889724731451, 39.80836868286144],
            [33.91082000732439, 39.705814361572266],
            [33.85577011108393, 39.563274383545036],
            [33.801372528076456, 39.514717102050895],
            [33.76018142700224, 39.44463348388689],
            [33.679565429687614, 39.44376754760742],
            [33.58490753173834, 39.38108825683594],
            [33.52802276611345, 39.2547988891601],
            [33.41689682006836, 39.16110992431652],
            [33.36560821533209, 39.22562789917015],
            [33.390270233154354, 39.27744674682617],
            [33.36938476562506, 39.317165374755916],
            [33.28668594360357, 39.33038711547863],
            [33.23331832885748, 39.37669372558594],
            [33.2855339050293, 39.46186065673851],
            [33.33845520019548, 39.71584701538097],
            [33.36276245117199, 39.75877761840832],
            [33.42865371704113, 39.81058883666998],
            [33.60328674316435, 39.89190673828142],
            [33.619411468506144, 39.9583435058596],
            [33.57646942138689, 40.048053741455135],
            [33.622394561767635, 40.1554412841798],
            [33.70774078369146, 40.2587776184082],
            [33.769126892090014, 40.28475952148449],
            [33.91788101196295, 40.26161193847679],
          ],
        ],
      },
      properties: {
        name: 'Kırıkkale',
        label: {
          lat: 39.66721115906335,
          lng: 33.44755087301178,
        },
      },
      id: 71,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.254264831543026, 42.1054115295413],
            [27.32935714721691, 42.0840950012207],
            [27.33961677551281, 42.06216812133789],
            [27.37686729431158, 42.04953002929693],
            [27.415891647338867, 41.990142822265625],
            [27.509033203125, 41.950714111328125],
            [27.551439285278548, 41.89959716796875],
            [27.56739425659191, 41.90628051757818],
            [27.557416915893555, 41.9135856628418],
            [27.568567276000977, 41.936641693115234],
            [27.668466567993107, 41.952606201172046],
            [27.69262123107916, 41.97296524047874],
            [27.729068756103743, 41.97274398803711],
            [27.802497863769645, 41.935733795166016],
            [27.82743835449247, 41.945426940918026],
            [27.813037872314737, 41.9797821044923],
            [27.851890563964957, 41.99657440185558],
            [27.902822494506836, 41.968566894531364],
            [28.03134155273466, 41.98703765869152],
            [28.05791854858404, 41.88319396972656],
            [28.01041793823248, 41.89402770996094],
            [27.995695114135913, 41.887638092041016],
            [27.970417022705192, 41.86236190795904],
            [27.995695114135913, 41.79735946655285],
            [28.042083740234546, 41.752639770507926],
            [28.040973663330362, 41.73125076293945],
            [28.105693817138842, 41.66930389404308],
            [28.090139389038086, 41.66291809082037],
            [28.09124946594244, 41.63847351074219],
            [28.149583816528548, 41.58051681518566],
            [27.977830886840934, 41.54333114624018],
            [27.86650657653837, 41.50082015991211],
            [27.770309448242188, 41.50877761840832],
            [27.730844497680607, 41.49436187744152],
            [27.67464828491228, 41.4577522277832],
            [27.673555374145565, 41.40991210937494],
            [27.64314651489252, 41.34899902343756],
            [27.55360603332548, 41.23656463623047],
            [27.520938873291016, 41.22114562988281],
            [27.472660064697436, 41.22648620605469],
            [27.377403259277344, 41.31006622314476],
            [27.262168884277514, 41.34740066528332],
            [26.914499282836857, 41.33306503295921],
            [26.88170051574724, 41.364166259765625],
            [26.88294029235857, 41.405998229980526],
            [27.00078773498558, 41.564857482910156],
            [26.997392654419002, 41.62268066406273],
            [26.921703338623104, 41.65630340576183],
            [26.9095973968507, 41.679828643798885],
            [26.951318740844897, 41.73140716552757],
            [26.96990013122553, 41.812602996826286],
            [26.988868713378906, 41.91792678833019],
            [26.971960067749308, 41.97768783569353],
            [26.98307037353544, 42.033229827880916],
            [27.01955223083496, 42.05057144165045],
            [27.028076171875284, 42.08116912841797],
            [27.069709777831974, 42.09228515625023],
            [27.20951843261713, 42.06493759155285],
            [27.20800781250017, 42.083984375],
            [27.254264831543026, 42.1054115295413],
          ],
        ],
      },
      properties: {
        name: 'Kırklareli',
        label: {
          lat: 41.736988563213586,
          lng: 27.133787276281627,
        },
      },
      id: 39,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [34.22672271728521, 39.74172973632841],
            [34.35737991333036, 39.74853515625023],
            [34.42567825317377, 39.73305511474615],
            [34.468528747558764, 39.67209625244152],
            [34.544994354248104, 39.622127532958984],
            [34.52546310424822, 39.55776214599615],
            [34.65660095214861, 39.486606597900504],
            [34.61058425903326, 39.380512237549055],
            [34.60924911499029, 39.327224731445426],
            [34.66175842285173, 39.31775283813499],
            [34.72655868530279, 39.36091613769531],
            [34.754566192627124, 39.35155868530285],
            [34.686729431152514, 39.26987457275385],
            [34.69286346435564, 39.22026062011747],
            [34.62529754638672, 39.173606872558594],
            [34.636188507080135, 39.097076416015625],
            [34.56758117675787, 39.0790634155274],
            [34.57684707641607, 39.03011703491234],
            [34.5208091735841, 38.990596771240234],
            [34.475379943847656, 38.917903900146484],
            [34.473014831543026, 38.88665008544933],
            [34.427967071533146, 38.87595748901384],
            [34.339496612549, 38.88554382324213],
            [34.31090545654308, 38.862415313720874],
            [34.30298995971691, 38.81587600708025],
            [34.26256942749052, 38.793670654296875],
            [34.22198104858393, 38.815670013427734],
            [34.17686462402338, 38.88210296630854],
            [34.07765579223633, 38.90355300903332],
            [33.98173522949247, 38.965106964111385],
            [33.9267005920413, 39.008110046386776],
            [33.94088363647478, 39.03778457641613],
            [33.59801483154314, 39.17142486572277],
            [33.52802276611345, 39.2547988891601],
            [33.58490753173834, 39.38108825683594],
            [33.679565429687614, 39.44376754760742],
            [33.76018142700224, 39.44463348388689],
            [33.801372528076456, 39.514717102050895],
            [33.85577011108393, 39.563274383545036],
            [33.90729522705084, 39.70091247558622],
            [33.96332550048834, 39.74765014648449],
            [34.06889724731451, 39.80836868286144],
            [34.22672271728521, 39.74172973632841],
          ],
        ],
      },
      properties: {
        name: 'Kırşehir',
        label: {
          lat: 39.348114378820746,
          lng: 33.9376951189583,
        },
      },
      id: 40,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [30.272916793823413, 41.2120819091798],
              [30.349306106567553, 41.19291687011719],
              [30.37742614746088, 41.162662506103516],
              [30.371839523315714, 41.1333122253418],
              [30.320560455322266, 41.10097122192411],
              [30.288484573364315, 41.02032470703148],
              [30.36289978027372, 40.95032501220726],
              [30.377388000488565, 40.86899185180687],
              [30.366508483887003, 40.850341796875],
              [30.290256500244197, 40.82116317749035],
              [30.2994384765625, 40.75570297241234],
              [30.22859191894537, 40.62846755981451],
              [30.153219223022575, 40.621955871582145],
              [30.019073486328296, 40.57857131958019],
              [29.90131950378418, 40.579971313476676],
              [29.766637802124308, 40.61340713500999],
              [29.5762557983399, 40.55675125122076],
              [29.45255661010748, 40.555171966552734],
              [29.43100166320812, 40.560283660888615],
              [29.432935714721737, 40.679412841796875],
              [29.514583587646598, 40.74124908447283],
              [29.52152824401884, 40.720695495605696],
              [29.50736045837408, 40.717361450195256],
              [29.56263923645048, 40.68652725219738],
              [29.811527252197322, 40.7301406860351],
              [29.91680526733404, 40.714027404785384],
              [29.93680572509794, 40.719860076904354],
              [29.940139770507812, 40.755695343017805],
              [29.78263664245634, 40.740970611572266],
              [29.73125076293951, 40.77180480957037],
              [29.615139007568644, 40.78263854980486],
              [29.57069396972662, 40.76597213745123],
              [29.489305496215877, 40.78013992309576],
              [29.354583740234375, 40.755138397217024],
              [29.331806182861385, 40.81624984741205],
              [29.257085800170955, 40.802639007568416],
              [29.254304885864258, 40.814861297607536],
              [29.292638778686808, 40.83319473266613],
              [29.270696640014933, 40.831806182861555],
              [29.265417098999023, 40.8426399230957],
              [29.27930641174322, 40.83652877807617],
              [29.330535888672046, 40.86297988891596],
              [29.348457336425952, 40.891124725342024],
              [29.419984817504826, 40.92051315307623],
              [29.43189430236822, 40.97430038452154],
              [29.481319427490405, 41.0007019042971],
              [29.496175765991495, 41.035736083984375],
              [29.652343750000057, 41.01049041748058],
              [29.748725891113565, 41.05318450927746],
              [29.875808715820312, 41.08005142211931],
              [29.882820129394815, 41.103969573974666],
              [29.863510131835994, 41.14208221435558],
              [30.1526393890382, 41.13763809204096],
              [30.193195343017635, 41.14736175537115],
              [30.192361831665096, 41.16208267211914],
              [30.22597312927263, 41.16180419921875],
              [30.22374725341814, 41.186248779296875],
              [30.25097274780279, 41.186527252197266],
              [30.272916793823413, 41.2120819091798],
            ],
          ],
          [
            [
              [30.264030456543026, 41.21763992309593],
              [30.25986099243181, 41.21430587768566],
              [30.25569534301775, 41.21513748168945],
              [30.257360458374308, 41.21763992309593],
              [30.264030456543026, 41.21763992309593],
            ],
          ],
        ],
      },
      properties: {
        name: 'Kocaeli',
        label: {
          lat: 40.96149077999494,
          lng: 29.685052447315087,
        },
      },
      id: 41,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [33.23051834106474, 39.22212600708008],
            [33.37403869628935, 39.037906646728516],
            [33.36212921142584, 38.791782379150504],
            [33.465042114257756, 38.63647079467779],
            [33.364070892333984, 38.537345886230526],
            [33.30143737792986, 38.347045898437614],
            [33.240203857422046, 38.24726104736351],
            [33.24311447143583, 38.201576232910156],
            [33.3625679016115, 38.00362014770519],
            [33.41840744018549, 37.947883605956974],
            [33.495018005371264, 37.93255615234381],
            [33.78624725341791, 37.95702743530279],
            [34.07424926757807, 38.01273727417015],
            [34.147918701172046, 38.00718688964872],
            [34.326908111572436, 37.856449127197266],
            [34.45117568969732, 37.700721740722656],
            [34.45323562622076, 37.6476287841798],
            [34.397258758544865, 37.55559158325207],
            [34.380016326904354, 37.47288131713867],
            [34.384258270263956, 37.45400238037115],
            [34.42032623291021, 37.44654464721674],
            [34.482170104980526, 37.39559936523443],
            [34.51411437988298, 37.333137512207145],
            [34.49520874023432, 37.31381988525396],
            [34.33284759521513, 37.241931915283374],
            [34.31916809082031, 37.22196960449219],
            [34.19761276245134, 37.17826080322277],
            [34.09875869750971, 37.24098968505871],
            [33.930988311767635, 37.27407455444347],
            [33.905017852783374, 37.32161712646507],
            [33.82967376708996, 37.38158416748058],
            [33.726142883301065, 37.60812377929693],
            [33.64541244506853, 37.604286193847884],
            [33.47241973876959, 37.53235626220709],
            [33.406707763672046, 37.454486846923885],
            [33.38849639892584, 37.39728927612316],
            [33.3600692749024, 37.37762451171875],
            [33.296306610107706, 37.37743377685547],
            [33.20130920410173, 37.4533424377442],
            [33.12356185913103, 37.45442581176758],
            [33.05659866333008, 37.38821792602539],
            [32.95408630371094, 37.383758544921875],
            [32.89720153808622, 37.35276412963867],
            [32.86245727539074, 37.27558135986328],
            [32.900009155273494, 37.213756561279524],
            [32.8411598205567, 37.21237945556652],
            [32.76886367797857, 37.233978271484375],
            [32.686759948730526, 37.208473205566406],
            [32.679237365722656, 37.14281845092779],
            [32.63539123535173, 37.07808303833008],
            [32.567897796631144, 37.01802444458008],
            [32.564151763916186, 36.9911346435548],
            [32.62294769287104, 36.94621276855469],
            [32.80971908569347, 36.9109458923341],
            [32.748134613037394, 36.850887298583984],
            [32.60804748535185, 36.78462219238281],
            [32.47058486938482, 36.7511253356933],
            [32.4174423217774, 36.827526092529524],
            [32.29104614257841, 36.85093307495117],
            [32.23294830322283, 37.00030899047857],
            [31.846702575683764, 37.28829956054699],
            [31.727830886840934, 37.32756423950195],
            [31.459989547729435, 37.34154510498041],
            [31.374643325805607, 37.370304107666016],
            [31.323301315307617, 37.42438888549816],
            [31.357999801635913, 37.48129272460949],
            [31.365823745727823, 37.54992675781273],
            [31.450740814209098, 37.77799987792969],
            [31.45230293273943, 37.852764129638786],
            [31.425519943237475, 37.90036773681652],
            [31.424312591552905, 37.96568679809582],
            [31.474828720093058, 38.020690917968864],
            [31.599279403686694, 38.065040588378906],
            [31.61876678466814, 38.105682373046875],
            [31.586572647094897, 38.14508438110357],
            [31.255617141723576, 38.36682128906256],
            [31.244230270386026, 38.41173171997076],
            [31.250438690185604, 38.42662429809576],
            [31.679281234741325, 38.63260269165045],
            [31.6107826232913, 38.67497253417963],
            [31.58945655822771, 38.72563552856445],
            [31.6233043670656, 38.817733764648665],
            [31.708700180053995, 38.95373535156273],
            [31.696891784668253, 39.09305953979515],
            [31.758911132812784, 39.075538635253906],
            [31.829113006591854, 39.100021362304915],
            [31.86066818237333, 39.167995452880916],
            [31.883207321167276, 39.173801422119254],
            [31.973306655883903, 39.10435485839844],
            [32.11332321166998, 39.03137207031273],
            [32.2944526672365, 39.06810379028326],
            [32.47206878662138, 38.994724273681754],
            [32.5559196472168, 39.04980850219738],
            [32.70268630981451, 39.03284835815441],
            [32.742153167724666, 39.082061767578125],
            [32.837898254394815, 39.153533935546875],
            [32.89254760742193, 39.154331207275504],
            [32.96263122558622, 39.126510620117244],
            [33.021648406982706, 39.15932846069347],
            [33.05522155761719, 39.218933105468864],
            [33.115245819091854, 39.22088241577154],
            [33.18780136108427, 39.276828765869084],
            [33.23051834106474, 39.22212600708008],
          ],
        ],
      },
      properties: {
        name: 'Konya',
        label: {
          lat: 38.09159702440437,
          lng: 32.35025872570184,
        },
      },
      id: 42,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.562942504882926, 39.89121246337896],
            [29.67700767517084, 39.90554428100603],
            [29.69292449951189, 39.87970352172863],
            [29.68674087524431, 39.82540512084961],
            [29.722852706909237, 39.74099349975609],
            [29.952077865600756, 39.68215942382835],
            [30.12015342712408, 39.70448303222662],
            [30.18699836730957, 39.69670867919933],
            [30.137981414794922, 39.62377929687523],
            [30.314607620239315, 39.483478546142635],
            [30.317146301269815, 39.36787796020508],
            [30.41478919982916, 39.28709411621094],
            [30.45332908630388, 39.20599746704107],
            [30.44631385803251, 39.18156051635765],
            [30.384635925293253, 39.12631988525396],
            [30.260791778564396, 39.07954406738281],
            [30.17113876342802, 38.902561187744254],
            [30.10215759277372, 38.80748748779308],
            [29.917819976806925, 38.71689987182617],
            [29.894367218017862, 38.70968246459984],
            [29.89125251770048, 38.79011917114258],
            [29.862709045410213, 38.855148315429744],
            [29.68840217590349, 38.89050674438499],
            [29.593931198120174, 38.8758544921875],
            [29.50399398803728, 38.83562088012707],
            [29.305118560791072, 38.78231811523449],
            [29.23378944397001, 38.73334121704124],
            [29.090955734253157, 38.739379882812614],
            [29.03648948669445, 38.72769927978521],
            [29.032846450805664, 38.8513298034668],
            [29.01067733764677, 38.87325668334961],
            [28.98968505859375, 38.956939697265625],
            [28.95732307434082, 39.008655548095646],
            [28.886121749877987, 39.0752220153808],
            [28.695968627929688, 39.12071228027338],
            [28.66218757629406, 39.163825988769474],
            [28.661375045776367, 39.2337074279788],
            [28.793338775634766, 39.283752441406364],
            [28.883300781250227, 39.366607666015625],
            [28.940580368041935, 39.519817352295036],
            [28.934938430786246, 39.550872802734546],
            [28.96330642700218, 39.58925628662132],
            [29.021434783935547, 39.55774688720703],
            [29.092315673828125, 39.543609619140625],
            [29.229446411132983, 39.55765151977539],
            [29.247165679931697, 39.5811576843264],
            [29.267078399658203, 39.692760467529354],
            [29.336360931396655, 39.77615356445318],
            [29.406822204590014, 39.90652847290045],
            [29.45207023620617, 39.92456817626976],
            [29.562942504882926, 39.89121246337896],
          ],
        ],
      },
      properties: {
        name: 'Kütahya',
        label: {
          lat: 39.31420572248606,
          lng: 29.357617743235206,
        },
      },
      id: 43,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [38.42752075195318, 39.1165504455567],
            [38.52343368530268, 39.11494064331055],
            [38.617038726806925, 39.079467773437614],
            [38.65647125244135, 39.05071258544916],
            [38.68186950683611, 39.00462722778332],
            [38.613189697265625, 39.010799407958984],
            [38.587699890136776, 38.97869491577177],
            [38.631317138672046, 38.876541137695426],
            [38.62973022460966, 38.75020980834955],
            [38.4956245422365, 38.74408340454113],
            [38.462364196777344, 38.72850799560558],
            [38.34734344482439, 38.5861930847168],
            [38.37929534912138, 38.512310028076286],
            [38.429889678955135, 38.47502899169933],
            [38.525379180908374, 38.46200180053722],
            [38.684249877929744, 38.41202545166021],
            [38.82920074462896, 38.40208816528332],
            [38.968620300293026, 38.30895233154291],
            [39.119144439697436, 38.33825683593756],
            [39.142196655273494, 38.285404205322266],
            [39.12298965454107, 38.197509765625114],
            [39.074615478515796, 38.14497375488281],
            [39.00511550903326, 38.11749267578125],
            [38.85887527465832, 38.09242630004883],
            [38.65533828735357, 38.09172439575201],
            [38.562923431396484, 38.12447357177746],
            [38.62433242797846, 38.169216156006144],
            [38.634452819824276, 38.19916915893566],
            [38.545761108398494, 38.230003356933594],
            [38.471187591552734, 38.21823120117193],
            [38.13481521606451, 38.089435577392635],
            [38.18105316162115, 37.91896057128906],
            [37.97327423095703, 37.86019515991222],
            [37.82437133789068, 37.8814582824707],
            [37.76950454711931, 37.86634826660179],
            [37.73728942871122, 37.83412933349632],
            [37.66350555419916, 37.835338592529354],
            [37.558151245117244, 37.808689117431754],
            [37.69754028320318, 38.03805160522461],
            [37.77407455444353, 38.22705841064459],
            [37.773830413818644, 38.31008911132807],
            [37.69929885864275, 38.358089447021484],
            [37.46228408813482, 38.45021438598633],
            [37.36172103881853, 38.46540832519531],
            [37.20303344726591, 38.458873748779524],
            [37.19495010376005, 38.49284362792969],
            [37.274082183838175, 38.554397583007926],
            [37.29307556152372, 38.59968948364269],
            [37.48601150512724, 38.70621490478527],
            [37.57392501831083, 38.7763786315918],
            [37.596317291259936, 38.836570739746264],
            [37.5527420043947, 38.92592239379883],
            [37.55189514160185, 38.95935440063499],
            [37.58811187744152, 39.00992202758795],
            [37.780391693115234, 39.001106262207315],
            [37.93951416015625, 39.059078216552734],
            [38.17367935180681, 39.07107162475586],
            [38.30748748779297, 39.13846969604515],
            [38.42752075195318, 39.1165504455567],
          ],
        ],
      },
      properties: {
        name: 'Malatya',
        label: {
          lat: 38.56968895790415,
          lng: 37.7192350166602,
        },
      },
      id: 44,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.679256439208984, 39.34687423706055],
            [27.79146385192871, 39.35728836059582],
            [27.881540298462085, 39.345581054687614],
            [27.896583557128906, 39.35721206665045],
            [27.917137145996037, 39.329010009765625],
            [27.8823184967041, 39.26954650878906],
            [27.895751953125114, 39.2360725402832],
            [27.978343963623274, 39.22848129272484],
            [28.010795593261662, 39.210613250732536],
            [28.057016372680835, 39.172363281250114],
            [28.112621307373274, 39.062858581543026],
            [28.15238761901861, 39.045005798339844],
            [28.466716766357536, 39.12395095825201],
            [28.620576858520792, 39.18162918090832],
            [28.66218757629406, 39.163825988769474],
            [28.70793151855463, 39.11395263671898],
            [28.855918884277457, 39.08648300170893],
            [28.91626358032255, 39.05462646484398],
            [28.987447738647745, 38.961959838867244],
            [29.03646087646507, 38.83010482788097],
            [29.03648948669445, 38.72769927978521],
            [28.87877845764166, 38.637416839599666],
            [28.84781837463379, 38.57641983032238],
            [28.840629577637003, 38.49005126953148],
            [28.856254577636776, 38.39474105834961],
            [28.82542800903326, 38.355316162109375],
            [28.92095375061041, 38.265453338623104],
            [28.801586151123104, 38.218879699707145],
            [28.789449691772518, 38.14189910888672],
            [28.71974372863798, 38.09927368164074],
            [28.68299102783203, 38.11477661132807],
            [28.559946060180778, 38.108661651611385],
            [28.527257919311467, 38.13525772094738],
            [28.474098205566577, 38.25453948974621],
            [28.433549880981445, 38.295082092285156],
            [28.22292518615734, 38.33587265014654],
            [28.16123199462919, 38.360778808593864],
            [28.145027160644815, 38.39204025268555],
            [28.117492675781477, 38.40279769897484],
            [28.001060485839787, 38.399547576904524],
            [27.853576660156534, 38.33378982543957],
            [27.82133483886747, 38.35077285766613],
            [27.742670059204045, 38.446926116943644],
            [27.56540679931652, 38.48628616333025],
            [27.457939147949446, 38.56347656250006],
            [27.33832931518566, 38.58828735351585],
            [27.279998779296932, 38.572151184082145],
            [27.22967720031761, 38.741630554199446],
            [27.124540328979776, 38.77974319458019],
            [27.168153762817496, 38.89170837402344],
            [27.37003517150879, 38.9268493652346],
            [27.387517929077205, 38.95204162597662],
            [27.433935165405387, 38.96704864501953],
            [27.50539588928217, 39.01988601684582],
            [27.504394531249943, 39.11765670776373],
            [27.470958709716797, 39.1718826293947],
            [27.45876693725586, 39.29547119140625],
            [27.407686233520792, 39.38151550292969],
            [27.516485214233455, 39.41384506225586],
            [27.612707138061694, 39.36009979248047],
            [27.679256439208984, 39.34687423706055],
          ],
        ],
      },
      properties: {
        name: 'Manisa',
        label: {
          lat: 38.76205612437413,
          lng: 27.86696953292517,
        },
      },
      id: 45,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [40.80224990844732, 37.717403411865234],
            [41.051792144775675, 37.73957443237305],
            [41.05427551269537, 37.71387100219749],
            [41.13343429565458, 37.63745117187506],
            [41.18900680542009, 37.556800842285384],
            [41.4461212158206, 37.55442810058594],
            [41.573192596435604, 37.57748413085932],
            [41.686473846435604, 37.67586898803711],
            [41.8738899230957, 37.74024581909191],
            [41.95733642578125, 37.63766860961914],
            [41.93354797363281, 37.585899353027344],
            [41.94921875000006, 37.52552032470726],
            [41.90201187133795, 37.49835586547857],
            [41.763572692871264, 37.47929763793957],
            [41.74073028564459, 37.468338012695426],
            [41.73814773559576, 37.4432373046875],
            [41.73899078369158, 37.33707046508789],
            [41.75641632080084, 37.296710968017635],
            [41.779117584228686, 37.2880554199221],
            [41.848300933838175, 37.30717849731445],
            [41.86858367919933, 37.276142120361385],
            [41.887989044189396, 37.209285736083984],
            [41.8692359924317, 37.13902282714844],
            [41.55814361572283, 37.085227966308594],
            [41.27106094360357, 37.07924270629883],
            [41.218410491943416, 37.063602447509766],
            [41.169742584228686, 37.092239379882926],
            [40.94995498657221, 37.12441253662115],
            [40.885929107666186, 37.124263763427734],
            [40.850471496582315, 37.1066246032716],
            [40.781726837158146, 37.120582580566634],
            [40.54626846313482, 37.026714324951456],
            [40.438137054443416, 37.00880050659174],
            [40.25516510009794, 36.916130065918026],
            [40.1816139221192, 36.94679260253912],
            [40.13233947753935, 37.02339935302729],
            [40.11487960815458, 37.130916595458984],
            [39.94049453735357, 37.414386749267635],
            [39.881374359130916, 37.55633163452154],
            [40.01730346679699, 37.5563125610351],
            [40.09448623657255, 37.589130401611555],
            [40.20661544799816, 37.566856384277344],
            [40.280414581298885, 37.569232940674],
            [40.41819000244146, 37.6458854675293],
            [40.5161018371582, 37.650424957275504],
            [40.535087585449276, 37.67518997192394],
            [40.54299545288086, 37.733390808105526],
            [40.60204696655302, 37.787681579589844],
            [40.64764404296881, 37.76625823974621],
            [40.715831756591854, 37.761577606201286],
            [40.752021789550895, 37.730331420898494],
            [40.80224990844732, 37.717403411865234],
          ],
        ],
      },
      properties: {
        name: 'Mardin',
        label: {
          lat: 37.410353177898486,
          lng: 40.70749578252821,
        },
      },
      id: 47,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [33.53041839599638, 36.129028320312614],
              [33.534862518310604, 36.12152862548834],
              [33.52875137329107, 36.11930465698248],
              [33.53152847290039, 36.124027252197266],
              [33.53041839599638, 36.129028320312614],
            ],
          ],
          [
            [
              [33.69486236572294, 36.16125106811546],
              [33.69819259643583, 36.16041564941429],
              [33.69819259643583, 36.159305572509766],
              [33.69180679321295, 36.16069412231451],
              [33.69486236572294, 36.16125106811546],
            ],
          ],
          [
            [
              [33.77958297729498, 36.20097351074219],
              [33.77708435058588, 36.18430709838884],
              [33.75680541992193, 36.182361602783374],
              [33.761806488037166, 36.19013977050781],
              [33.77958297729498, 36.20097351074219],
            ],
          ],
          [
            [
              [33.828193664551065, 36.26930618286161],
              [33.82902908325224, 36.26708221435575],
              [33.8262481689456, 36.264583587646484],
              [33.8256950378418, 36.267360687256144],
              [33.828193664551065, 36.26930618286161],
            ],
          ],
          [
            [
              [34.914901733398494, 37.12962722778326],
              [34.93461608886747, 37.076961517333984],
              [35.00078582763683, 37.041458129882926],
              [35.05463027954107, 36.97039413452154],
              [35.0698127746582, 36.833457946777344],
              [35.034801483154354, 36.770996093750114],
              [34.949817657470646, 36.7540168762207],
              [34.90958404541021, 36.72375106811546],
              [34.853748321533374, 36.7801399230957],
              [34.76291656494146, 36.809581756592024],
              [34.65402603149431, 36.80764007568371],
              [34.560695648193644, 36.76847076416021],
              [34.54513931274431, 36.74291610717768],
              [34.47263717651384, 36.70847320556669],
              [34.429862976074276, 36.663749694824276],
              [34.27847290039074, 36.585693359375],
              [34.168472290039006, 36.466804504394645],
              [34.121250152588175, 36.45069503784208],
              [34.110416412353686, 36.425415039062614],
              [34.07930374145502, 36.41041564941406],
              [34.07263946533209, 36.31791687011736],
              [34.04347229003912, 36.29486083984398],
              [33.99708175659208, 36.30402755737316],
              [33.97652816772478, 36.275970458984375],
              [33.99791717529325, 36.28569412231457],
              [33.999027252197436, 36.284584045410384],
              [33.96263885498075, 36.23180389404308],
              [33.93763732910185, 36.28958511352539],
              [33.87014007568388, 36.31624984741205],
              [33.83235931396513, 36.285137176513956],
              [33.84097290039091, 36.27513885498041],
              [33.81486129760748, 36.273750305176065],
              [33.80902862548834, 36.2401390075683],
              [33.69847106933622, 36.173751831054915],
              [33.687362670898494, 36.159305572509766],
              [33.699859619140796, 36.14319610595703],
              [33.6895828247072, 36.13458251953142],
              [33.67208480834955, 36.14625167846708],
              [33.68347167968767, 36.1576385498048],
              [33.65930557250971, 36.1601371765139],
              [33.661251068115405, 36.18680572509777],
              [33.64791488647478, 36.193748474121264],
              [33.59291839599615, 36.176528930664006],
              [33.56097030639654, 36.12541580200218],
              [33.474029541015796, 36.159305572509766],
              [33.394584655761776, 36.12486267089844],
              [33.35235977172863, 36.15430450439459],
              [33.28930664062506, 36.129028320312614],
              [33.14652633666998, 36.137916564941634],
              [33.12513732910185, 36.13013839721697],
              [33.08152770996111, 36.06958389282238],
              [33.05180740356474, 36.0948600769043],
              [32.9501380920413, 36.10374832153349],
              [32.86875152587902, 36.07069396972656],
              [32.8031959533692, 36.015415191650504],
              [32.679306030273494, 36.038471221923885],
              [32.566024780273494, 36.099861145019474],
              [32.60036849975586, 36.1391334533692],
              [32.63268661499029, 36.225891113281364],
              [32.646808624267635, 36.28602600097656],
              [32.63582229614252, 36.38359451293945],
              [32.65814208984381, 36.446079254150504],
              [32.84065246582037, 36.43311691284191],
              [33.05472183227556, 36.468769073486385],
              [33.21320724487322, 36.52260971069347],
              [33.23061370849638, 36.55921173095703],
              [33.217575073242244, 36.58370590209978],
              [33.096580505371264, 36.63430023193354],
              [33.04000473022461, 36.67696380615246],
              [32.9618453979495, 36.809215545654524],
              [33.11583709716814, 36.85238647460943],
              [33.328708648681754, 36.976009368896484],
              [33.39587783813505, 37.00056838989269],
              [33.52960968017584, 37.0029754638673],
              [33.62107849121094, 37.046009063720874],
              [33.67952346801752, 37.04685974121088],
              [33.740608215332315, 37.026695251464844],
              [33.836917877197436, 37.05025863647461],
              [33.98369598388689, 37.12459564209007],
              [34.137424468994254, 37.14317321777338],
              [34.31916809082031, 37.22196960449219],
              [34.33284759521513, 37.241931915283374],
              [34.49090576171881, 37.310096740722656],
              [34.51411437988298, 37.333137512207145],
              [34.50988006591825, 37.34932327270508],
              [34.59980010986334, 37.351367950439396],
              [34.70718383789068, 37.39586639404308],
              [34.78332519531256, 37.39600372314476],
              [34.914901733398494, 37.12962722778326],
            ],
          ],
        ],
      },
      properties: {
        name: 'Mersin',
        label: {
          lat: 36.82681163588383,
          lng: 33.71307222541405,
        },
      },
      id: 33,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [29.059860229492358, 36.5420837402346],
              [29.061805725097656, 36.54069519042986],
              [29.06041717529331, 36.53874969482439],
              [29.058750152588004, 36.53985977172874],
              [29.059860229492358, 36.5420837402346],
            ],
          ],
          [
            [
              [29.07208251953125, 36.55541610717785],
              [29.07597160339367, 36.55347061157255],
              [29.064027786255338, 36.554306030273494],
              [29.065694808959904, 36.55541610717785],
              [29.07208251953125, 36.55541610717785],
            ],
          ],
          [
            [
              [28.035972595214787, 36.55902862548851],
              [28.036527633666992, 36.55541610717785],
              [28.03513908386242, 36.554584503174055],
              [28.03430557251005, 36.55708312988281],
              [28.035972595214787, 36.55902862548851],
            ],
          ],
          [
            [
              [28.040693283080998, 36.563472747802734],
              [28.03847312927286, 36.56124877929682],
              [28.035694122314794, 36.56097412109398],
              [28.036527633666992, 36.562915802002124],
              [28.040693283080998, 36.563472747802734],
            ],
          ],
          [
            [
              [28.127082824707486, 36.60069274902355],
              [28.129028320312614, 36.595695495605526],
              [28.121805191040323, 36.59763717651367],
              [28.122638702392692, 36.59930419921898],
              [28.127082824707486, 36.60069274902355],
            ],
          ],
          [
            [
              [28.056804656982877, 36.619026184082145],
              [28.05763626098667, 36.61680603027344],
              [28.053195953369254, 36.613193511963004],
              [28.055414199829556, 36.619026184082145],
              [28.056804656982877, 36.619026184082145],
            ],
          ],
          [
            [
              [28.052917480468864, 36.62736129760742],
              [28.05347251892084, 36.62597274780285],
              [28.053749084472656, 36.62319564819336],
              [28.050693511963345, 36.62430572509771],
              [28.052917480468864, 36.62736129760742],
            ],
          ],
          [
            [
              [28.763750076294343, 36.62874984741234],
              [28.765138626099088, 36.62680435180664],
              [28.761528015136662, 36.62597274780285],
              [28.76124954223667, 36.62708282470703],
              [28.763750076294343, 36.62874984741234],
            ],
          ],
          [
            [
              [28.054582595825195, 36.65013885498064],
              [28.05985832214361, 36.649028778076456],
              [28.060140609741154, 36.64736175537132],
              [28.04875183105463, 36.648193359375114],
              [28.054582595825195, 36.65013885498064],
            ],
          ],
          [
            [
              [29.1059703826906, 36.65319442749046],
              [29.099582672119254, 36.645973205566406],
              [29.097362518310547, 36.6462516784668],
              [29.098196029663484, 36.65263748168951],
              [29.1059703826906, 36.65319442749046],
            ],
          ],
          [
            [
              [27.510417938232763, 36.66291809082048],
              [27.512083053588924, 36.66097259521496],
              [27.50930786132841, 36.654582977295036],
              [27.5076389312747, 36.65930557250982],
              [27.510417938232763, 36.66291809082048],
            ],
          ],
          [
            [
              [29.046527862549283, 36.66458511352539],
              [29.054304122924805, 36.660415649414176],
              [29.043195724487248, 36.65180587768555],
              [29.04125022888195, 36.66152954101574],
              [29.046527862549283, 36.66458511352539],
            ],
          ],
          [
            [
              [28.014303207397518, 36.67013931274437],
              [28.014303207397518, 36.6668052673341],
              [28.012916564941577, 36.66652679443354],
              [28.011528015136832, 36.66958236694359],
              [28.014303207397518, 36.67013931274437],
            ],
          ],
          [
            [
              [28.895971298217944, 36.67041778564476],
              [28.90736389160162, 36.6648597717288],
              [28.90791702270502, 36.65124893188499],
              [28.888748168945256, 36.665973663330305],
              [28.895971298217944, 36.67041778564476],
            ],
          ],
          [
            [
              [28.0362491607666, 36.67124938964872],
              [28.046247482299975, 36.65625000000017],
              [28.04152870178234, 36.64958190917969],
              [28.027639389038143, 36.659862518310774],
              [28.0362491607666, 36.67124938964872],
            ],
          ],
          [
            [
              [29.03013801574741, 36.671806335449276],
              [29.035972595214957, 36.66875076293945],
              [29.036527633667333, 36.6668052673341],
              [29.029861450195426, 36.66819381713867],
              [29.03013801574741, 36.671806335449276],
            ],
          ],
          [
            [
              [28.042083740234716, 36.67319488525402],
              [28.041805267334325, 36.66875076293945],
              [28.04013824462902, 36.66847229003906],
              [28.039304733276822, 36.672084808349666],
              [28.042083740234716, 36.67319488525402],
            ],
          ],
          [
            [
              [28.91680526733404, 36.68180465698265],
              [28.939582824707088, 36.6737518310548],
              [28.91486167907715, 36.654304504394815],
              [28.909305572509766, 36.672084808349666],
              [28.91680526733404, 36.68180465698265],
            ],
          ],
          [
            [
              [28.043750762939453, 36.68180465698265],
              [28.042638778686523, 36.68291854858421],
              [28.04513740539562, 36.683471679687614],
              [28.04513740539562, 36.68264007568365],
              [28.043750762939453, 36.68180465698265],
            ],
          ],
          [
            [
              [28.69819450378418, 36.694862365722884],
              [28.69819450378418, 36.692638397217024],
              [28.690416336059684, 36.69208145141607],
              [28.692363739013786, 36.69430541992193],
              [28.69819450378418, 36.694862365722884],
            ],
          ],
          [
            [
              [28.93291664123535, 36.69736099243164],
              [28.93402862548868, 36.69458389282249],
              [28.932081222534407, 36.69402694702154],
              [28.930971145630053, 36.69625091552746],
              [28.93291664123535, 36.69736099243164],
            ],
          ],
          [
            [
              [29.00597190856945, 36.699028015136946],
              [29.013750076294116, 36.69597244262707],
              [29.013193130493164, 36.69347381591814],
              [29.00597190856945, 36.69374847412138],
              [29.00597190856945, 36.699028015136946],
            ],
          ],
          [
            [
              [28.928194046020565, 36.7001380920413],
              [28.930416107177678, 36.69680404663086],
              [28.92597198486328, 36.69291687011719],
              [28.923196792602937, 36.698749542236555],
              [28.928194046020565, 36.7001380920413],
            ],
          ],
          [
            [
              [27.988193511962834, 36.704860687255916],
              [27.990415573120515, 36.70264053344738],
              [27.98986053466797, 36.700973510742415],
              [27.98736190795904, 36.70180511474621],
              [27.988193511962834, 36.704860687255916],
            ],
          ],
          [
            [
              [28.93486022949247, 36.70875167846691],
              [28.935695648193416, 36.70375061035156],
              [28.932081222534407, 36.698749542236555],
              [28.933473587036133, 36.707359313965014],
              [28.93486022949247, 36.70875167846691],
            ],
          ],
          [
            [
              [27.997083663940828, 36.710140228271484],
              [27.99819374084518, 36.70930480957048],
              [27.995695114136083, 36.707084655761776],
              [27.994583129882756, 36.70902633666992],
              [27.997083663940828, 36.710140228271484],
            ],
          ],
          [
            [
              [28.933195114135742, 36.7120819091798],
              [28.933195114135742, 36.70791625976557],
              [28.931804656982422, 36.707359313965014],
              [28.92958259582531, 36.709861755371094],
              [28.933195114135742, 36.7120819091798],
            ],
          ],
          [
            [
              [28.248472213745515, 36.71458435058605],
              [28.24735832214361, 36.7120819091798],
              [28.242639541625977, 36.713748931884936],
              [28.244583129883267, 36.71458435058605],
              [28.248472213745515, 36.71458435058605],
            ],
          ],
          [
            [
              [28.00180435180704, 36.72013854980486],
              [28.004304885864713, 36.71791839599632],
              [28.004583358765103, 36.71319580078131],
              [27.99986076354992, 36.71791839599632],
              [28.00180435180704, 36.72013854980486],
            ],
          ],
          [
            [
              [28.033750534057674, 36.72652816772478],
              [28.031805038452546, 36.71791839599632],
              [28.014862060546875, 36.71180725097679],
              [28.01513862609869, 36.72236251831055],
              [28.033750534057674, 36.72652816772478],
            ],
          ],
          [
            [
              [28.05208206176752, 36.73541641235357],
              [28.058195114136026, 36.733470916748104],
              [28.064027786254996, 36.73485946655302],
              [28.0665283203125, 36.733749389648665],
              [28.060693740845124, 36.72652816772478],
              [28.04513740539562, 36.725139617920036],
              [28.05208206176752, 36.73541641235357],
            ],
          ],
          [
            [
              [28.93986129760748, 36.73708343505888],
              [28.950416564941406, 36.7254180908206],
              [28.938472747802734, 36.71763992309576],
              [28.933750152588118, 36.72402954101568],
              [28.93986129760748, 36.73708343505888],
            ],
          ],
          [
            [
              [27.40541648864746, 36.74291610717768],
              [27.413473129272518, 36.73875045776367],
              [27.414028167725064, 36.73764038085949],
              [27.404306411743107, 36.74124908447294],
              [27.40541648864746, 36.74291610717768],
            ],
          ],
          [
            [
              [27.962360382080135, 36.75291824340843],
              [27.966247558593977, 36.75208282470726],
              [27.965694427490575, 36.74958419799816],
              [27.962638854980526, 36.75041580200195],
              [27.962360382080135, 36.75291824340843],
            ],
          ],
          [
            [
              [27.791528701782227, 36.75319290161144],
              [27.792083740234375, 36.75236129760765],
              [27.790418624878043, 36.751251220703125],
              [27.79013633728067, 36.75236129760765],
              [27.791528701782227, 36.75319290161144],
            ],
          ],
          [
            [
              [27.76458358764654, 36.75347137451183],
              [27.762361526489258, 36.75152587890631],
              [27.759027481079386, 36.751251220703125],
              [27.759860992431754, 36.75263977050787],
              [27.76458358764654, 36.75347137451183],
            ],
          ],
          [
            [
              [27.775972366333065, 36.756805419921875],
              [27.775972366333065, 36.75347137451183],
              [27.77375030517578, 36.75208282470726],
              [27.773193359375, 36.75485992431658],
              [27.775972366333065, 36.756805419921875],
            ],
          ],
          [
            [
              [27.80763816833513, 36.76069259643555],
              [27.808195114136083, 36.759304046631144],
              [27.804582595825252, 36.75763702392584],
              [27.80541610717819, 36.760417938232706],
              [27.80763816833513, 36.76069259643555],
            ],
          ],
          [
            [
              [28.05958366394077, 36.76180648803705],
              [28.058471679687443, 36.759304046631144],
              [28.055973052978914, 36.759582519531364],
              [28.057083129883267, 36.76180648803705],
              [28.05958366394077, 36.76180648803705],
            ],
          ],
          [
            [
              [28.03430557251005, 36.76235961914085],
              [28.03736114501953, 36.76097106933594],
              [28.03736114501953, 36.759860992431754],
              [28.033472061157283, 36.760139465332145],
              [28.03430557251005, 36.76235961914085],
            ],
          ],
          [
            [
              [28.12375068664545, 36.762916564941406],
              [28.127082824707486, 36.76180648803705],
              [28.12680625915533, 36.760417938232706],
              [28.124305725097827, 36.76097106933594],
              [28.12375068664545, 36.762916564941406],
            ],
          ],
          [
            [
              [27.46819686889694, 36.77069473266607],
              [27.470138549805085, 36.76930618286133],
              [27.470138549805085, 36.768196105956974],
              [27.467361450195426, 36.76958465576172],
              [27.46819686889694, 36.77069473266607],
            ],
          ],
          [
            [
              [27.46069526672369, 36.775138854980696],
              [27.46458244323736, 36.77236175537121],
              [27.464305877685547, 36.77069473266607],
              [27.45874977111839, 36.773193359375],
              [27.46069526672369, 36.775138854980696],
            ],
          ],
          [
            [
              [28.440971374512117, 36.777084350585994],
              [28.442638397216854, 36.771526336669865],
              [28.430973052978743, 36.77041625976568],
              [28.436805725097713, 36.777637481689396],
              [28.440971374512117, 36.777084350585994],
            ],
          ],
          [
            [
              [28.599027633666992, 36.79763793945335],
              [28.597639083862248, 36.795417785644815],
              [28.595417022705135, 36.795696258545206],
              [28.59652709960949, 36.79735946655296],
              [28.599027633666992, 36.79763793945335],
            ],
          ],
          [
            [
              [28.258750915527287, 36.809860229492244],
              [28.259859085083065, 36.797916412353516],
              [28.243194580078352, 36.8079185485841],
              [28.25319480896013, 36.80736160278332],
              [28.258750915527287, 36.809860229492244],
            ],
          ],
          [
            [
              [28.28819465637224, 36.821250915527344],
              [28.28791618347168, 36.81902694702143],
              [28.27819442749046, 36.81958389282238],
              [28.278472900391023, 36.82069396972673],
              [28.28819465637224, 36.821250915527344],
            ],
          ],
          [
            [
              [28.444860458373967, 36.86486053466808],
              [28.445972442627294, 36.86291503906256],
              [28.445972442627294, 36.862083435058764],
              [28.444026947021598, 36.86319351196312],
              [28.444860458373967, 36.86486053466808],
            ],
          ],
          [
            [
              [28.0262508392334, 36.868751525878906],
              [28.027639389038143, 36.865970611572266],
              [28.01791572570835, 36.867916107177734],
              [28.01791572570835, 36.868473052978686],
              [28.0262508392334, 36.868751525878906],
            ],
          ],
          [
            [
              [28.03736114501953, 36.871528625488395],
              [28.03736114501953, 36.87014007568382],
              [28.032083511352937, 36.868194580078125],
              [28.03430557251005, 36.870693206787394],
              [28.03736114501953, 36.871528625488395],
            ],
          ],
          [
            [
              [28.042360305786133, 36.87652587890619],
              [28.04513740539562, 36.87625122070335],
              [28.045415878296183, 36.87458419799805],
              [28.042360305786133, 36.8731956481933],
              [28.042360305786133, 36.87652587890619],
            ],
          ],
          [
            [
              [28.03458404541061, 36.885692596435774],
              [28.0362491607666, 36.88402938842785],
              [28.03430557251005, 36.882637023925724],
              [28.033750534057674, 36.88541793823259],
              [28.03458404541061, 36.885692596435774],
            ],
          ],
          [
            [
              [28.15569496154808, 36.93763732910179],
              [28.1576385498048, 36.93458175659191],
              [28.154861450195312, 36.93347167968773],
              [28.153194427490575, 36.935699462890625],
              [28.15569496154808, 36.93763732910179],
            ],
          ],
          [
            [
              [28.15458297729532, 36.94597244262718],
              [28.156805038452433, 36.945137023926065],
              [28.155971527099666, 36.94374847412132],
              [28.15402984619135, 36.94402694702171],
              [28.15458297729532, 36.94597244262718],
            ],
          ],
          [
            [
              [27.30624961853067, 36.9523620605471],
              [27.306528091431062, 36.95097351074219],
              [27.304582595825195, 36.94985961914068],
              [27.303472518921012, 36.95180511474615],
              [27.30624961853067, 36.9523620605471],
            ],
          ],
          [
            [
              [28.19847488403326, 36.96374893188488],
              [28.200138092041016, 36.958751678467024],
              [28.18930435180704, 36.95791625976591],
              [28.193195343017692, 36.96180725097673],
              [28.19847488403326, 36.96374893188488],
            ],
          ],
          [
            [
              [27.579305648803654, 36.977085113525675],
              [27.577917098999478, 36.97819519042963],
              [27.581527709961335, 36.97874832153343],
              [27.58097267150879, 36.97763824462908],
              [27.579305648803654, 36.977085113525675],
            ],
          ],
          [
            [
              [27.65569686889677, 36.979862213134936],
              [27.65736198425293, 36.97874832153343],
              [27.65736198425293, 36.97763824462908],
              [27.655136108398438, 36.97902679443382],
              [27.65569686889677, 36.979862213134936],
            ],
          ],
          [
            [
              [27.58958244323742, 36.980140686035156],
              [27.60013961791998, 36.97541809082037],
              [27.60208320617687, 36.96652603149414],
              [27.591806411743505, 36.96847152709984],
              [27.58958244323742, 36.980140686035156],
            ],
          ],
          [
            [
              [27.23180580139166, 36.98708343505865],
              [27.232639312744595, 36.9859733581543],
              [27.233194351196403, 36.98152923584007],
              [27.229028701782568, 36.983196258545206],
              [27.23180580139166, 36.98708343505865],
            ],
          ],
          [
            [
              [27.197639465332486, 36.993751525879134],
              [27.199306488037053, 36.99291610717802],
              [27.199028015136662, 36.991527557373274],
              [27.195692062378214, 36.99236297607422],
              [27.197639465332486, 36.993751525879134],
            ],
          ],
          [
            [
              [28.20624732971197, 36.99569320678728],
              [28.20986175537155, 36.990699768066634],
              [28.200416564941406, 36.99097061157249],
              [28.20180511474632, 36.99347305297857],
              [28.20624732971197, 36.99569320678728],
            ],
          ],
          [
            [
              [27.428195953369084, 36.997638702392635],
              [27.484029769897518, 36.97763824462908],
              [27.492639541626147, 36.96736145019531],
              [27.476528167725007, 36.95791625976591],
              [27.445693969726562, 36.96986007690441],
              [27.428195953369084, 36.997638702392635],
            ],
          ],
          [
            [
              [28.208751678467195, 36.999584197998104],
              [28.209583282471158, 36.997081756592024],
              [28.204860687255803, 36.997917175293196],
              [28.205137252807617, 36.999584197998104],
              [28.208751678467195, 36.999584197998104],
            ],
          ],
          [
            [
              [27.385139465332315, 37.00180435180664],
              [27.386806488037053, 36.997360229492415],
              [27.384027481079556, 36.99013900756836],
              [27.379583358764762, 36.99486160278349],
              [27.385139465332315, 37.00180435180664],
            ],
          ],
          [
            [
              [28.241249084472656, 37.003471374511946],
              [28.241804122925203, 37.00152587890625],
              [28.23791694641119, 37.0020828247072],
              [28.23791694641119, 37.0029182434082],
              [28.241249084472656, 37.003471374511946],
            ],
          ],
          [
            [
              [27.180971145630224, 37.006248474121264],
              [27.183471679687727, 37.00569534301786],
              [27.183471679687727, 37.00485992431652],
              [27.180416107177848, 37.00430679321312],
              [27.180971145630224, 37.006248474121264],
            ],
          ],
          [
            [
              [27.36013793945358, 37.01069259643583],
              [27.362361907959098, 37.00763702392601],
              [27.359304428100643, 37.005973815918026],
              [27.356805801391545, 37.01013946533226],
              [27.36013793945358, 37.01069259643583],
            ],
          ],
          [
            [
              [27.21986007690475, 37.01347351074213],
              [27.224304199218807, 37.00819396972656],
              [27.2048606872562, 36.99625015258789],
              [27.203193664550895, 36.99874877929699],
              [27.21986007690475, 37.01347351074213],
            ],
          ],
          [
            [
              [27.203472137451286, 37.05097198486351],
              [27.203472137451286, 37.04597091674816],
              [27.198192596435717, 37.04902648925804],
              [27.200416564941406, 37.05097198486351],
              [27.203472137451286, 37.05097198486351],
            ],
          ],
          [
            [
              [27.213472366333065, 37.08986282348627],
              [27.213750839233626, 37.08430480957031],
              [27.204027175903263, 37.082359313964844],
              [27.207639694214265, 37.08930587768572],
              [27.213472366333065, 37.08986282348627],
            ],
          ],
          [
            [
              [27.236803054809684, 37.090694427490234],
              [27.240695953369084, 37.08902740478533],
              [27.241249084473054, 37.08763885498058],
              [27.23208427429205, 37.088748931884766],
              [27.236803054809684, 37.090694427490234],
            ],
          ],
          [
            [
              [27.47486114501953, 37.124027252197436],
              [27.47291755676315, 37.11847305297846],
              [27.46958351135254, 37.11819458007807],
              [27.46902847290073, 37.11958312988281],
              [27.47486114501953, 37.124027252197436],
            ],
          ],
          [
            [
              [27.481807708740575, 37.13069534301775],
              [27.480695724487248, 37.12513732910179],
              [27.47708129882824, 37.12513732910179],
              [27.47791671752975, 37.129028320312614],
              [27.481807708740575, 37.13069534301775],
            ],
          ],
          [
            [
              [27.256528854370572, 37.13375091552757],
              [27.257917404174748, 37.132915496826456],
              [27.257917404174748, 37.13097381591791],
              [27.255418777466218, 37.1318054199221],
              [27.256528854370572, 37.13375091552757],
            ],
          ],
          [
            [
              [27.394027709961335, 37.140415191650334],
              [27.389028549194734, 37.13624954223633],
              [27.385139465332315, 37.13763809204107],
              [27.385414123535156, 37.13958358764654],
              [27.394027709961335, 37.140415191650334],
            ],
          ],
          [
            [
              [27.53236389160162, 37.165138244628906],
              [27.52874946594261, 37.14125061035185],
              [27.489860534668082, 37.14125061035185],
              [27.49458312988287, 37.15680694580084],
              [27.53236389160162, 37.165138244628906],
            ],
          ],
          [
            [
              [27.36291885376005, 37.1751403808596],
              [27.378194808960018, 37.16764068603533],
              [27.379028320312955, 37.16319274902355],
              [27.367359161377294, 37.16236114501976],
              [27.36291885376005, 37.1751403808596],
            ],
          ],
          [
            [
              [27.355972290039176, 37.17708206176775],
              [27.35958480834961, 37.176250457763956],
              [27.360414505004996, 37.1740264892581],
              [27.354028701782624, 37.17235946655296],
              [27.355972290039176, 37.17708206176775],
            ],
          ],
          [
            [
              [27.521249771118335, 37.19736099243187],
              [27.522918701172046, 37.196529388427734],
              [27.522918701172046, 37.19569396972656],
              [27.519027709961392, 37.196804046630916],
              [27.521249771118335, 37.19736099243187],
            ],
          ],
          [
            [
              [27.55013656616211, 37.202640533447436],
              [27.55180549621582, 37.20097351074213],
              [27.552360534668026, 37.19791793823265],
              [27.55069351196289, 37.19847106933622],
              [27.55013656616211, 37.202640533447436],
            ],
          ],
          [
            [
              [27.55013656616211, 37.25374984741211],
              [27.563747406006314, 37.24708175659197],
              [27.563747406006314, 37.24458312988287],
              [27.54874992370617, 37.25069427490263],
              [27.55013656616211, 37.25374984741211],
            ],
          ],
          [
            [
              [27.5598602294923, 37.255138397217024],
              [27.56097221374523, 37.25430679321289],
              [27.56125068664562, 37.25319290161133],
              [27.558750152587947, 37.2540283203125],
              [27.5598602294923, 37.255138397217024],
            ],
          ],
          [
            [
              [27.369581222534407, 37.28291702270508],
              [27.365417480469148, 37.27986145019537],
              [27.36319351196289, 37.28041839599632],
              [27.3665275573735, 37.28486251831055],
              [27.369581222534407, 37.28291702270508],
            ],
          ],
          [
            [
              [28.478357315063647, 37.4941978454591],
              [28.60888862609869, 37.4764137268067],
              [28.615867614746094, 37.3905487060548],
              [28.74400711059576, 37.35529327392578],
              [28.786222457886026, 37.24433517456066],
              [28.928304672241268, 37.20682525634794],
              [29.0329914093017, 37.144401550293196],
              [29.063364028930664, 37.104351043701286],
              [29.05659675598173, 37.07457733154297],
              [29.07584381103527, 37.047645568847656],
              [29.081838607788143, 36.99150466918945],
              [29.19094657897955, 36.88718414306652],
              [29.266778945923136, 36.884883880615234],
              [29.329647064209155, 36.95889282226574],
              [29.33764457702665, 37.040996551513786],
              [29.387758255004826, 37.076091766357536],
              [29.408311843872355, 37.02462768554693],
              [29.39665603637701, 36.950046539306754],
              [29.44611740112333, 36.96438980102539],
              [29.511768341064737, 37.024211883545036],
              [29.546728134155217, 37.027606964111555],
              [29.62462997436529, 36.99750900268566],
              [29.6769447326663, 36.932643890381144],
              [29.6735973358156, 36.87476730346697],
              [29.604988098144702, 36.779148101806754],
              [29.57402038574247, 36.61486434936529],
              [29.32302856445341, 36.4380264282226],
              [29.32847785949724, 36.40187454223644],
              [29.29306030273466, 36.31244659423851],
              [29.262361526489315, 36.3009681701663],
              [29.226249694824276, 36.32875061035173],
              [29.164863586425838, 36.340972900390625],
              [29.13819694519077, 36.35985946655279],
              [29.14541625976608, 36.37819290161144],
              [29.10124969482439, 36.387084960937784],
              [29.102916717529695, 36.40458297729492],
              [29.131526947021882, 36.41569519042997],
              [29.117916107177678, 36.425415039062614],
              [29.133474349975586, 36.42791748046869],
              [29.124860763549805, 36.461528778076456],
              [29.100696563721158, 36.47458267211914],
              [29.125972747802734, 36.496528625488565],
              [29.125694274902344, 36.54236221313499],
              [29.11208534240768, 36.554584503174055],
              [29.09708595275913, 36.54513931274431],
              [29.086250305175838, 36.56513977050804],
              [29.049304962158203, 36.55847167968756],
              [29.053474426269588, 36.53874969482439],
              [29.008472442626953, 36.543472290039176],
              [29.046806335449673, 36.55819320678734],
              [29.02236175537115, 36.58597183227539],
              [29.04013824462936, 36.61986160278332],
              [29.07541656494186, 36.61430740356474],
              [29.07764053344738, 36.6462516784668],
              [29.101804733276367, 36.6409721374514],
              [29.089582443237305, 36.61986160278332],
              [29.115972518920955, 36.62652587890642],
              [29.12208557128946, 36.64736175537132],
              [29.103195190429688, 36.67124938964872],
              [29.054304122924805, 36.68152618408209],
              [29.03319549560547, 36.70791625976557],
              [29.013193130493164, 36.704303741455305],
              [29.020416259765625, 36.715415954589844],
              [28.9959716796875, 36.70819473266613],
              [28.97097206115734, 36.730972290039176],
              [28.964862823486385, 36.72236251831055],
              [28.928750991821346, 36.75513839721697],
              [28.929859161377294, 36.73430633544922],
              [28.894306182861385, 36.7120819091798],
              [28.909305572509766, 36.70541763305687],
              [28.864582061767692, 36.69708251953125],
              [28.869028091431062, 36.67097091674816],
              [28.850971221924055, 36.663471221923885],
              [28.866249084472997, 36.654026031494254],
              [28.85014152526867, 36.64319610595709],
              [28.87041664123541, 36.63347244262695],
              [28.880416870117188, 36.648750305175895],
              [28.906803131103516, 36.639583587646484],
              [28.868473052978516, 36.621807098388615],
              [28.8756942749024, 36.60180664062506],
              [28.845693588256893, 36.58819580078125],
              [28.824306488037166, 36.62569427490263],
              [28.851249694824617, 36.63763809204096],
              [28.830694198608512, 36.63874816894531],
              [28.818195343017635, 36.65930557250982],
              [28.794027328491268, 36.6504173278808],
              [28.806526184082145, 36.669029235840014],
              [28.79013824462885, 36.685974121093864],
              [28.727916717529297, 36.71180725097679],
              [28.67013931274454, 36.69152832031267],
              [28.673749923706396, 36.70597076416027],
              [28.6479167938233, 36.721805572509766],
              [28.632917404174748, 36.69985961914091],
              [28.61791610717779, 36.70347213745117],
              [28.624305725097713, 36.727638244629134],
              [28.60708427429205, 36.733749389648665],
              [28.632917404174748, 36.75485992431658],
              [28.61291694641119, 36.759304046631144],
              [28.630138397216854, 36.78152847290062],
              [28.58763885498047, 36.815418243408374],
              [28.549306869506893, 36.830417633056925],
              [28.54874992370651, 36.81430435180681],
              [28.529029846191747, 36.8070831298831],
              [28.53597259521507, 36.785694122314624],
              [28.489583969116268, 36.79902648925787],
              [28.498193740844897, 36.81791687011747],
              [28.462083816528434, 36.81124877929716],
              [28.45069503784191, 36.84569549560547],
              [28.469306945800895, 36.862361907958984],
              [28.455694198608512, 36.87930679321306],
              [28.432916641235465, 36.8576393127442],
              [28.407360076904354, 36.85402679443354],
              [28.402914047241552, 36.86652755737322],
              [28.379861831665494, 36.847637176513615],
              [28.387916564941406, 36.83514022827171],
              [28.426805496215934, 36.835693359375284],
              [28.398195266723746, 36.78458404541027],
              [28.31125068664545, 36.81708145141613],
              [28.301527023315487, 36.803749084472884],
              [28.314029693603516, 36.794860839843864],
              [28.2859725952153, 36.79042053222679],
              [28.26569366455118, 36.81402587890625],
              [28.31263732910162, 36.81791687011747],
              [28.315416336059684, 36.826805114746094],
              [28.277639389038086, 36.85235977172863],
              [28.25930786132824, 36.84625244140642],
              [28.232915878296012, 36.80430984497082],
              [28.256526947021598, 36.791805267333984],
              [28.249027252197322, 36.7726402282716],
              [28.26791572570812, 36.765972137451286],
              [28.269304275513036, 36.74708175659191],
              [28.291805267334098, 36.74902725219721],
              [28.303472518921353, 36.730140686035384],
              [28.28819465637224, 36.71986007690447],
              [28.26152992248535, 36.7329177856447],
              [28.225694656372298, 36.70236206054699],
              [28.224306106567383, 36.68819427490257],
              [28.163749694824332, 36.684307098388956],
              [28.106250762939396, 36.59208297729492],
              [28.088752746582486, 36.58208465576189],
              [28.06624984741211, 36.59513854980497],
              [28.02541732788086, 36.56097412109398],
              [28.01097106933605, 36.57624816894537],
              [28.01791572570835, 36.56458282470726],
              [27.97874832153326, 36.55374908447294],
              [27.965137481689624, 36.57986068725603],
              [27.97874832153326, 36.58625030517595],
              [27.956249237060604, 36.6012496948245],
              [28.062362670898835, 36.604862213134766],
              [28.095138549804688, 36.6462516784668],
              [28.07208251953125, 36.660415649414176],
              [28.072917938232422, 36.65847396850603],
              [28.0665283203125, 36.64208221435558],
              [28.057083129883267, 36.63541793823265],
              [28.068195343017805, 36.65569305419922],
              [28.052639007568473, 36.657638549804915],
              [28.072359085083065, 36.67541503906273],
              [28.05041694641119, 36.67319488525402],
              [28.04125022888195, 36.69291687011719],
              [28.04041671752941, 36.67402648925781],
              [28.02402687072771, 36.66791534423845],
              [27.963472366333065, 36.684307098388956],
              [28.001527786254883, 36.704303741455305],
              [28.042360305786133, 36.70375061035156],
              [28.061250686645508, 36.72319412231468],
              [28.097919464111328, 36.72680664062494],
              [28.085418701171875, 36.71763992309576],
              [28.099029541015682, 36.70513916015648],
              [28.112640380859318, 36.72819519042969],
              [28.1293048858646, 36.72569274902344],
              [28.0845832824711, 36.7434730529788],
              [28.112361907958928, 36.774581909179915],
              [28.128469467163086, 36.754306793213175],
              [28.133472442627408, 36.757083892822436],
              [28.120138168335018, 36.803199768066634],
              [28.08208274841303, 36.79624938964861],
              [28.078750610351562, 36.775138854980696],
              [28.05125045776373, 36.759582519531364],
              [28.046247482299975, 36.78486251831083],
              [28.014303207397518, 36.75847244262718],
              [27.95597267150879, 36.76097106933594],
              [27.930416107178075, 36.742084503173885],
              [27.91986083984375, 36.754581451416016],
              [27.89458274841303, 36.756805419921875],
              [27.89902877807623, 36.74242782592796],
              [27.89069366455078, 36.74097061157238],
              [27.877639770507926, 36.75791549682623],
              [27.858472824096737, 36.74124908447294],
              [27.816249847412166, 36.7631950378418],
              [27.730693817138615, 36.7631950378418],
              [27.686527252197664, 36.7254180908206],
              [27.696250915527457, 36.71097183227562],
              [27.675970077514762, 36.70041656494146],
              [27.678749084472827, 36.657638549804915],
              [27.573474884033658, 36.68486022949236],
              [27.56125068664562, 36.672359466552905],
              [27.51402854919462, 36.67736053466808],
              [27.47708129882824, 36.64708328247093],
              [27.46847152709961, 36.66152954101574],
              [27.404861450195312, 36.66236114501953],
              [27.40236091613781, 36.680416107177734],
              [27.36291885376005, 36.6845817565918],
              [27.373195648193416, 36.689582824707145],
              [27.36291885376005, 36.709861755371094],
              [27.398193359375, 36.70041656494146],
              [27.42124938964878, 36.713470458984546],
              [27.428195953369084, 36.748470306396655],
              [27.447916030883846, 36.7448616027832],
              [27.464305877685547, 36.76235961914085],
              [27.479585647583463, 36.74986267089872],
              [27.609861373901367, 36.76402664184576],
              [27.640415191650447, 36.8109703063966],
              [27.69680786132824, 36.78513717651367],
              [27.771804809570256, 36.78847122192394],
              [27.827083587646484, 36.81347274780302],
              [28.03291893005371, 36.78763961791998],
              [28.06041717529297, 36.800971984863395],
              [28.065139770507926, 36.82097244262695],
              [28.055973052978914, 36.8337516784668],
              [28.002361297607422, 36.83514022827171],
              [28.029861450195256, 36.83708572387724],
              [28.031248092651424, 36.839027404785384],
              [28.00013923645031, 36.853473663330135],
              [28.05903053283697, 36.87874984741211],
              [28.04041671752941, 36.88430404663103],
              [28.05041694641119, 36.897083282470874],
              [28.014303207397518, 36.9056930541995],
              [28.043750762939453, 36.910137176513956],
              [28.020694732666414, 36.92569351196306],
              [28.099582672119084, 36.94041824340826],
              [28.13903045654297, 36.93458175659191],
              [28.145971298217717, 36.91875076293957],
              [28.159027099609375, 36.926532745361385],
              [28.159582138061523, 36.90791702270525],
              [28.16791725158697, 36.906806945801065],
              [28.17069435119663, 36.93958282470726],
              [28.158193588257177, 36.94541549682623],
              [28.20569419860874, 36.95208358764654],
              [28.200971603393555, 36.96930694580101],
              [28.21597290039108, 36.977359771728516],
              [28.197082519531705, 36.982360839843864],
              [28.215139389038143, 36.98513793945335],
              [28.21569442749052, 36.99874877929699],
              [28.250694274902628, 36.98986053466797],
              [28.2451362609865, 37.003192901611555],
              [28.268194198608683, 37.01652908325218],
              [28.330415725708065, 37.032360076904524],
              [28.322914123535384, 37.05152893066429],
              [28.163749694824332, 37.02847290039068],
              [28.10097312927263, 37.03458404541021],
              [28.115694046020792, 37.01541519165045],
              [28.0998592376709, 37.01180648803722],
              [28.08764076232916, 37.02875137329124],
              [27.97819519043003, 37.03180694580095],
              [27.94597244262701, 37.0159721374514],
              [27.92569351196289, 37.03097152709961],
              [27.843748092651595, 37.018470764160156],
              [27.79958343505865, 36.99486160278349],
              [27.786804199218807, 37.005973815918026],
              [27.781251907348633, 36.99236297607422],
              [27.685140609741325, 37.003471374511946],
              [27.64736175537115, 36.997917175293196],
              [27.636249542236442, 36.97763824462908],
              [27.574026107788086, 36.993751525879134],
              [27.564582824707088, 36.97458267211937],
              [27.518472671508846, 36.99514007568371],
              [27.48291778564493, 36.98625183105486],
              [27.424303054809684, 37.035694122314396],
              [27.41263961792015, 37.01680374145519],
              [27.395971298217887, 37.029304504394474],
              [27.37624931335489, 36.99874877929699],
              [27.382638931274812, 37.026527404785384],
              [27.330974578857422, 37.014583587646484],
              [27.340415954589844, 36.99847412109375],
              [27.300416946411133, 36.9726371765139],
              [27.30402755737299, 36.95735931396496],
              [27.263471603393725, 36.96402740478544],
              [27.25013923645065, 37.03125],
              [27.22541427612316, 37.058471679687784],
              [27.238750457763956, 37.08319473266596],
              [27.293472290039062, 37.110973358154354],
              [27.254583358764705, 37.11152648925798],
              [27.25513839721725, 37.13097381591791],
              [27.264028549194677, 37.120140075683594],
              [27.273471832275504, 37.140693664550724],
              [27.311527252197266, 37.11541748046881],
              [27.32319450378418, 37.159305572509936],
              [27.343193054199332, 37.150138854980696],
              [27.34513854980503, 37.13041687011736],
              [27.364860534668196, 37.15708160400419],
              [27.390417098999478, 37.14485931396496],
              [27.376529693603686, 37.13402938842796],
              [27.386526107788086, 37.120418548583984],
              [27.43041610717779, 37.128471374512],
              [27.470972061157283, 37.08069610595726],
              [27.537361145019645, 37.12874984741222],
              [27.581527709961335, 37.13680648803728],
              [27.57513618469244, 37.13930511474638],
              [27.557081222534237, 37.13347244262701],
              [27.549861907959098, 37.13569259643572],
              [27.56097221374523, 37.15458297729492],
              [27.541528701782454, 37.15402603149437],
              [27.546527862549226, 37.18430709838867],
              [27.526250839233512, 37.194026947021655],
              [27.5548610687257, 37.1929168701173],
              [27.570692062378043, 37.211528778076286],
              [27.593471527099666, 37.19347381591825],
              [27.574583053588867, 37.179027557373104],
              [27.599861145019588, 37.196250915527514],
              [27.610137939453523, 37.18708419799833],
              [27.615137100220124, 37.18847274780268],
              [27.57541847229021, 37.21402740478521],
              [27.612916946411588, 37.27986145019537],
              [27.556804656982422, 37.27763748168951],
              [27.540971755981502, 37.2540283203125],
              [27.552360534668026, 37.24486160278326],
              [27.53486061096197, 37.25152587890642],
              [27.52680587768549, 37.22847366333036],
              [27.51069450378418, 37.22763824462902],
              [27.498750686645508, 37.237361907958984],
              [27.522361755371094, 37.25041580200224],
              [27.518472671508846, 37.27680587768572],
              [27.45430755615274, 37.255416870117244],
              [27.497360229492358, 37.31597137451183],
              [27.47791671752975, 37.34430694580101],
              [27.470693588256893, 37.3193054199221],
              [27.443195343017635, 37.302360534668196],
              [27.411804199218807, 37.3048629760745],
              [27.385414123535156, 37.328193664550724],
              [27.383192062378043, 37.3570823669433],
              [27.413473129272518, 37.383750915527344],
              [27.432638168335302, 37.381248474121094],
              [27.416358947754134, 37.42242813110374],
              [27.444992065429744, 37.505565643310604],
              [27.488868713378963, 37.56693649291992],
              [27.516687393188477, 37.57382965087902],
              [27.698598861694563, 37.49717712402338],
              [27.884967803955192, 37.45704269409197],
              [28.14990234375, 37.47454833984375],
              [28.220544815063704, 37.562210083007926],
              [28.294479370117188, 37.586898803710994],
              [28.478357315063647, 37.4941978454591],
            ],
          ],
        ],
      },
      properties: {
        name: 'Muğla',
        label: {
          lat: 37.17398707403524,
          lng: 28.366775575107923,
        },
      },
      id: 48,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [42.72718811035173, 39.16370010375988],
            [42.76899337768549, 38.94040298461914],
            [42.68435287475603, 38.926906585693416],
            [42.56119918823248, 38.94335556030279],
            [42.4895858764649, 38.9266815185548],
            [42.328445434570426, 38.93886566162132],
            [42.13997268676758, 38.87031555175781],
            [42.139369964599894, 38.824989318847884],
            [42.023853302002124, 38.8231315612793],
            [41.9985084533692, 38.81031799316412],
            [42.00059890747076, 38.785957336426065],
            [42.054039001464844, 38.728683471679744],
            [42.056205749511776, 38.69475173950195],
            [41.940517425537166, 38.61808013916027],
            [41.863296508789006, 38.590469360351506],
            [41.632709503173885, 38.60134506225609],
            [41.57016754150408, 38.58500671386719],
            [41.52218246459961, 38.541912078857706],
            [41.40530395507841, 38.52570343017584],
            [41.381370544433594, 38.54735183715826],
            [41.394565582275334, 38.60486221313488],
            [41.377975463867244, 38.63625335693354],
            [41.279525756835994, 38.705539703369254],
            [41.15648269653349, 38.89936828613304],
            [41.161922454834155, 38.920677185058594],
            [41.274494171142635, 39.02955627441406],
            [41.274139404297046, 39.11057281494152],
            [41.23756408691412, 39.15412902832031],
            [41.204399108886776, 39.16355514526367],
            [41.171733856201286, 39.28934097290062],
            [41.19566345214855, 39.34185791015631],
            [41.255546569824276, 39.369392395019645],
            [41.386318206787394, 39.383571624755916],
            [41.44354248046892, 39.366619110107536],
            [41.53429412841797, 39.32184219360346],
            [41.66228103637701, 39.20041656494152],
            [41.71326828002958, 39.17493057250988],
            [41.82796478271513, 39.161075592041016],
            [42.074256896972656, 39.222366333007926],
            [42.218486785888786, 39.32173919677746],
            [42.22022247314453, 39.34602355957048],
            [42.19287490844732, 39.381523132324276],
            [42.227268218994425, 39.41969680786127],
            [42.32644271850597, 39.459419250488395],
            [42.463413238525675, 39.48609924316412],
            [42.51290893554716, 39.37992477417015],
            [42.62761688232439, 39.27266311645508],
            [42.6687965393067, 39.25415039062523],
            [42.72718811035173, 39.16370010375988],
          ],
        ],
      },
      properties: {
        name: 'Muş',
        label: {
          lat: 39.0081174655341,
          lng: 41.6827298136136,
        },
      },
      id: 49,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [34.856098175048885, 39.36425018310558],
            [34.92192459106457, 39.33542633056652],
            [34.89593505859369, 39.227462768554744],
            [34.99610900878923, 39.140846252441634],
            [35.002208709716854, 39.09674072265625],
            [35.037403106689624, 39.03805160522461],
            [35.00083923339838, 39.010292053222656],
            [34.95324707031256, 38.798259735107706],
            [35.068992614746264, 38.74825668334972],
            [35.070098876953125, 38.613536834716854],
            [35.018016815185604, 38.565429687500114],
            [34.92493057250982, 38.53613662719732],
            [34.906982421875284, 38.490486145019645],
            [34.91961669921892, 38.398212432861555],
            [34.87619018554693, 38.364654541015625],
            [34.79171752929693, 38.35210037231457],
            [34.670738220215014, 38.408721923828125],
            [34.53929519653326, 38.37565231323242],
            [34.458038330078296, 38.399730682373104],
            [34.348003387451286, 38.473419189453125],
            [34.27626037597656, 38.61580276489258],
            [34.219444274902514, 38.65495300292969],
            [34.206523895263615, 38.69076919555664],
            [34.26256942749052, 38.793670654296875],
            [34.30298995971691, 38.81587600708025],
            [34.314521789550895, 38.8675231933596],
            [34.339496612549, 38.88554382324213],
            [34.427967071533146, 38.87595748901384],
            [34.473014831543026, 38.88665008544933],
            [34.475379943847656, 38.917903900146484],
            [34.5208091735841, 38.990596771240234],
            [34.57684707641607, 39.03011703491234],
            [34.56758117675787, 39.0790634155274],
            [34.636188507080135, 39.097076416015625],
            [34.62529754638672, 39.173606872558594],
            [34.69286346435564, 39.22026062011747],
            [34.686729431152514, 39.26987457275385],
            [34.754566192627124, 39.35155868530285],
            [34.72655868530279, 39.36091613769531],
            [34.66175842285173, 39.31775283813499],
            [34.60924911499029, 39.327224731445426],
            [34.61058425903326, 39.380512237549055],
            [34.65660095214861, 39.486606597900504],
            [34.79120254516607, 39.4306373596192],
            [34.7947616577149, 39.38988113403332],
            [34.856098175048885, 39.36425018310558],
          ],
        ],
      },
      properties: {
        name: 'Nevşehir',
        label: {
          lat: 38.705507779097786,
          lng: 34.35791900763074,
        },
      },
      id: 50,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [34.52778244018572, 38.37610244750999],
            [34.670738220215014, 38.408721923828125],
            [34.785182952881144, 38.35391235351574],
            [34.82062530517595, 38.35119628906273],
            [34.90371322631853, 38.37690734863281],
            [34.92252349853521, 38.43228149414068],
            [34.98105621337908, 38.429912567138786],
            [35.06126403808622, 38.28385162353521],
            [35.12228393554699, 38.25902938842785],
            [35.24277496337896, 38.25186920166027],
            [35.27957916259771, 38.22149658203148],
            [35.312156677246264, 38.16281127929699],
            [35.31087112426786, 38.03140640258795],
            [35.26578140258795, 37.959201812744254],
            [35.23033142089861, 37.94804000854492],
            [35.20941543579096, 37.91901397705084],
            [35.218376159668026, 37.84157562255865],
            [35.19812774658203, 37.81408691406273],
            [35.04302597045904, 37.7019309997558],
            [34.87720870971697, 37.710834503173885],
            [34.834575653076456, 37.69160461425781],
            [34.81658554077154, 37.65838241577154],
            [34.85847854614258, 37.57877349853527],
            [34.860763549804744, 37.525032043456974],
            [34.78827667236334, 37.465160369873104],
            [34.78332519531256, 37.39600372314476],
            [34.69614410400396, 37.393993377685774],
            [34.591953277588004, 37.350292205810604],
            [34.50988006591825, 37.34932327270508],
            [34.469276428222656, 37.40861129760742],
            [34.414676666259936, 37.449813842773494],
            [34.384258270263956, 37.45400238037115],
            [34.38123703002924, 37.50630950927746],
            [34.45323562622076, 37.6476287841798],
            [34.453449249267635, 37.69588470458996],
            [34.266948699951456, 37.914951324463004],
            [34.12569427490246, 38.01376342773443],
            [34.14690780639654, 38.05195236206055],
            [34.18675994873075, 38.070056915283146],
            [34.26839065551758, 38.05600738525402],
            [34.32982254028326, 38.13497161865246],
            [34.393146514892635, 38.16622543334961],
            [34.39450073242182, 38.24264526367193],
            [34.36320114135748, 38.2909202575683],
            [34.36829757690447, 38.36765289306652],
            [34.394397735595646, 38.43891906738287],
            [34.52778244018572, 38.37610244750999],
          ],
        ],
      },
      properties: {
        name: 'Niğde',
        label: {
          lat: 38.04699038421605,
          lng: 34.58651434701427,
        },
      },
      id: 51,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [37.171527862549, 41.148193359375114],
            [37.29291534423828, 41.145694732666016],
            [37.293472290039006, 41.12402725219732],
            [37.38791656494158, 41.107360839843864],
            [37.536529541015796, 41.02097320556652],
            [37.60902786254911, 41.048202514648665],
            [37.682640075683594, 41.136806488037166],
            [37.704582214355526, 41.114028930664176],
            [37.786251068115234, 41.11708450317383],
            [37.776805877685604, 41.06208419799816],
            [37.80819320678711, 41.025699615478516],
            [37.8656959533692, 41.01569366455078],
            [37.87819290161133, 40.987361907958984],
            [38.12208175659208, 40.957359313964844],
            [38.00863647460943, 40.748332977295206],
            [38.11658096313505, 40.6118354797365],
            [38.15565490722673, 40.50869369506859],
            [38.02550125122076, 40.41411972045904],
            [37.90161514282255, 40.395137786865234],
            [37.82976531982433, 40.34440231323242],
            [37.750797271728686, 40.3297233581543],
            [37.707328796387, 40.35209655761713],
            [37.60409545898443, 40.555461883545036],
            [37.466255187988565, 40.563144683837834],
            [37.34712219238298, 40.627052307129134],
            [37.31242370605469, 40.627868652343864],
            [37.29387283325201, 40.66733932495134],
            [37.18733215332037, 40.704162597656364],
            [37.078315734863565, 40.68880844116222],
            [36.97516632080095, 40.70256423950207],
            [36.9319686889649, 40.73946380615263],
            [36.851066589355526, 40.75009155273443],
            [36.688777923584155, 40.81615447998041],
            [36.69670104980486, 40.84641647338867],
            [36.82196426391607, 40.87958145141596],
            [36.904468536376896, 40.924163818359546],
            [36.996006011963175, 41.04626083374052],
            [37.15253448486328, 41.11470413208019],
            [37.15065002441423, 41.14789581298845],
            [37.171527862549, 41.148193359375114],
          ],
        ],
      },
      properties: {
        name: 'Ordu',
        label: {
          lat: 40.8511564808087,
          lng: 37.36553181509387,
        },
      },
      id: 52,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [36.327865600585994, 37.348400115966854],
            [36.48894882202154, 37.368858337402344],
            [36.582782745361385, 37.40520477294933],
            [36.65103912353544, 37.32998657226568],
            [36.728641510009936, 37.27605056762695],
            [36.532501220703296, 37.10746383667009],
            [36.442592620849666, 36.95328521728521],
            [36.34716796875006, 36.95531463623047],
            [36.254726409912166, 37.008663177490405],
            [36.04160690307617, 37.025554656982536],
            [36.059387207031534, 37.12387084960949],
            [36.000972747802734, 37.17415237426786],
            [35.87482452392595, 37.121696472168026],
            [35.85282516479492, 37.12870788574219],
            [35.904296875000114, 37.20827102661144],
            [35.881771087646484, 37.241584777832145],
            [35.884262084960994, 37.359619140625114],
            [36.023311614990405, 37.562290191650504],
            [36.15035247802746, 37.635444641113565],
            [36.302368164062614, 37.651248931884936],
            [36.2121200561524, 37.50016021728521],
            [36.24630355834978, 37.37089157104498],
            [36.327865600585994, 37.348400115966854],
          ],
        ],
      },
      properties: {
        name: 'Osmaniye',
        label: {
          lat: 37.29582414769816,
          lng: 36.13284270620848,
        },
      },
      id: 80,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [41.219917297363565, 41.29500198364252],
            [41.24785232543974, 41.25560760498041],
            [41.25561904907232, 41.208522796630916],
            [41.3067703247072, 41.155185699462834],
            [41.36881256103521, 41.11997222900402],
            [41.40925979614258, 41.11717605590832],
            [41.42398071289074, 41.093452453613395],
            [41.41150665283203, 41.06899642944336],
            [41.34373474121088, 41.03704833984375],
            [41.12230682373047, 40.80845260620117],
            [41.046794891357536, 40.76273727416998],
            [40.82793426513683, 40.65369033813488],
            [40.48347854614275, 40.535343170166016],
            [40.47890853881836, 40.628585815429915],
            [40.51181793212896, 40.69040298461914],
            [40.5118942260745, 40.741134643554744],
            [40.46595764160185, 40.871932983398494],
            [40.421428680419865, 40.94190979003906],
            [40.33486175537115, 40.99541473388683],
            [40.3884735107423, 41.02652740478527],
            [40.497917175293026, 41.04124832153326],
            [40.5484733581543, 41.028472900390625],
            [40.720973968505916, 41.08763885498047],
            [40.8031959533692, 41.16263961791992],
            [40.99763870239252, 41.19458389282249],
            [41.06735992431635, 41.22013854980463],
            [41.1529159545899, 41.2826385498048],
            [41.219917297363565, 41.29500198364252],
          ],
        ],
      },
      properties: {
        name: 'Rize',
        label: {
          lat: 40.977836880025194,
          lng: 40.661440446020656,
        },
      },
      id: 53,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [30.36929130554205, 41.17901229858427],
              [30.65263748168951, 41.1290283203125],
              [30.755695343017692, 41.08625030517578],
              [30.97593688964872, 41.072639465332145],
              [31.036275863647518, 41.016273498535156],
              [31.00865745544445, 40.961486816406364],
              [30.906887054443416, 40.897171020507926],
              [30.873615264892862, 40.83534622192383],
              [30.89267539978033, 40.77858734130854],
              [30.987047195434855, 40.719253540039176],
              [30.949708938598803, 40.669773101806584],
              [30.944461822509822, 40.56676101684582],
              [30.9108257293704, 40.5385627746582],
              [30.84126853942871, 40.52185058593744],
              [30.676174163818644, 40.51831817626959],
              [30.59339523315458, 40.44031524658226],
              [30.6464271545413, 40.38548660278343],
              [30.62383460998541, 40.335178375244254],
              [30.378683090210245, 40.402488708496094],
              [30.12273216247587, 40.37049865722662],
              [29.97472190856962, 40.471775054931754],
              [29.928827285766886, 40.558509826660156],
              [29.92487716674833, 40.577526092529354],
              [30.026767730712834, 40.579669952392635],
              [30.24206924438505, 40.6360816955567],
              [30.2994384765625, 40.75570297241234],
              [30.290256500244197, 40.82116317749035],
              [30.376861572265568, 40.86356735229492],
              [30.36289978027372, 40.95032501220726],
              [30.288484573364315, 41.02032470703148],
              [30.320560455322266, 41.10097122192411],
              [30.375438690185547, 41.1376838684082],
              [30.36929130554205, 41.17901229858427],
            ],
          ],
          [
            [
              [30.36929130554205, 41.17901229858427],
              [30.368911743164062, 41.17930603027355],
              [30.369304656982706, 41.17930603027355],
              [30.36929130554205, 41.17901229858427],
            ],
          ],
        ],
      },
      properties: {
        name: 'Sakarya',
        label: {
          lat: 40.72310687368876,
          lng: 30.347682302007506,
        },
      },
      id: 54,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [37.032897949219034, 41.19848632812523],
              [37.03131103515631, 41.198730468750114],
              [37.03131103515631, 41.19927978515631],
              [37.0333251953125, 41.199096679687784],
              [37.032897949219034, 41.19848632812523],
            ],
          ],
          [
            [
              [37.02709960937506, 41.20068359374994],
              [37.02990722656267, 41.200073242187614],
              [37.03070068359392, 41.19927978515631],
              [37.02911376953119, 41.198913574219034],
              [37.02709960937506, 41.20068359374994],
            ],
          ],
          [
            [
              [36.65551757812517, 41.37872314453131],
              [36.65991210937517, 41.380493164062784],
              [36.66131591796881, 41.37512207031273],
              [36.65832519531244, 41.37512207031273],
              [36.65551757812517, 41.37872314453131],
            ],
          ],
          [
            [
              [36.65551757812517, 41.37872314453131],
              [36.657897949219034, 41.36511230468767],
              [36.66168212890631, 41.36492919921875],
              [36.66271972656244, 41.376892089843864],
              [36.66070556640631, 41.381286621094034],
              [36.86132812500017, 41.34112548828125],
              [36.995727539062784, 41.28411865234381],
              [37.023925781250284, 41.257080078125284],
              [37.017272949219034, 41.21368408203125],
              [37.031921386718864, 41.187500000000284],
              [37.15065002441423, 41.14789581298845],
              [37.15253448486328, 41.11470413208036],
              [37.000690460205135, 41.05016326904308],
              [36.904468536376896, 40.924163818359546],
              [36.82196426391607, 40.87958145141596],
              [36.69670104980486, 40.84641647338867],
              [36.69994354248064, 40.880859375],
              [36.657619476318644, 40.898769378662166],
              [36.453960418701115, 40.8676567077639],
              [36.37617874145525, 40.90769958496105],
              [36.372375488281534, 40.952079772949276],
              [36.23618698120134, 40.981094360351676],
              [36.20392608642584, 40.98003387451172],
              [36.18646621704107, 40.91199111938488],
              [36.16328430175787, 40.89022445678722],
              [36.04716110229509, 40.84297561645508],
              [35.955291748046875, 40.87558364868164],
              [35.840560913085994, 40.86432647705101],
              [35.69504547119146, 40.87898635864286],
              [35.643894195556925, 40.92682647705078],
              [35.47882080078119, 41.01443862915039],
              [35.093154907226506, 41.09054183959961],
              [34.98682022094721, 41.07823944091797],
              [34.96025466918957, 41.113548278808594],
              [34.94060516357439, 41.20204162597656],
              [34.892101287841854, 41.253662109375114],
              [34.93707275390631, 41.307632446289176],
              [35.112976074219034, 41.37586212158209],
              [35.23078155517584, 41.26348114013689],
              [35.33028793334972, 41.249080657959155],
              [35.3814315795899, 41.26378631591808],
              [35.42044830322294, 41.29426193237305],
              [35.45225524902355, 41.357505798339844],
              [35.41756439209013, 41.469825744628906],
              [35.485122680664006, 41.586826324462834],
              [35.498935699463175, 41.6419563293457],
              [35.56549072265631, 41.63128662109381],
              [35.653686523437784, 41.640686035156534],
              [35.95367431640631, 41.735290527344034],
              [36.05609130859381, 41.6875],
              [36.11511230468744, 41.62567138671875],
              [36.132080078125284, 41.46130371093756],
              [36.241516113281364, 41.353515625],
              [36.35571289062506, 41.310485839843864],
              [36.341308593750284, 41.3118896484375],
              [36.3375244140625, 41.294128417968864],
              [36.381896972656364, 41.27270507812506],
              [36.386474609375114, 41.25512695312506],
              [36.439880371093864, 41.244506835937614],
              [36.51470947265619, 41.25952148437523],
              [36.567504882812784, 41.28790283203125],
              [36.620727539062784, 41.36749267578148],
              [36.65551757812517, 41.37872314453131],
            ],
          ],
        ],
      },
      properties: {
        name: 'Samsun',
        label: {
          lat: 41.2332179829929,
          lng: 35.74112483852642,
        },
      },
      id: 55,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [39.26585769653326, 37.998172760009766],
            [39.44062423706066, 37.9846305847168],
            [39.66156768798834, 37.84016799926769],
            [39.76156616210966, 37.83341598510742],
            [39.85432052612316, 37.7578582763673],
            [39.86167144775402, 37.60364151000982],
            [39.88358306884771, 37.52904891967796],
            [40.11487960815458, 37.130916595458984],
            [40.134674072265625, 37.01825714111328],
            [40.1816139221192, 36.94679260253912],
            [40.25516510009794, 36.916130065918026],
            [39.84182739257824, 36.75532150268549],
            [39.22734832763672, 36.664997100830135],
            [39.020233154297046, 36.703311920166016],
            [38.73147201538097, 36.70748519897461],
            [38.56340026855469, 36.83882522583019],
            [38.39853668212902, 36.89716339111328],
            [38.1943435668947, 36.90692138671875],
            [38.010631561279354, 36.825210571289176],
            [38.01078796386747, 36.936237335205305],
            [37.880939483642635, 37.057415008545036],
            [37.834709167480526, 37.19113159179693],
            [37.83034515380871, 37.24394226074219],
            [37.84837341308611, 37.312484741210994],
            [37.93680572509794, 37.40411758422874],
            [38.00278091430681, 37.44073867797874],
            [38.16900634765642, 37.407279968261776],
            [38.330547332763786, 37.48437881469732],
            [38.47832489013666, 37.48891067504883],
            [38.615886688232536, 37.57777023315424],
            [38.82369232177746, 37.639743804931754],
            [38.83985519409174, 37.658622741699276],
            [38.83071136474615, 37.69311904907238],
            [38.95743942260748, 37.7553596496582],
            [38.97814941406256, 37.795402526855696],
            [38.97775268554693, 37.890113830566406],
            [39.05976867675787, 37.98223876953125],
            [39.17874908447283, 38.030654907226676],
            [39.26585769653326, 37.998172760009766],
          ],
        ],
      },
      properties: {
        name: 'Şanlıurfa',
        label: {
          lat: 37.26607482940797,
          lng: 38.70330819018241,
        },
      },
      id: 63,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [42.39585113525408, 38.132087707519645],
            [42.49808883666998, 38.109996795654354],
            [42.72762680053711, 38.01245117187523],
            [42.8357009887697, 38.06550598144537],
            [42.9546012878418, 38.05150604248064],
            [42.98358917236334, 38.02978134155285],
            [43.03906250000006, 37.9368133544923],
            [42.98860931396513, 37.854892730713004],
            [42.98530578613287, 37.80927276611345],
            [42.76489257812494, 37.8343200683596],
            [42.680290222168026, 37.877780914306754],
            [42.60340881347656, 37.878520965576286],
            [42.493461608887, 37.83566284179693],
            [42.41053771972673, 37.74816131591808],
            [42.326351165771655, 37.69716262817377],
            [42.15908813476591, 37.68182373046875],
            [41.968589782714844, 37.69533538818388],
            [41.888881683349666, 37.72859573364269],
            [41.856918334960994, 37.763187408447266],
            [41.754611968994254, 37.74295043945335],
            [41.70092010498058, 37.77768707275396],
            [41.73792648315447, 37.8255729675293],
            [41.73163986206072, 37.85505676269531],
            [41.51866149902361, 37.85847473144531],
            [41.45145416259794, 37.88371658325195],
            [41.41131591796875, 37.918457031250114],
            [41.432540893554744, 37.95641326904308],
            [41.480823516845874, 37.986244201660156],
            [41.48127746582048, 38.02124786376959],
            [41.60668945312506, 38.038478851318416],
            [41.6461448669433, 38.102352142333984],
            [41.67486572265625, 38.19519042968773],
            [41.91657638549833, 38.148315429687614],
            [41.97900390625006, 38.15625381469738],
            [42.025947570801065, 38.12945938110357],
            [42.095233917236385, 38.20076751708996],
            [42.20790863037138, 38.21693801879883],
            [42.26993179321295, 38.20078659057623],
            [42.39585113525408, 38.132087707519645],
          ],
        ],
      },
      properties: {
        name: 'Siirt',
        label: {
          lat: 38.00085157273002,
          lng: 42.08066286631134,
        },
      },
      id: 56,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [34.945415496826456, 42.09791564941406],
            [35.01625061035185, 42.09319305419922],
            [35.05180740356457, 42.059860229492415],
            [35.04375076293951, 42.04180526733404],
            [35.077640533447436, 42.02680587768566],
            [35.19319534301752, 42.040138244628906],
            [35.206527709960994, 42.01263809204124],
            [35.14097213745134, 42.02347183227539],
            [35.09569549560564, 41.96569442749029],
            [35.09013748168951, 41.92180633544933],
            [35.12958145141607, 41.85874938964844],
            [35.20735931396496, 41.80263900756859],
            [35.19347381591825, 41.79208374023443],
            [35.20819473266607, 41.76736068725609],
            [35.264862060547046, 41.73819351196295],
            [35.27597045898443, 41.71597290039068],
            [35.414306640625114, 41.68375015258789],
            [35.498935699463175, 41.6419563293457],
            [35.485122680664006, 41.586826324462834],
            [35.41756439209013, 41.469825744628906],
            [35.4532356262207, 41.362899780273665],
            [35.40052795410162, 41.27267456054693],
            [35.33028793334972, 41.249080657959155],
            [35.23078155517584, 41.26348114013689],
            [35.112976074219034, 41.37586212158209],
            [34.93707275390631, 41.307632446289176],
            [34.8448562622072, 41.19581222534174],
            [34.521492004394815, 41.27654266357433],
            [34.47560119628923, 41.30388641357422],
            [34.46514892578131, 41.540878295898494],
            [34.56705856323259, 41.59246063232422],
            [34.59622573852556, 41.63491439819336],
            [34.59929656982433, 41.668979644775504],
            [34.4930953979495, 41.72483825683594],
            [34.269077301025675, 41.739074707031364],
            [34.26716613769537, 41.805038452148665],
            [34.225559234619425, 41.87401580810547],
            [34.22653198242193, 41.95513916015648],
            [34.30986022949236, 41.94097137451189],
            [34.490695953369425, 41.976806640625],
            [34.50791549682634, 41.958194732666016],
            [34.61791610717802, 41.94208145141624],
            [34.79819488525396, 41.954582214355526],
            [34.90763854980469, 42.02402877807617],
            [34.94902801513672, 42.07374954223661],
            [34.945415496826456, 42.09791564941406],
          ],
        ],
      },
      properties: {
        name: 'Sinop',
        label: {
          lat: 41.65005853459486,
          lng: 34.781536728473595,
        },
      },
      id: 57,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [42.772178649902514, 37.83314132690458],
            [42.98530578613287, 37.80927276611345],
            [43.0542106628418, 37.7635955810548],
            [43.15652084350597, 37.761554718017805],
            [43.317729949951456, 37.727920532226676],
            [43.49570465087896, 37.72740173339838],
            [43.436573028564396, 37.52254486083979],
            [43.4347877502442, 37.349205017089844],
            [43.5009841918947, 37.26836013793957],
            [43.3700408935548, 37.328636169433594],
            [43.325466156005916, 37.30364227294922],
            [43.16740417480486, 37.37397766113281],
            [43.03809738159208, 37.35547637939453],
            [42.973693847656364, 37.316524505615234],
            [42.849826812744425, 37.34685897827154],
            [42.83127975463873, 37.37160110473633],
            [42.79906082153326, 37.377475738525675],
            [42.730808258056925, 37.34506225585943],
            [42.74326705932617, 37.31804275512695],
            [42.69933319091814, 37.30542755126959],
            [42.700664520263786, 37.285415649414176],
            [42.66455459594732, 37.26198577880888],
            [42.59164810180681, 37.147251129150504],
            [42.53633880615246, 37.14884567260742],
            [42.36370849609381, 37.10926055908203],
            [42.33525466918974, 37.18570327758795],
            [42.35742187500006, 37.22752761840832],
            [42.294952392578296, 37.28092956542969],
            [42.22082901000971, 37.277477264404354],
            [42.232196807861385, 37.317359924316406],
            [42.05733108520536, 37.18888092041021],
            [41.8692359924317, 37.13902282714844],
            [41.887989044189396, 37.209285736083984],
            [41.857463836670206, 37.301559448242244],
            [41.779117584228686, 37.2880554199221],
            [41.75320816040039, 37.301284790039176],
            [41.73899078369158, 37.33707046508789],
            [41.74073028564459, 37.468338012695426],
            [41.90201187133795, 37.49835586547857],
            [41.94921875000006, 37.52552032470726],
            [41.93354797363281, 37.585899353027344],
            [41.95733642578125, 37.63766860961914],
            [41.888881683349666, 37.72859573364269],
            [42.02056884765631, 37.68241500854498],
            [42.31177520751953, 37.69374847412132],
            [42.41053771972673, 37.74816131591808],
            [42.493461608887, 37.83566284179693],
            [42.59617996215849, 37.87704849243164],
            [42.680290222168026, 37.877780914306754],
            [42.772178649902514, 37.83314132690458],
          ],
        ],
      },
      properties: {
        name: 'Şırnak',
        label: {
          lat: 37.53562694236572,
          lng: 42.4282409717507,
        },
      },
      id: 73,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [38.22033691406256, 40.3379364013673],
            [38.24710083007824, 40.20339965820318],
            [38.31576156616228, 40.15777206420904],
            [38.452972412109375, 40.09781646728527],
            [38.57074737548834, 40.116062164306584],
            [38.77371978759777, 40.04879760742199],
            [38.75243377685564, 39.97180938720703],
            [38.72418212890619, 39.956573486328125],
            [38.447406768798885, 39.96938323974615],
            [38.41403198242216, 39.944557189941406],
            [38.36586761474615, 39.858364105224894],
            [38.384220123291186, 39.82737731933605],
            [38.52223587036144, 39.84823226928722],
            [38.554382324219034, 39.826526641845646],
            [38.52255249023466, 39.797157287597884],
            [38.445766448974894, 39.78325271606445],
            [38.43944168090826, 39.75685119628906],
            [38.413822174072266, 39.746189117431754],
            [38.364730834960994, 39.677970886230526],
            [38.34907150268583, 39.5365562438966],
            [38.39641189575195, 39.41117095947277],
            [38.389953613281364, 39.18740081787115],
            [38.35454559326172, 39.13976669311529],
            [38.27381896972685, 39.12646484375],
            [38.181423187256144, 39.07257843017584],
            [37.93951416015625, 39.059078216552734],
            [37.780391693115234, 39.001106262207315],
            [37.58811187744152, 39.00992202758795],
            [37.55189514160185, 38.95935440063499],
            [37.5527420043947, 38.92592239379883],
            [37.596317291259936, 38.836570739746264],
            [37.57392501831083, 38.7763786315918],
            [37.32717132568365, 38.60868072509771],
            [37.05988693237333, 38.578189849853516],
            [36.99398040771513, 38.61465454101574],
            [36.92048263549833, 38.62846374511719],
            [36.7323379516601, 38.591064453125],
            [36.758411407470874, 38.674396514892805],
            [36.944854736328296, 39.05715942382824],
            [36.91714477539091, 39.10745239257818],
            [36.87818527221697, 39.1377525329591],
            [36.77732849121122, 39.175086975097656],
            [36.61505126953125, 39.17627334594738],
            [36.45937347412138, 39.1303596496582],
            [36.37403869628912, 39.15341186523443],
            [36.30744171142578, 39.130260467529524],
            [36.057857513427905, 39.1307830810548],
            [35.96096420288103, 39.18781661987305],
            [35.885440826416016, 39.27633666992216],
            [35.81264877319347, 39.29944610595703],
            [35.838054656982706, 39.337776184081974],
            [35.97855758666998, 39.42293548584007],
            [36.06618118286161, 39.50249099731445],
            [36.069194793701286, 39.53652572631859],
            [36.1566696166995, 39.67705154418945],
            [36.12236404418951, 39.69313049316406],
            [36.123931884765796, 39.74603652954096],
            [36.07004928588884, 39.78324508666992],
            [36.047111511230526, 39.85269927978527],
            [35.965507507324276, 39.89990997314453],
            [35.9857711791995, 39.94587326049816],
            [36.11804580688505, 39.94603347778343],
            [36.22705459594732, 39.977584838867244],
            [36.30592727661161, 39.95699310302757],
            [36.442497253418026, 39.949581146240234],
            [36.60661315917997, 39.993495941162166],
            [36.67920684814459, 40.03599548339855],
            [36.7119712829591, 40.0902671813966],
            [36.700984954834155, 40.14154052734375],
            [36.77357864379894, 40.223766326904354],
            [36.96790313720703, 40.18217468261719],
            [37.07748031616211, 40.22293472290039],
            [37.168788909912394, 40.19018936157232],
            [37.43417358398443, 40.153423309326286],
            [37.47169113159208, 40.23818969726574],
            [37.56003570556646, 40.276390075683594],
            [37.55509185791021, 40.31818771362316],
            [37.58262252807623, 40.34762954711914],
            [37.58802795410173, 40.408416748047046],
            [37.6478652954101, 40.45049285888683],
            [37.71109008789068, 40.34790039062494],
            [37.772056579590014, 40.32857894897461],
            [37.82976531982433, 40.34440231323242],
            [37.90161514282255, 40.395137786865234],
            [38.02550125122076, 40.41411972045904],
            [38.15565490722673, 40.50869369506859],
            [38.182529449463004, 40.46619415283203],
            [38.22033691406256, 40.3379364013673],
          ],
        ],
      },
      properties: {
        name: 'Sivas',
        label: {
          lat: 39.57850805189396,
          lng: 37.00726916745568,
        },
      },
      id: 58,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.149583816528548, 41.58051681518566],
            [28.18263816833496, 41.57180404663103],
            [28.199304580688647, 41.54819488525385],
            [28.179122924804744, 41.52955627441423],
            [28.23168945312517, 41.499076843261776],
            [28.15378189086914, 41.24697875976574],
            [28.087570190429744, 41.211147308349666],
            [28.057348251342773, 41.15075302124035],
            [28.123260498046932, 41.0598602294923],
            [28.013750076293945, 41.034305572509766],
            [27.985694885254134, 41.012916564941634],
            [27.987083435058878, 40.99125289917015],
            [27.956806182861555, 40.97680664062517],
            [27.964307785034237, 40.96569442749046],
            [27.87791633605974, 40.96541595459007],
            [27.84069442749052, 40.99236297607433],
            [27.76347160339361, 41.01402664184599],
            [27.511249542236555, 40.97430419921875],
            [27.46263885498064, 40.89569473266624],
            [27.455417633056925, 40.84541702270536],
            [27.34458541870123, 40.76680374145519],
            [27.309305191040153, 40.70236206054693],
            [27.178472518920955, 40.62736129760748],
            [27.029861450195483, 40.59069442749029],
            [27.028583526611442, 40.69945907592779],
            [27.04261207580595, 40.74805068969732],
            [27.020599365234432, 40.79498672485374],
            [26.96979522705078, 40.79952239990246],
            [26.865480422973576, 40.74710464477545],
            [26.82361412048334, 40.74297332763672],
            [26.783828735351562, 40.74620056152344],
            [26.73179054260271, 40.802635192871094],
            [26.730768203735636, 40.902725219726676],
            [26.783018112182617, 40.999576568603516],
            [26.74397468566889, 41.03450775146496],
            [26.748094558715877, 41.07102966308611],
            [26.772720336914176, 41.10102081298851],
            [26.89196395874029, 41.13861846923834],
            [26.937599182129134, 41.18946838378906],
            [26.93860054016136, 41.23728561401373],
            [26.89655685424833, 41.294040679931584],
            [26.898347854614258, 41.34303283691406],
            [26.95331382751459, 41.325469970703296],
            [27.12053489685087, 41.34813308715843],
            [27.262168884277514, 41.34740066528332],
            [27.377403259277344, 41.31006622314476],
            [27.472660064697436, 41.22648620605469],
            [27.520938873291016, 41.22114562988281],
            [27.55360603332548, 41.23656463623047],
            [27.64314651489252, 41.34899902343756],
            [27.673555374145565, 41.40991210937494],
            [27.67464828491228, 41.4577522277832],
            [27.730844497680607, 41.49436187744152],
            [27.770309448242188, 41.50877761840832],
            [27.86650657653837, 41.50082015991211],
            [27.977830886840934, 41.54333114624018],
            [28.149583816528548, 41.58051681518566],
          ],
        ],
      },
      properties: {
        name: 'Tekirdağ',
        label: {
          lat: 41.13364097969743,
          lng: 27.20551936852256,
        },
      },
      id: 59,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [36.69994354248064, 40.880859375],
            [36.68491363525396, 40.826515197753906],
            [36.69797897338873, 40.80878448486328],
            [36.851066589355526, 40.75009155273443],
            [36.9319686889649, 40.73946380615263],
            [36.97164916992199, 40.703620910644474],
            [37.078315734863565, 40.68880844116222],
            [37.18733215332037, 40.704162597656364],
            [37.29387283325201, 40.66733932495134],
            [37.31242370605469, 40.627868652343864],
            [37.34712219238298, 40.627052307129134],
            [37.466255187988565, 40.563144683837834],
            [37.61163711547857, 40.551143646240234],
            [37.6478652954101, 40.45049285888683],
            [37.58802795410173, 40.408416748047046],
            [37.58262252807623, 40.34762954711914],
            [37.55509185791021, 40.31818771362316],
            [37.56003570556646, 40.276390075683594],
            [37.47169113159208, 40.23818969726574],
            [37.43417358398443, 40.153423309326286],
            [37.168788909912394, 40.19018936157232],
            [37.07748031616211, 40.22293472290039],
            [36.96790313720703, 40.18217468261719],
            [36.77357864379894, 40.223766326904354],
            [36.700984954834155, 40.14154052734375],
            [36.71134185791044, 40.08755493164057],
            [36.6641273498538, 40.0172958374024],
            [36.442497253418026, 39.949581146240234],
            [36.30592727661161, 39.95699310302757],
            [36.22705459594732, 39.977584838867244],
            [36.11804580688505, 39.94603347778343],
            [35.9857711791995, 39.94587326049816],
            [35.96333694458019, 39.986537933349894],
            [35.961826324463175, 40.043380737304744],
            [35.936515808105526, 40.07973480224604],
            [35.633205413818644, 40.08720397949219],
            [35.51206970214861, 40.189777374267635],
            [35.529628753662394, 40.235530853271484],
            [35.5763778686524, 40.27421951293945],
            [35.71618652343756, 40.32625579834007],
            [35.84466171264654, 40.501518249511776],
            [35.95844650268555, 40.50232696533209],
            [36.03977584838873, 40.45986938476557],
            [36.15447616577177, 40.44520568847656],
            [36.32520294189459, 40.523677825927734],
            [36.45606231689459, 40.65576934814453],
            [36.47220230102545, 40.7211151123048],
            [36.41676330566412, 40.82258224487305],
            [36.4480056762697, 40.86983108520536],
            [36.49979400634794, 40.86569976806652],
            [36.61869049072283, 40.89941406250023],
            [36.69994354248064, 40.880859375],
          ],
        ],
      },
      properties: {
        name: 'Tokat',
        label: {
          lat: 40.38542225496519,
          lng: 36.3790015856706,
        },
      },
      id: 60,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [39.419582366943416, 41.107639312744254],
            [39.486251831054744, 41.09208297729492],
            [39.565971374511776, 41.02597045898432],
            [39.64041519165056, 40.99986267089844],
            [39.71902847290045, 41.0120849609375],
            [39.78013992309599, 41.002639770507926],
            [39.87347412109381, 40.95402908325195],
            [40.035137176513786, 40.95958328247076],
            [40.12014007568388, 40.9120826721192],
            [40.230693817138615, 40.928470611572266],
            [40.33458328247076, 40.99514007568365],
            [40.36624526977545, 40.98522949218756],
            [40.417865753174, 40.94629287719738],
            [40.46320343017584, 40.876575469970874],
            [40.5118942260745, 40.741134643554744],
            [40.51181793212896, 40.69040298461914],
            [40.47890853881836, 40.628585815429915],
            [40.48347854614275, 40.535343170166016],
            [40.226131439208984, 40.50077056884771],
            [40.09298324584955, 40.512348175048885],
            [40.10813140869169, 40.57054519653332],
            [40.040325164795206, 40.638103485107365],
            [40.004878997802734, 40.65853500366211],
            [39.98151016235357, 40.64609527587896],
            [39.97420120239275, 40.62319564819347],
            [39.99523925781244, 40.5870056152346],
            [39.98057937622076, 40.56537628173828],
            [39.95221710205084, 40.562820434570426],
            [39.89093780517595, 40.61500549316412],
            [39.8285293579101, 40.62057876586914],
            [39.84022521972673, 40.69247055053705],
            [39.80594635009771, 40.71657562255888],
            [39.766292572021655, 40.67451095581066],
            [39.72811889648443, 40.581474304199446],
            [39.67606353759771, 40.55933380126976],
            [39.30743789672857, 40.6691055297851],
            [39.13891601562506, 40.78902816772478],
            [39.1179466247558, 40.853782653808764],
            [39.119213104248104, 40.960250854492244],
            [39.17869949340826, 41.07402801513666],
            [39.284305572509936, 41.0498619079591],
            [39.419582366943416, 41.107639312744254],
          ],
        ],
      },
      properties: {
        name: 'Trabzon',
        label: {
          lat: 40.872660035193384,
          lng: 39.54781281243066,
        },
      },
      id: 61,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [40.271240234375, 39.54582595825195],
            [40.54322814941406, 39.54778289794922],
            [40.51652145385748, 39.5039901733399],
            [40.33533477783203, 39.427463531494254],
            [40.390830993652344, 39.382858276367244],
            [40.33251953125, 39.351543426513786],
            [40.20206451416021, 39.28889083862305],
            [40.098674774170206, 39.31428146362305],
            [40.0318336486817, 39.204952239990234],
            [40.04388046264654, 39.15027236938482],
            [40.029830932617244, 39.115364074707145],
            [40.0097732543947, 39.089889526367244],
            [39.9225807189942, 39.08842849731445],
            [39.869342803955135, 39.04762649536133],
            [39.89322280883795, 38.99279022216797],
            [39.891315460205135, 38.9417343139649],
            [39.8397102355957, 38.86560821533226],
            [39.77879714965832, 38.81803894042969],
            [39.63027191162115, 38.80181884765625],
            [39.49058151245123, 38.749164581299055],
            [39.048492431640625, 38.89308929443382],
            [38.9420242309572, 38.893768310546875],
            [38.84452056884794, 38.871868133545036],
            [38.769435882568644, 38.89875411987316],
            [38.78187942504877, 38.99327850341808],
            [38.72687530517595, 39.115749359130916],
            [38.77346038818365, 39.182136535644474],
            [38.89364624023443, 39.21349716186535],
            [38.92637634277344, 39.25006484985357],
            [38.833896636963004, 39.257617950439624],
            [38.79290771484375, 39.27995681762701],
            [38.8339462280274, 39.32938766479515],
            [38.96605682373064, 39.37565994262695],
            [39.097686767578296, 39.46172332763683],
            [39.32331466674816, 39.499732971191406],
            [39.477455139160156, 39.4769744873048],
            [39.596000671387, 39.48797607421898],
            [39.61517333984381, 39.445877075195426],
            [39.66516876220709, 39.441463470458984],
            [39.69773864746111, 39.45171737670927],
            [39.77057266235357, 39.51818084716808],
            [39.85518646240246, 39.54473114013672],
            [39.88587951660162, 39.54994583129911],
            [39.986354827881144, 39.51869201660179],
            [40.12992477416998, 39.556602478027344],
            [40.271240234375, 39.54582595825195],
          ],
        ],
      },
      properties: {
        name: 'Tunceli',
        label: {
          lat: 39.20518604519161,
          lng: 39.16491227619129,
        },
      },
      id: 62,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.89272689819353, 38.77788162231445],
            [29.894367218017862, 38.70968246459984],
            [29.87275886535673, 38.64421844482433],
            [29.77183532714872, 38.50595855712919],
            [29.755413055419922, 38.45410919189453],
            [29.673618316650447, 38.418857574463004],
            [29.64810752868658, 38.34411239624035],
            [29.594125747680607, 38.27232742309593],
            [29.57591819763178, 38.19177246093756],
            [29.54411315917963, 38.19533920288097],
            [29.42590332031267, 38.26173400878912],
            [29.22126007080078, 38.195537567138956],
            [29.096721649170036, 38.2179908752442],
            [28.92095375061041, 38.265453338623104],
            [28.82542800903326, 38.355316162109375],
            [28.85549926757841, 38.388626098632926],
            [28.8410701751709, 38.52633666992199],
            [28.848800659179744, 38.580696105957145],
            [28.87877845764166, 38.637416839599666],
            [29.022827148437443, 38.725307464599666],
            [29.090955734253157, 38.739379882812614],
            [29.23378944397001, 38.73334121704124],
            [29.305118560791072, 38.78231811523449],
            [29.668746948242244, 38.88996887207031],
            [29.862709045410213, 38.855148315429744],
            [29.89272689819353, 38.77788162231445],
          ],
        ],
      },
      properties: {
        name: 'Uşak',
        label: {
          lat: 38.583168408857915,
          lng: 29.256944832577993,
        },
      },
      id: 64,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [43.34183883666992, 39.39789199829113],
            [43.42657852172857, 39.38888549804682],
            [43.48865509033209, 39.330860137939624],
            [43.58568572998064, 39.28785705566406],
            [43.64554214477545, 39.302429199218864],
            [43.716354370117244, 39.37020492553734],
            [43.96207427978521, 39.35651016235363],
            [44.03281784057617, 39.37202072143555],
            [44.08853530883806, 39.32948303222679],
            [44.08794021606445, 39.29744338989258],
            [44.1117019653322, 39.286445617676065],
            [44.0981178283692, 39.254219055175895],
            [44.1150856018067, 39.23867416381847],
            [44.11330413818365, 39.20209503173834],
            [44.218376159668026, 39.138637542724666],
            [44.23231124877924, 39.10028457641607],
            [44.18688583374052, 39.116287231445426],
            [44.152053833007926, 39.09199905395519],
            [44.20054244995123, 39.06901168823248],
            [44.2188453674317, 39.028751373291016],
            [44.18151473999029, 38.99415969848627],
            [44.224102020263956, 38.891876220703125],
            [44.25598144531256, 38.855079650878906],
            [44.29030227661127, 38.85530471801752],
            [44.31613159179716, 38.83385848999046],
            [44.31856536865246, 38.80030059814453],
            [44.27720260620117, 38.71603012084972],
            [44.30116653442377, 38.67173767089844],
            [44.285503387451456, 38.64738845825224],
            [44.33678436279314, 38.62283706665039],
            [44.32693099975586, 38.5501136779788],
            [44.33952713012695, 38.50283050537132],
            [44.31733322143566, 38.44160842895502],
            [44.31766128540045, 38.38542556762701],
            [44.38671112060541, 38.363548278808764],
            [44.45695495605486, 38.38514709472679],
            [44.501117706299, 38.353702545166016],
            [44.509529113769815, 38.32789230346691],
            [44.42692565917997, 38.27817535400396],
            [44.40821456909197, 38.25121688842785],
            [44.41706848144548, 38.210250854492415],
            [44.404792785644815, 38.14494705200201],
            [44.36408615112333, 38.12714767456055],
            [44.37923431396513, 38.097625732421875],
            [44.352626800537394, 38.09918594360363],
            [44.32249832153349, 38.069694519043026],
            [44.31347274780279, 38.029933929443416],
            [44.25692749023443, 37.95954132080078],
            [44.26597976684576, 37.93852996826183],
            [44.23886108398466, 37.88711547851568],
            [44.27629089355469, 37.86631774902344],
            [44.33904266357422, 37.87405776977545],
            [44.416442871094034, 37.85408401489269],
            [44.413669586181925, 37.82162857055687],
            [44.44305038452177, 37.79836654663109],
            [44.47020721435558, 37.797904968261776],
            [44.46298980712919, 37.768390655517635],
            [44.57461929321295, 37.767143249511776],
            [44.479644775390796, 37.67538070678722],
            [44.42198181152372, 37.646568298339844],
            [44.32952880859392, 37.65622329711914],
            [44.237655639648494, 37.62777709960949],
            [44.21875, 37.64314651489269],
            [44.24557495117182, 37.708969116210994],
            [44.22552108764654, 37.75441741943365],
            [44.20137023925798, 37.76893234252947],
            [44.0651931762697, 37.71755218505865],
            [43.96967315673834, 37.7267951965332],
            [43.892715454101506, 37.700431823730526],
            [43.78456878662104, 37.726203918457145],
            [43.67584609985357, 37.715328216552734],
            [43.317729949951456, 37.727920532226676],
            [43.15652084350597, 37.761554718017805],
            [43.04656219482433, 37.765319824218864],
            [42.98530578613287, 37.80927276611345],
            [42.98860931396513, 37.854892730713004],
            [43.03906250000006, 37.9368133544923],
            [42.98358917236334, 38.02978134155285],
            [42.9546012878418, 38.05150604248064],
            [42.8357009887697, 38.06550598144537],
            [42.777313232421875, 38.127155303955135],
            [42.79895782470709, 38.16839981079107],
            [42.75567626953131, 38.175254821777344],
            [42.720058441162166, 38.20351028442394],
            [42.739238739013615, 38.277294158935774],
            [42.68788528442394, 38.39511108398449],
            [42.69043731689459, 38.42795944213873],
            [42.72961044311529, 38.45822143554693],
            [42.8891716003418, 38.52491760253906],
            [42.9462432861331, 38.614349365234375],
            [42.964450836181754, 38.61788177490246],
            [43.056091308593864, 38.72330474853521],
            [43.17415237426775, 38.79370498657221],
            [43.196823120117244, 38.828151702880916],
            [43.197910308838004, 38.8801727294923],
            [43.12784957885748, 38.93337631225586],
            [43.00352096557623, 38.99146652221691],
            [43.02248382568365, 39.09549331665056],
            [43.144695281982536, 39.13629150390631],
            [43.16763305664068, 39.16597366333019],
            [43.165607452392635, 39.23989868164074],
            [43.08466720581049, 39.284191131592024],
            [43.07938003540056, 39.30751419067394],
            [43.10197830200224, 39.32246017456055],
            [43.19167327880865, 39.32806777954107],
            [43.290340423583984, 39.401798248291016],
            [43.34183883666992, 39.39789199829113],
          ],
        ],
      },
      properties: {
        name: 'Van',
        label: {
          lat: 38.39607741786177,
          lng: 43.495597055500255,
        },
      },
      id: 65,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.394861221313647, 40.70208358764654],
            [29.442625045776538, 40.69208145141596],
            [29.43100166320812, 40.560283660888615],
            [29.362733840942667, 40.580024719238224],
            [29.26760673522955, 40.55602264404297],
            [29.045017242431754, 40.559192657470874],
            [29.010364532470874, 40.497295379638786],
            [29.03236198425293, 40.47847366333008],
            [28.97513961792015, 40.45569610595703],
            [28.883195877075252, 40.47874832153343],
            [28.85375022888212, 40.50597381591808],
            [28.780139923095874, 40.51847076416033],
            [28.79319381713873, 40.55236053466808],
            [28.931528091430835, 40.6004180908206],
            [28.991249084472884, 40.644584655761776],
            [29.282085418701286, 40.6601371765139],
            [29.394861221313647, 40.70208358764654],
          ],
        ],
      },
      properties: {
        name: 'Yalova',
        label: {
          lat: 40.6056560650661,
          lng: 28.919151328754733,
        },
      },
      id: 77,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [35.343200683594034, 40.21666336059576],
            [35.38194656372076, 40.19127655029308],
            [35.51206970214861, 40.189777374267635],
            [35.633205413818644, 40.08720397949219],
            [35.936515808105526, 40.07973480224604],
            [35.961826324463175, 40.043380737304744],
            [35.96333694458019, 39.986537933349894],
            [35.9857711791995, 39.94587326049816],
            [35.965507507324276, 39.89990997314453],
            [36.047111511230526, 39.85269927978527],
            [36.07004928588884, 39.78324508666992],
            [36.123931884765796, 39.74603652954096],
            [36.12236404418951, 39.69313049316406],
            [36.1566696166995, 39.67705154418945],
            [36.069194793701286, 39.53652572631859],
            [36.06618118286161, 39.50249099731445],
            [35.97855758666998, 39.42293548584007],
            [35.838054656982706, 39.337776184081974],
            [35.80165863037115, 39.287456512451286],
            [35.723690032959155, 39.22582626342796],
            [35.67081451416021, 39.20149993896507],
            [35.55098342895536, 39.202976226806754],
            [35.47180557250988, 39.18677139282238],
            [35.463966369628906, 39.156749725341854],
            [35.482967376709155, 39.099575042724666],
            [35.2412185668947, 39.00565338134777],
            [35.037403106689624, 39.03805160522461],
            [35.002208709716854, 39.09674072265625],
            [34.99610900878923, 39.140846252441634],
            [34.89593505859369, 39.227462768554744],
            [34.9202499389649, 39.33756637573248],
            [34.796630859375, 39.38809204101574],
            [34.79120254516607, 39.4306373596192],
            [34.62562561035185, 39.49412536621105],
            [34.53654098510759, 39.54788589477539],
            [34.52186584472685, 39.57050704956066],
            [34.544994354248104, 39.622127532958984],
            [34.468528747558764, 39.67209625244152],
            [34.42567825317377, 39.73305511474615],
            [34.35737991333036, 39.74853515625023],
            [34.234619140625284, 39.73669052124018],
            [34.06889724731451, 39.80836868286144],
            [34.05434417724615, 39.90491104125988],
            [34.08631896972673, 39.9203529357913],
            [34.27889251709013, 39.93708801269531],
            [34.394672393798885, 39.99183654785156],
            [34.80086135864252, 39.993850708007926],
            [34.90447235107433, 40.04970169067383],
            [35.05699539184599, 40.02979278564453],
            [35.17874526977556, 40.090763092041016],
            [35.16777420043957, 40.2132301330567],
            [35.288646697998104, 40.213741302490234],
            [35.33233642578119, 40.228908538818416],
            [35.343200683594034, 40.21666336059576],
          ],
        ],
      },
      properties: {
        name: 'Yozgat',
        label: {
          lat: 39.70452377933144,
          lng: 34.933033196783406,
        },
      },
      id: 66,
      type: 'Feature',
    },
    {
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [32.02097702026373, 41.56291580200201],
            [32.0411911010745, 41.523483276367244],
            [32.30512619018572, 41.306194305420036],
            [32.35403823852545, 41.23849105834972],
            [32.29877471923834, 41.23664093017601],
            [32.13407135009794, 41.15750503540039],
            [32.09339904785162, 41.076122283935604],
            [32.09199523925798, 41.01836776733404],
            [31.43902778625494, 41.05629730224604],
            [31.338193893432674, 41.1367378234865],
            [31.409025192261026, 41.21263885498058],
            [31.402360916137695, 41.271526336670036],
            [31.41736221313488, 41.26319503784197],
            [31.420694351196346, 41.27402877807617],
            [31.391252517700195, 41.2940292358399],
            [31.39986038208002, 41.315971374511776],
            [31.620138168335018, 41.382637023925724],
            [31.74819564819353, 41.43986129760765],
            [31.754304885864315, 41.45513916015625],
            [31.785417556762752, 41.45430374145508],
            [31.89430809020996, 41.523750305175895],
            [32.02097702026373, 41.56291580200201],
          ],
        ],
      },
      properties: {
        name: 'Zonguldak',
        label: {
          lat: 41.29625834712369,
          lng: 31.568290965071377,
        },
      },
      id: 67,
      type: 'Feature',
    },
  ],
};

export default geoJson;
